(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("mobx-react"), require("ca-ui-carbon-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("jquery"), require("react-dom"), require("polyglot"), require("ca-modeller/shaping"), require("explore-common"), require("bi/moser/moser.min"), require("gemini/lib/@waca/dashboard-common/dist/core/APIFactory"), require("gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/View"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "mobx-react", "ca-ui-carbon-toolkit", "mobx-state-tree", "underscore", "prop-types", "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons", "jquery", "react-dom", "polyglot", "ca-modeller/shaping", "explore-common", "bi/moser/moser.min", "gemini/lib/@waca/dashboard-common/dist/core/APIFactory", "gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI", "gemini/lib/@waca/core-client/js/core-client/ui/core/View"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("mobx-react"), require("ca-ui-carbon-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"), require("jquery"), require("react-dom"), require("polyglot"), require("ca-modeller/shaping"), require("explore-common"), require("bi/moser/moser.min"), require("gemini/lib/@waca/dashboard-common/dist/core/APIFactory"), require("gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/View")) : factory(root["react"], root["mobx-react"], root["ca-ui-carbon-toolkit"], root["mobx-state-tree"], root["underscore"], root["prop-types"], root["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"], root["jquery"], root["react-dom"], root["polyglot"], root["ca-modeller/shaping"], root["explore-common"], root["bi/moser/moser.min"], root["gemini/lib/@waca/dashboard-common/dist/core/APIFactory"], root["gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"], root["gemini/lib/@waca/core-client/js/core-client/ui/core/View"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_31__, __WEBPACK_EXTERNAL_MODULE_55__, __WEBPACK_EXTERNAL_MODULE_100__, __WEBPACK_EXTERNAL_MODULE_101__, __WEBPACK_EXTERNAL_MODULE_503__) {
return webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_100__;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_101__;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var BaseStep = function () {
	function BaseStep(options, moduleOptions) {
		_classCallCheck(this, BaseStep);

		this.badgesFeature = moduleOptions.badgesFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.ownerWidget = options.ownerWidget;
		this.logger = options.logger;
		this.visAPI = options.visAPI;
		this.dashboardApi = options.dashboardApi;

		this._initializeStep = this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner._logRenderContext.bind(this.owner);

		if (this.id) {
			this._initializeStep(this.id);
		}
	}

	BaseStep.prototype.getRenderState = function getRenderState() {
		return this.owner._renderState;
	};

	BaseStep.prototype.clearError = function clearError() {
		// todo: no equivalent new api for visHelper;
		this.visAPI.visHelper.clearError();
	};

	BaseStep.prototype.showError = function showError(msg, params) {
		// todo: no equivalent new api for visHelper;
		this.visAPI.visHelper.showError(msg, params);
	};

	return BaseStep;
}();

exports.default = BaseStep;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseSummarizerQuery2 = __webpack_require__(56);

var _BaseSummarizerQuery3 = _interopRequireDefault(_BaseSummarizerQuery2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The FilteredSummaryValueQuery is a single query that updates summaryCollector entries
 * with the single row result of the aggregated summary values with filtering applied
 * for all measures (ordinals) that are projected.
 * Currently this query is only done to compute values for countdistinct.
 * Logic to process exception conditions to avoid querying and update summaries immediately are done
 * NOTE: This query considers selections but does not query for single selections.
 **/
var FilteredSummaryValueQuery = function (_BaseSummarizerQuery) {
	_inherits(FilteredSummaryValueQuery, _BaseSummarizerQuery);

	/**
  * @Constructor
  * @param {Object} widgetApi - the owner widget (needed to access services)
  * @param {Object} dashboardApi - the dashboardApi
  * @param {Object} logger - The logger,
  * @param {Function} [cbGetRowTuples=null] - when this callback is supplied, the rendered data rows are used
  *				where the filter values are "implied" (eg TopN).  This is only needed for summary stats (not selection stats)
  */
	function FilteredSummaryValueQuery(widgetApi, dashboardApi, logger) {
		var cbGetRowTuples = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		_classCallCheck(this, FilteredSummaryValueQuery);

		var _this = _possibleConstructorReturn(this, _BaseSummarizerQuery.call(this, widgetApi, dashboardApi, logger, cbGetRowTuples));

		_this._unprocessedItems = []; //Keep a list of facts that this query couldn't process.
		return _this;
	}

	/**
  * Add an item to the filteredSummaryValue query definition UNLESS
  * 1) it is not a fact or an aggregation type we're interested (currently only countdistinct is processed)
  * 2) if this is a selection with only 1 value, the value is the same as the summary, add it to the collector instead.
  * @param {object} queryDef - the queryDefinition that will be modified with this item if it applies
  * @param {object[]} queryDef.dataItems - simple data item _querySpec
  * @param {String[]} queryDef.projections - the list of projected items (ids same as dataItems list)
  * @param summaryCollector - a summaryCollector (or selectionSummaryCollector) whose entries are to be augmented with the overallSummary values.
 */


	FilteredSummaryValueQuery.prototype.addQueryItem = function addQueryItem(queryDef, mappedDataItem, summaryCollector) {
		if (mappedDataItem.getType() === 'fact' && mappedDataItem.getAggregation() === 'countdistinct') {
			var itemUpdated = false;

			//If we only have 1 value in this selection summary, we don't need to query.
			if (summaryCollector.isSelectionSummaryCollector) {
				var dataItemUniqueId = mappedDataItem.getId();
				var summaryEntry = summaryCollector.getSummary(dataItemUniqueId);
				var summaryEntryValues = summaryEntry && summaryEntry.valueMap && Object.keys(summaryEntry.valueMap);
				if (summaryEntryValues && summaryEntryValues.length === 1) {
					//We know we have exactly 1 value in the valueMap, so assign it and mark the item as updated.
					this.updateSummaryEntry(summaryCollector, dataItemUniqueId, summaryEntry.valueMap[summaryEntryValues[0]], 'filteredSummaryValueUse', 'filteredSummaryValue');
					itemUpdated = true;
				} else if (!summaryEntryValues) {
					//If there are no selections, remove the entry.
					summaryCollector.removeSummary(dataItemUniqueId);
					itemUpdated = true;
				}
			}
			if (!itemUpdated) {
				var dataItemJSON = {
					aggregate: mappedDataItem.getAggregation(),
					itemId: mappedDataItem.getColumnId(),
					id: mappedDataItem.getId()
				};

				queryDef.dataItems.push(dataItemJSON);
				queryDef.projections.push(mappedDataItem.getId());
			}
		} else if (mappedDataItem.getType() === 'fact') {
			this._unprocessedItems.push(mappedDataItem.getAggregation() + mappedDataItem.getColumnId());
		}
	};

	FilteredSummaryValueQuery.prototype.getUnprocessedItems = function getUnprocessedItems() {
		return this._unprocessedItems;
	};

	/**
  * Process the value of an item returned from the query by adding it to the summaryCollector
  * @param {String} dataItemUniqueId - the id of the dataItem.
  * @param {String} aggregate - the aggregation type (eg countdistinct)
  * @param {String} filteredSummaryUseValue - the actual value (to be added as the filteredSummaryUseValue)
  * @param {Object} summaryCollector - the summaryCollector to add the value to.
  */


	FilteredSummaryValueQuery.prototype.processValue = function processValue(dataItemUniqueId, aggregate, filteredSummaryUseValue, summaryCollector) {
		this.updateSummaryEntry(summaryCollector, dataItemUniqueId, filteredSummaryUseValue, 'filteredSummaryValueUse', 'filteredSummaryValue');
	};

	return FilteredSummaryValueQuery;
}(_BaseSummarizerQuery3.default);

exports.default = FilteredSummaryValueQuery;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var _ = __webpack_require__(8); //TODO: should try to remove this dependency

/**
 * The SummaryCollector is used to save statistics based on one or more values for one or more measures.
 * The table it owns is keyed one per measure item.
 **/
var NO_DETAIL_ROWCOUNT = undefined;

var SummaryCollector = function () {
	/**
  * @Constructor
  * @param {Object} WidgetApi
  */
	function SummaryCollector(dashboardApi, widgetApi) {
		var isSelectionSummaryCollector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		_classCallCheck(this, SummaryCollector);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.isSelectionSummaryCollector = isSelectionSummaryCollector;
		this.lastCategorySelection = [];
		this.summaryTable = {};
	}

	/**
  * Return a more 'user-friendly' version of the summary table
  * (keyed on itemId, aggregationType and layerId rather than dataItemUniqueId).
  * This type of key could be used for crude matching in a compare rules processor.
  * (ie same item, aggregation and layer can definitely be compared!)
  * @returns a JSON friendly summaryTable.
  */
	SummaryCollector.prototype.getSummaryTableJSON = function getSummaryTableJSON() {
		var summaryTableJSON = {};
		this.summaryTable = JSON.parse(JSON.stringify(this.summaryTable));

		_.each(this.summaryTable, function (summaryTableEntry, key) {
			var jsonKey = summaryTableEntry.metadata ? summaryTableEntry.metadata.itemId + '_' + summaryTableEntry.metadata.aggregationType + '_' + summaryTableEntry.metadata.layerId : key;
			summaryTableJSON[jsonKey] = summaryTableEntry;

			//Convert valueMap to a values array (use object iteration to preserve selected order).
			if (summaryTableEntry.valueMap) {
				summaryTableEntry.values = [];
				_.each(summaryTableEntry.valueMap, function (value) {
					summaryTableEntry.values.push(value);
				});
			}
		});

		var rtnValue = {
			measures: summaryTableJSON
		};
		if (this.lastCategorySelection.length) {
			//return "formatted value" for null = [no value]
			var Formatter = this.widgetApi.getVisApi() && this.widgetApi.getVisApi().getFormatter();
			if (Formatter) {
				rtnValue.lastCategorySelection = this.lastCategorySelection.map(function (tuplePart) {
					return tuplePart ? tuplePart : Formatter.format(tuplePart);
				});
			} else {
				rtnValue.lastCategorySelection = this.lastCategorySelection;
			}
		}
		return rtnValue;
	};

	SummaryCollector.prototype.setLastCategorySelection = function setLastCategorySelection(lastCategorySelection) {
		this.lastCategorySelection = lastCategorySelection;
	};

	/**
  * Clear out the summaryTable to collect new summaries.
  * @param layerId (optional) - if specified, only entries for a particular layer will be removed.
  */


	SummaryCollector.prototype.reset = function reset() {
		var _this = this;

		var layerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		if (layerId) {
			Object.keys(this.summaryTable).forEach(function (summaryTableKey) {
				var summaryTableEntry = _this.summaryTable[summaryTableKey];
				if (summaryTableEntry.metadata && summaryTableEntry.metadata.layerId === layerId) {
					_this.summaryTable[summaryTableKey] = null;
					delete _this.summaryTable[summaryTableKey];
				}
			});
		} else {
			this.summaryTable = {};
		}
	};

	/**
  * get the summary entry for the passed key (or add a new summaryEntry)
  * @param dataItemUniqueId - the uniqueId of the dataItem is the key of the summaryTable.
  * @returns the new summary entry.
  */


	SummaryCollector.prototype.getSummary = function getSummary(dataItemUniqueId) {
		if (!this.summaryTable[dataItemUniqueId]) {
			this._initializeSummary(dataItemUniqueId);
		}
		return this.summaryTable[dataItemUniqueId];
	};

	SummaryCollector.prototype.removeSummary = function removeSummary(dataItemUniqueId) {
		if (this.summaryTable[dataItemUniqueId]) {
			this.summaryTable[dataItemUniqueId] = null;
			delete this.summaryTable[dataItemUniqueId];
		}
	};

	/**
  * incorporate a single value into the summary
  * @param summaryEntry - the summaryEntry of interest
  * @param value - the value to incorporate
  * @param detailRowCountUse (optional) - if available, the detail rowCount associated with this summary value.
  */


	SummaryCollector.prototype.updateSummary = function updateSummary(summaryEntry, value, detailRowCountUse) {
		var updatedSummaryEntry = this.updateSummaryEntry(summaryEntry);
		if (value === null) {
			// Null indicates a missing value.
			updatedSummaryEntry.missingValueCount = updatedSummaryEntry.missingValueCount === undefined ? 1 : updatedSummaryEntry.missingValueCount + 1;
			return;
		}
		if (updatedSummaryEntry.maxUse === undefined || updatedSummaryEntry.maxUse < value) {
			updatedSummaryEntry.maxUse = value;
		}
		if (updatedSummaryEntry.minUse === undefined || updatedSummaryEntry.minUse > value) {
			updatedSummaryEntry.minUse = value;
		}
		if (value < 0) {
			updatedSummaryEntry.hasNegativeValues = true;
		}
		updatedSummaryEntry.totalUse = updatedSummaryEntry.totalUse === undefined ? value : updatedSummaryEntry.totalUse + value;
		this._updateWeightedAverageFields(updatedSummaryEntry, value, detailRowCountUse);
	};

	/**
  * copies summaryEntry and replaces it in the table with the clone
  * we need to do this because when the vis in explore compare card is updated
  * and retrieve and update entries in summary table, entries are read-only
  * by copying the object we make the object modifiable
  * @param summaryEntry - the summaryEntry of interest
  * @returns summaryEntry
  */


	SummaryCollector.prototype.updateSummaryEntry = function updateSummaryEntry(summaryEntry) {
		var itemUniqueId = summaryEntry.metadata && summaryEntry.metadata.itemUniqueId;
		if (itemUniqueId) {
			var newSummaryEntry = Object.assign({}, summaryEntry);
			this.summaryTable[itemUniqueId] = newSummaryEntry;
			return newSummaryEntry;
		} else {
			return summaryEntry;
		}
	};

	/**
  * This function applies to stacked bar/column and area charts where each entry is Grouped by the first category
  * into a 'stack'.  Regardless of the aggregation type, each stack is the sum of its positive segments and its negative segments. The domain
  * of the chart is the min and max of these sums.
  * @param summaryEntry - the summaryEntry of interest
  * @param segmentValue - the segment value to add to a stack of segments.
  * @param stackId - the stackId (which is the same as the entryIndex of the grouping column) eg: 2004 = 0, 2005 = 1
  */


	SummaryCollector.prototype.updateStackedSummary = function updateStackedSummary(summaryEntry, segmentValue, stackId) {
		summaryEntry.stackedSummaryValueMap = summaryEntry.stackedSummaryValueMap || {};

		var _ref = summaryEntry.stackedSummaryValueMap[stackId] || {},
		    currentPosHeightOfStack = _ref.currentPosHeightOfStack,
		    currentNegHeightOfStack = _ref.currentNegHeightOfStack;

		if (segmentValue >= 0) {
			currentPosHeightOfStack = currentPosHeightOfStack === undefined ? segmentValue : currentPosHeightOfStack + segmentValue;
		} else {
			currentNegHeightOfStack = currentNegHeightOfStack === undefined ? segmentValue : currentNegHeightOfStack + segmentValue;
		}
		summaryEntry.stackedSummaryValueMap[stackId] = {
			currentPosHeightOfStack: currentPosHeightOfStack,
			currentNegHeightOfStack: currentNegHeightOfStack
		};
	};

	/**
  * once all data has been processed, produce a finalized summary (stackedDomainMax and stackedDomainMin for each stack)
  * @param summaryEntry - the entry of interest (eg. Revenue)
  */


	SummaryCollector.prototype.finalizeStackedSummary = function finalizeStackedSummary(summaryEntry) {
		var heightArray = [];
		_.each(summaryEntry.stackedSummaryValueMap, function (stackEntry) {
			if (typeof stackEntry.currentPosHeightOfStack !== 'undefined') {
				heightArray.push(stackEntry.currentPosHeightOfStack);
			}
			if (typeof stackEntry.currentNegHeightOfStack !== 'undefined') {
				heightArray.push(stackEntry.currentNegHeightOfStack);
			}
		});

		summaryEntry.stackedDomainMax = heightArray.length ? Math.max.apply(Math, heightArray) : undefined;
		summaryEntry.stackedDomainMin = heightArray.length ? Math.min.apply(Math, heightArray) : undefined;
		delete summaryEntry.stackedSummaryValueMap;
	};

	/**
  * A selection summary stores a map of tuple to value.  This allows insertion or removal of a value when
  * a tuple is added/removed from the selection.
  * @param summaryEntry - the summaryEntry of interest
  * @param rowSummary - the value to incorporate
  *				.dataItemUniqueId - the item being summarized,
  *				.value: - the value for the selection being incorporated
  *				.detailRowCountUse (optional): rowCount });
 	 * @param tuple - the selected tuple.
  * @param ctrlSelect - (optional) if ctrlSelect is true, an existing entry for a given tuple will be deleted.
  */


	SummaryCollector.prototype.updateSelectionSummary = function updateSelectionSummary(summaryEntry, rowSummary, tuple, ctrlSelect) {
		if (!summaryEntry.valueMap) {
			summaryEntry.valueMap = {};
		}
		if (ctrlSelect && summaryEntry.valueMap[JSON.stringify(tuple)]) {
			delete summaryEntry.valueMap[JSON.stringify(tuple)];
		} else {
			summaryEntry.valueMap[JSON.stringify(tuple)] = rowSummary.value;
			this._updateWeightedAverageFields(summaryEntry, rowSummary.value, rowSummary.detailRowCountUse);
		}
	};

	/**
  * complete calculations that only need to be done once per dataset.
  * @param summaryEntry - the summaryEntry of interest (ie: for a particular measure)
  * @param rowCount - the rowCount (for computing average)
  * @param aggregate - if the aggregate is average, we don't return a total.
  */


	SummaryCollector.prototype.finalizeSummaries = function finalizeSummaries(summaryEntry) {
		var rowCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var aggregate = arguments[2];

		this.updateStackedSummary(summaryEntry);
		this.finalizeStackedSummary(summaryEntry);
		var Formatter = this.widgetApi.getVisApi().getFormatter();
		summaryEntry.rowCount = rowCount - (summaryEntry.missingValueCount || 0);
		if (summaryEntry.rowCount > 0) {
			summaryEntry.avgUse = summaryEntry.totalUse / summaryEntry.rowCount;
		}
		if (summaryEntry.detailSumUse !== undefined && summaryEntry.detailRowCountUse !== undefined) {
			summaryEntry.weightedAvgUse = summaryEntry.detailSumUse / summaryEntry.detailRowCountUse;
		}
		var formatSpec = summaryEntry.metadata && summaryEntry.metadata.format;
		if (Formatter && formatSpec) {
			summaryEntry.min = summaryEntry.minUse !== undefined && Formatter.format(summaryEntry.minUse, formatSpec);
			summaryEntry.max = summaryEntry.maxUse !== undefined && Formatter.format(summaryEntry.maxUse, formatSpec);
			summaryEntry.total = summaryEntry.totalUse !== undefined && Formatter.format(summaryEntry.totalUse, formatSpec);
			summaryEntry.avg = summaryEntry.avgUse !== undefined && Formatter.format(summaryEntry.avgUse, formatSpec);
			if (summaryEntry.weightedAvgUse !== undefined) {
				summaryEntry.weightedAvg = Formatter.format(summaryEntry.weightedAvgUse, formatSpec);
			}
		} else {
			//If no Formatter is supplied, return unformatted results.
			summaryEntry.min = summaryEntry.minUse;
			summaryEntry.max = summaryEntry.maxUse;
			summaryEntry.total = summaryEntry.totalUse;
			summaryEntry.avg = summaryEntry.avgUse;
			if (summaryEntry.weightedAvgUse !== undefined) {
				summaryEntry.weightedAvg = summaryEntry.weightedAvgUse;
			}
		}

		//Cleanup information that explore shouldn't have.
		if (aggregate === 'avg' || aggregate === 'countdistinct') {
			//Don't produce totals for averages or countdistinct.
			delete summaryEntry.totalUse;
			delete summaryEntry.total;
		}
		//TODO: We could potentially remove the formatSpec
	};

	/**
  * Selection helper method that allows a caller to pass selectionInfo to the SummaryCollector
  * and apply the associated values.
  * @param selectionInfo - the selectionInfo object which includes the ordinal selections and values.
  * @param ctrlSelect - a flag that signifies that this is a multiple selection (eg lasso select) and should be treated as a complete selection.
  * @returns true if selectionInfo can be applied.
  */


	SummaryCollector.prototype.applySelectionInfo = function applySelectionInfo(selectionInfo, ctrlSelect) {
		var _this2 = this;

		if (!selectionInfo._aOrdinalSelections || !selectionInfo._aOrdinalSelections.length) {
			return false;
		}
		var tuple = _.map(selectionInfo._aCategorySelections, function (categorySelection) {
			return { u: categorySelection.value.u, d: categorySelection.value.d };
		});
		_.each(selectionInfo._aOrdinalSelections, function (ordinalSelection) {
			var selEntry = _this2.getSummary(ordinalSelection.slotDataItem.getUniqueId());
			_this2.updateSelectionSummary(selEntry, ordinalSelection, tuple, ctrlSelect);
		});

		return true;
	};

	/**
  * Selection helper method that allows a caller to pass selectionInfo for a lassoSelection to the SummaryCollector
  * @param selectionInfo - the selectionInfo for the lasso selection (see details below)
  * @param lassoSelectTupleSize - the number of elements in each point in the lasso selection (eg: 2007:Fax = 2)
  */


	SummaryCollector.prototype.applyLassoSelectionInfo = function applyLassoSelectionInfo(selectionInfo, lassoSelectTupleSize) {
		var _this3 = this;

		//For lasso selections, there are N values per tuple in _aOrdinalSelections as usual (ie: 1 value for each measure).
		//THEN, each additional selection has the values for each corresponding tuple in _aAdditionalOrdinalSelections.
		//The categorical values are all in _aCategorySelections in a flat array lassoSelectTupleSize long.
		//Eg: ['2007', 'Fax', '2008', 'Mail'] and lassoSelectTupleSize of 2 would represent 2 datapoints 2007:Fax, 2008:Mail.
		//Not the greatest structure but complete and that's what is used for all lasso selects in liveWidget.

		//Step1: make a single array of values.
		var allValues = selectionInfo._aOrdinalSelections.concat(selectionInfo._aAdditionalOrdinalSelections);

		//Step2: remove extra information from the categorical part tuple (ie: the parent info to form the proper keys)
		var allTuples = _.map(selectionInfo._aCategorySelections, function (categorySelection) {
			return { u: categorySelection.value.u, d: categorySelection.value.d };
		});

		var tuple = null;
		_.each(allValues, function (thisValue, idx) {
			//whenever we have read all N measures, fetch the next tuple.
			if (idx % selectionInfo._aOrdinalSelections.length === 0) {
				tuple = _.first(allTuples, lassoSelectTupleSize);
				allTuples = _.rest(allTuples, lassoSelectTupleSize);
			}
			var selEntry = _this3.getSummary(thisValue.slotDataItem.getUniqueId());
			_this3.updateSelectionSummary(selEntry, thisValue, tuple);
		});
	};

	/**
  * @returns true if any of the entries in the summaryTable are missing summaryValues (unfiltered measure values)
  */


	SummaryCollector.prototype.areOverallSummaryValuesNeeded = function areOverallSummaryValuesNeeded() {
		return _.find(this.summaryTable, function (summaryTableEntry) {
			return summaryTableEntry.summaryValue === undefined;
		}) ? true : false;
	};

	SummaryCollector.prototype._addMetadata = function _addMetadata(dataItemUniqueId) {
		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var foundMappingInfo = content.getFeature('Visualization').getSlots().getMappingInfo(dataItemUniqueId);

		if (foundMappingInfo) {
			var dataItemAPI = foundMappingInfo.dataItem;
			var slotAPI = foundMappingInfo.slot;
			var aggregationType = dataItemAPI.getAggregation();
			var datasetIdList = slotAPI ? slotAPI.getDefinition().getDatasetIdList() : [];
			var layerId = datasetIdList[0];
			return {
				itemUniqueId: dataItemAPI.getId(),
				itemId: dataItemAPI.getColumnId(),
				label: dataItemAPI.getLabel(),
				aggregationType: aggregationType,
				layerId: layerId,
				format: dataItemAPI.getFormat(),
				slotId: slotAPI.getId()
			};
		}
		return null;
	};

	//If this summary entry includes a detail row count, save it, a sum and the weighted average into the summaryEntry.


	SummaryCollector.prototype._updateWeightedAverageFields = function _updateWeightedAverageFields(summaryEntry, aggregatedValue, detailRowCountUse) {
		if (detailRowCountUse !== NO_DETAIL_ROWCOUNT) {
			var detailSumUse = aggregatedValue * detailRowCountUse;
			summaryEntry.detailSumUse = summaryEntry.detailSumUse === undefined ? detailSumUse : summaryEntry.detailSumUse + detailSumUse;
			summaryEntry.detailRowCountUse = summaryEntry.detailRowCountUse === undefined ? detailRowCountUse : summaryEntry.detailRowCountUse + detailRowCountUse;
			summaryEntry.weightedAvgUse = summaryEntry.detailSumUse / summaryEntry.detailRowCountUse;
		}
	};

	/**
  * add a new summaryItemEntry to the summaryTable.
  * @param itemKey - the key (unique to this measure)
  * @param dataItemUniqueId - the uniqueId of the dataItem.
  * //TODO: this key should be collapsed into one...the dataItemUniqueId OR the itemId, aggregation type and layerId.
  */


	SummaryCollector.prototype._initializeSummary = function _initializeSummary(dataItemUniqueId) {
		this.summaryTable[dataItemUniqueId] = {
			metadata: this._addMetadata(dataItemUniqueId)
		};
	};

	SummaryCollector.prototype.isTupleInSelectionSummary = function isTupleInSelectionSummary(tuple) {
		var _this4 = this;

		var lastTupleKey = void 0;

		if (Array.isArray(tuple)) {
			lastTupleKey = JSON.stringify(tuple);
		} else {
			lastTupleKey = JSON.stringify([tuple]);
		}

		var isInSelectionSummary = Object.keys(this.summaryTable).some(function (summaryTableKey) {
			if (_this4.summaryTable[summaryTableKey].valueMap[lastTupleKey] !== undefined) {
				return true;
			}
		});
		return isInSelectionSummary;
	};

	_createClass(SummaryCollector, null, [{
		key: 'NO_DETAIL_ROWCOUNT',
		get: function get() {
			return NO_DETAIL_ROWCOUNT;
		}
	}]);

	return SummaryCollector;
}();

exports.default = SummaryCollector;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_26__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_31__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(30);
module.exports = __webpack_require__(467);


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ShowByView = exports.ShowByAction = exports.ExploreLayoutPropertiesProvider = exports.VisTitleFetcherFeature = exports.ImageCaptureFeature = exports.SummarizerFeature = exports.CrosshairsFeature = exports.ChartInsights = exports.BadgesFeature = undefined;

var _BadgesFeature = __webpack_require__(468);

var _BadgesFeature2 = _interopRequireDefault(_BadgesFeature);

var _ChartInsights = __webpack_require__(474);

var _ChartInsights2 = _interopRequireDefault(_ChartInsights);

var _CrosshairsFeature = __webpack_require__(479);

var _CrosshairsFeature2 = _interopRequireDefault(_CrosshairsFeature);

var _SummarizerFeature = __webpack_require__(490);

var _SummarizerFeature2 = _interopRequireDefault(_SummarizerFeature);

var _VisImageCaptureFeature = __webpack_require__(495);

var _VisImageCaptureFeature2 = _interopRequireDefault(_VisImageCaptureFeature);

var _VisTitleFetcherFeature = __webpack_require__(497);

var _VisTitleFetcherFeature2 = _interopRequireDefault(_VisTitleFetcherFeature);

var _ExploreLayoutPropertiesProvider = __webpack_require__(99);

var _ExploreLayoutPropertiesProvider2 = _interopRequireDefault(_ExploreLayoutPropertiesProvider);

var _ShowByAction = __webpack_require__(498);

var _ShowByAction2 = _interopRequireDefault(_ShowByAction);

var _ShowByView = __webpack_require__(499);

var _ShowByView2 = _interopRequireDefault(_ShowByView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BadgesFeature = _BadgesFeature2.default;
exports.ChartInsights = _ChartInsights2.default;
exports.CrosshairsFeature = _CrosshairsFeature2.default;
exports.SummarizerFeature = _SummarizerFeature2.default;
exports.ImageCaptureFeature = _VisImageCaptureFeature2.default;
exports.VisTitleFetcherFeature = _VisTitleFetcherFeature2.default;
exports.ExploreLayoutPropertiesProvider = _ExploreLayoutPropertiesProvider2.default;
exports.ShowByAction = _ShowByAction2.default;
exports.ShowByView = _ShowByView2.default; /*
                                            *+------------------------------------------------------------------------+
                                            *| Licensed Materials - Property of IBM
                                            *| IBM Cognos Products: Explore
                                            *| (C) Copyright IBM Corp. 2018, 2019
                                            *|
                                            *| US Government Users Restricted Rights - Use, duplication or disclosure
                                            *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                            *+------------------------------------------------------------------------+
                                            */

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _GetBadgesInfo = __webpack_require__(469);

var _GetBadgesInfo2 = _interopRequireDefault(_GetBadgesInfo);

var _RenderBadgesInfo = __webpack_require__(470);

var _RenderBadgesInfo2 = _interopRequireDefault(_RenderBadgesInfo);

var _StringResources = __webpack_require__(471);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Deferred = __webpack_require__(473);

var MAX_DRIVERS_PER_COLUMN = 5;
//Temporary until we decide how we are rendering the info
var ACCURACY_RANGES = [
/*
{
	min:2,
	msgs:['badge_significantly_correlated_one_driver', 'badge_significantly_correlated_one_driver']
},
{
	min:2,
	msgs:['badge_strongly_correlated_one_driver', 'badge_strongly_correlated_two_driver']
},
{
	min:2,
	msgs:['badge_positively_correlated_one_driver','badge_positively_correlated_two_driver']
},
*/
{
	min: 0.66,
	msgs: ['badge_correlated_one_driver', 'badge_correlated_two_driver']
}];

var BadgesFeature = function () {
	function BadgesFeature(widgetApi, dashboardApi) {
		var _this = this;

		_classCallCheck(this, BadgesFeature);

		this.badgeDataReadyDfd = new Deferred();
		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.badgeDataBySlots = {};
		this.badgeClickHandlers = [];
		this._canRender = false;
		// todo: no equivalent new api for widgetApi.on;
		this.widgetApi.on('visevent:customdataselection', this._onVisBadgeClick, this);
		this.dashboardApi.getCanvasWhenReady().then(function (canvas) {
			_this.layoutApi = canvas.getLayout(_this.widgetApi.getId());
			_this.layoutApi.onTitleBadgeClick(_this._onTitleBadgeClick, _this);
			_this._canRender = true;
			// Render the badges if If we have requested to render the badges before the board is loaded.
			if (_this._isBadgesRendered) {
				_this.renderBadges();
			}
		});
	}

	BadgesFeature.prototype.getFeatureTags = function getFeatureTags() {
		return ['interactive-only'];
	};

	BadgesFeature.prototype.destroy = function destroy() {
		// todo: no equivalent new api for widgetApi.off;
		this.widgetApi.off('visevent:customdataselection', this._onVisBadgeClick, this);
		if (this.layoutApi) {
			this.layoutApi.offTitleBadgeClick(this._onTitleBadgeClick, this);
		}
		this.badgeClickHandlers = []; //remove all references
	};

	/**
 * Set the badge info for a given column
 *
 * @param {String} columnId - metadata column id
 * @param {String} label - metadata column label
 * @param {integer} badgeSlotIndex - the index of the slot that the badge is associated with. If the badge is associated with a slot that does not support badges, the index will be -1
 * @param {String} slotId - the slot id
 * @param {Object} data - fast pattern detection data response
 *
 */


	BadgesFeature.prototype.setBadgeData = function setBadgeData(columnId, label, badgeSlotIndex, slotId, data) {
		var badgesData = this.badgeDataBySlots[badgeSlotIndex];
		if (!badgesData) {
			badgesData = {
				slotId: slotId,
				data: {}
			};
			this.badgeDataBySlots[badgeSlotIndex] = badgesData;
		}

		var badgeData = this._createBadgeData(columnId, label, data);
		if (badgeData) {
			badgesData.data[columnId] = badgeData;
			this._calculateBadgeDecorationLabel(badgesData);
			this._invokeChange();
			if (this.badgeDataReadyDfd) {
				this.badgeDataReadyDfd.resolve();
			}
		}
	};

	/**
 * Clear the badge info
 */


	BadgesFeature.prototype.clearBadgesInfo = function clearBadgesInfo() {
		//todo: new decoratorApi not working yet
		var decoratorApi = this.widgetApi.getVisApi().getDecoratorAPI(0);
		if (decoratorApi) {
			decoratorApi.clearItemDecoration('badge');
			decoratorApi.updateDecorations();
		}

		if (this.layoutApi) {
			this.layoutApi.setTitleBadge(null);
		}

		this._isBadgesRendered = false;
		this.badgeDataBySlots = {};
		this.badgeDataReadyDfd = new Deferred();
	};

	/*
 * Return the badge info associated with the widget title
 *
 */


	BadgesFeature.prototype.getTitleBadgeInfo = function getTitleBadgeInfo() {
		return this.getBadgesInfoForSlot(-1);
	};

	/**
 * return the badge Info associated with a given column od
 * @param {integer} slotIndex - slotIndex
 */


	BadgesFeature.prototype.getBadgesInfoForSlot = function getBadgesInfoForSlot(slotIndex) {
		var badgesInfo = void 0;
		if (this.badgeDataBySlots[slotIndex]) {
			badgesInfo = this.badgeDataBySlots[slotIndex].data;
		} else {
			badgesInfo = {};
		}
		// Return a copy of the internal badges data map
		return JSON.parse(JSON.stringify(badgesInfo));
	};

	/**
 * return the badge Info associated with a given column od
 * @param {integer} slotId - Slot id
 */


	BadgesFeature.prototype.getBadgesInfoForSlotBySlotId = function getBadgesInfoForSlotBySlotId(slotId) {
		var index = void 0;
		var badgesInfo = void 0;
		for (index in this.badgeDataBySlots) {
			if (this.badgeDataBySlots[index].slotId === slotId) {
				badgesInfo = this.badgeDataBySlots[index].data;
				break;
			}
		}

		// Return a copy of the internal badges data map
		return JSON.parse(JSON.stringify(badgesInfo || {}));
	};

	/**
 * Register a handler that will be called when the badge info has changes
 */


	BadgesFeature.prototype.onBadgeSelect = function onBadgeSelect(handler) {
		this.badgeClickHandlers.push(handler);
	};

	/**
 * Unregister a previously registered handler using onChange()
 */


	BadgesFeature.prototype.offBadgeSelect = function offBadgeSelect(handler) {
		var index = this.badgeClickHandlers.indexOf(handler);
		if (index > -1) {
			this.badgeClickHandlers.splice(index, 1);
		}
	};

	/**
 * Return the feature API object.
 */


	BadgesFeature.prototype.getAPI = function getAPI() {
		return {
			onBadgeSelect: this.onBadgeSelect.bind(this),
			offBadgeSelect: this.offBadgeSelect.bind(this),
			getBadgeDataWhenReady: this.getBadgeDataWhenReady.bind(this)
		};
	};

	/**
 * Return the feature extra render sequence steps
 */


	BadgesFeature.prototype.getExtraRenderSequenceSteps = function getExtraRenderSequenceSteps() {
		return [{
			id: 'getBadgeInfo',
			dependencies: ['metadata'],
			module: _GetBadgesInfo2.default,
			moduleOptions: {
				badgesFeature: this
			}
		}, {
			id: 'renderBadgeInfo',
			dependencies: ['getBadgeInfo', 'render'],
			module: _RenderBadgesInfo2.default,
			moduleOptions: {
				badgesFeature: this
			}
		}];
	};

	BadgesFeature.prototype.renderBadges = function renderBadges() {
		this._isBadgesRendered = true;
		// guard to wait for the board to be loaded.
		if (this._canRender) {
			this._decorateSlots();
			this._decorateTitle();
		}
	};
	/**
  * @param {slotId} slot id of the widget, -1 means title
  * @return {object} promise with badge info
  */


	BadgesFeature.prototype.getBadgeDataWhenReady = function getBadgeDataWhenReady(slotId) {
		var _this2 = this;

		return this.badgeDataReadyDfd.promise.then(function () {
			return _this2.getBadgesInfoForSlotBySlotId(slotId);
		});
	};

	/**
 * decorate the visualization with the supported badges
 */


	BadgesFeature.prototype._decorateSlots = function _decorateSlots() {
		var slotIndex = void 0;
		var isDecorated = void 0;
		//todo: new decoratorApi not working yet
		var decoratorApi = this.widgetApi.getVisApi().getDecoratorAPI(0);
		if (decoratorApi) {
			for (slotIndex in this.badgeDataBySlots) {
				if (slotIndex >= 0) {
					var label = this.badgeDataBySlots[slotIndex].label;
					if (label) {
						decoratorApi.decorateItem(slotIndex, 'badge', label);
						isDecorated = true;
					}
				}
			}
			if (isDecorated) {
				decoratorApi.updateDecorations();
			}
		}
	};

	/**
 * decorate the widget title with the the title badge info
 */


	BadgesFeature.prototype._decorateTitle = function _decorateTitle() {
		if (this.badgeDataBySlots[-1] && this.layoutApi) {
			this.layoutApi.setTitleBadge(this.badgeDataBySlots[-1].label, _StringResources2.default.get('badge_label'));
		}
	};

	BadgesFeature.prototype._getSlotId = function _getSlotId(badgePayload) {
		return badgePayload.dataItem && badgePayload.dataItem.itemClass ? badgePayload.dataItem.itemClass.slotDef && badgePayload.dataItem.itemClass.slotDef.name : badgePayload.dataItem && badgePayload.dataItem.slotDef && badgePayload.dataItem.slotDef.name;
	};
	/**
 * Called when a vis badge is clicked.
 * Call all the registered onClick handler with the proper badge info
 *
 * @param {object} payload - badge selection payload form the visAPI
 */


	BadgesFeature.prototype._onVisBadgeClick = function _onVisBadgeClick(payload) {
		var item = payload.items[0];
		if (item && item.key === 'badge' && item.values && item.values.length) {
			var badgePayload = item.values[0].payload;
			var slotId = this._getSlotId(badgePayload);
			if (slotId) {
				var clientRect = payload.event.target.getBoundingClientRect();
				var slotBadgeInfo = this.getBadgesInfoForSlotBySlotId(slotId);
				this.badgeClickHandlers.forEach(function (handler) {
					handler(slotBadgeInfo, clientRect);
				});
			}
		}
	};

	/**
 * Called when a title badge is clicked.
 * Call all the registere onClick handler with the proper badge info
 * @param {object} payload - badge selection payload
 */


	BadgesFeature.prototype._onTitleBadgeClick = function _onTitleBadgeClick(payload) {
		var clientRect = payload.event.target.getBoundingClientRect();
		var badgeInfo = this.getTitleBadgeInfo();
		this.badgeClickHandlers.forEach(function (handler) {
			handler(badgeInfo, clientRect);
		});
	};

	/**
 * called when a new badge info is available.
 * If a render has been requested, this method will render the badges as they become available
 */


	BadgesFeature.prototype._invokeChange = function _invokeChange() {
		// if we have rendered.. render again to update
		if (this._isBadgesRendered) {
			this.renderBadges();
		}
	};

	/**
 * Calculate the badge decoration label
 * @param {object}  badgesData
 */


	BadgesFeature.prototype._calculateBadgeDecorationLabel = function _calculateBadgeDecorationLabel(badgesData) {
		var name = void 0;
		var count = 0;
		for (name in badgesData.data) {
			count += badgesData.data[name].drivers.length;
		}
		badgesData.label = count > 0 ? count : '';
	};

	/**
 * Create the badge entry detail. This function will:
 * 1 - Sort the drivers by accuracy.
 * 2 - Only keep up to 5 drivers
 * 3 - Filter out any drivers that are below the threshhold
 * 4 - Build a label that contains the drivers and the formatted accuracy
 *
 *	@param {String} columnId
 * @param {String} label
 * @param {Object} data - fast pattern detection data response
 */


	BadgesFeature.prototype._createBadgeData = function _createBadgeData(columnId, label, data) {
		var _this3 = this;

		var badgeData = {
			id: columnId,
			label: label,
			drivers: []
		};

		if (data.results) {
			data.results.sort(function (a, b) {
				return b.accuracy - a.accuracy;
			}).forEach(function (entry, index) {
				if (index >= MAX_DRIVERS_PER_COLUMN) {
					return;
				}
				var driverInfo = _this3._createDriverInfo(entry, columnId);
				if (driverInfo) {
					badgeData.drivers.push(driverInfo);
				}
			});
		}

		return badgeData.drivers.length ? badgeData : null;
	};

	BadgesFeature.prototype._getAllFiltersAsLocalFilters = function _getAllFiltersAsLocalFilters() {
		var localFilters = [];
		var globalFilters = [];
		var visualization = this.widgetApi.getVisualization();
		if (visualization) {
			localFilters = visualization.getLocalFilters().getFilterList();
			var globalFiltersFeature = this.dashboardApi.getFeature('GlobalFilters');
			if (globalFiltersFeature) {
				var sourceId = visualization.getDataSource() && visualization.getDataSource().getId();
				var scope = this.widgetApi.getScope();
				globalFilters = globalFiltersFeature.getFilters(sourceId, scope).getFilterList();
			}
		}
		return [].concat(localFilters, globalFilters);
	};

	/**
 * Create a driver info. This method will generate a label
 * that contains the list of drivers and accuracy.
 * Any driver with an accuracy below the pre defined threshold will be filtered out. In the case the response will be null.
 *
 * @param {Object} driverData - fast pattern detection driver data response
 */


	BadgesFeature.prototype._createDriverInfo = function _createDriverInfo(driverData, columnId) {

		var driverInfo = null;
		var range = ACCURACY_RANGES.find(function (range) {
			return driverData.accuracy > range.min;
		});
		if (range) {
			var visualization = this.widgetApi.getVisualization();
			var dataSource = visualization && visualization.getDataSource();
			var sourceId = dataSource && dataSource.getId();
			var inputs = driverData.fields.inputs;
			driverInfo = {
				accuracy: driverData.accuracy,
				inputs: inputs,
				target: columnId,
				widgetSpec: {
					type: 'live',
					visId: 'com.ibm.vis.rave2comet',
					visTypeLocked: true,
					slotmapping: {
						slots: [{
							name: 'values',
							dataItems: ['1']
						}]
					},
					data: {
						dataViews: [{
							modelRef: sourceId,
							dataItems: [{
								itemId: columnId,
								id: '1'
							}]
						}]
					},
					localFilters: this._getAllFiltersAsLocalFilters(),
					'customData': {
						'selected': [{
							'id': driverData.id,
							'value': true
						}]
					}
				}
			};
			var options = this._createLabelOptionsForDriver(driverInfo);
			var msgIndex = Math.min(inputs.length - 1, 1);
			driverInfo.label = _StringResources2.default.get(range.msgs[msgIndex], options);
		}
		return driverInfo;
	};

	/**
 *
 * Create the string resources options that will be used to generate the driver label.
 * The logic handles whether we have 1 , 2 or more drivers and depedening on the number it will select the proper message options.
 *
 */


	BadgesFeature.prototype._createLabelOptionsForDriver = function _createLabelOptionsForDriver(driverInfo) {
		var options = {};
		options.percent = (driverInfo.accuracy * 100).toFixed(0) + '%';

		if (driverInfo.inputs.length > 2) {
			// We have more than 2 drivers.
			var labels = driverInfo.inputs.map(function (input) {
				return input.label;
			});
			var last = labels.pop();
			options['column0'] = labels.toString().replace(/,/g, ', ');
			labels.shift();
			options['column1'] = last;
		} else {
			driverInfo.inputs.forEach(function (input, index) {
				options['column' + index] = input.label;
			});
		}

		return options;
	};

	return BadgesFeature;
}();

exports.default = BadgesFeature;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseStep2 = __webpack_require__(114);

var _BaseStep3 = _interopRequireDefault(_BaseStep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var SKIP_BADGEINFO_FOR_CATEGORIES = true;

var GetBadgesInfo = function (_BaseStep) {
	_inherits(GetBadgesInfo, _BaseStep);

	function GetBadgesInfo() {
		_classCallCheck(this, GetBadgesInfo);

		return _possibleConstructorReturn(this, _BaseStep.apply(this, arguments));
	}

	GetBadgesInfo.prototype._isVisTypeUnsupported = function _isVisTypeUnsupported(visId) {
		var unsupportedVisTypes = ['com.ibm.vis.rave2comet', 'com.ibm.vis.spiral', 'com.ibm.vis.sunburst', 'com.ibm.vis.decisiontree'];
		return unsupportedVisTypes.indexOf(visId) > -1;
	};

	GetBadgesInfo.prototype._getContent = function _getContent() {
		var _this2 = this;

		if (!this.content) {
			return this.dashboardApi.getCanvasWhenReady().then(function (canvas) {
				_this2.content = canvas.getContent(_this2.ownerWidget.getId());
				return _this2.content;
			});
		} else {
			return Promise.resolve(this.content);
		}
	};

	GetBadgesInfo.prototype._containsOlap = function _containsOlap(visOlapContentHelper) {
		//We call an api "likelyContainsOlap" to ensure we don't make badge requests for OLAP
		//OR for edge cases where calculations might contain OLAP in mixed packages
		//where we can't tell if the vis is OLAP or not from other items.
		return visOlapContentHelper && visOlapContentHelper.likelyContainsOlap();
	};

	GetBadgesInfo.prototype._shouldSkipBadges = function _shouldSkipBadges(visualization, visOlapContentHelper) {
		//Do not ask for Badges if slot mappings are not compete
		var slots = visualization && visualization.getSlots();
		if (!slots.isMappingComplete()) {
			return true;
		}
		//OR if this vistype isn't supported for badges OR it containsOLAP (FPD request doesn't support olap)
		var visDefinition = visualization && visualization.getDefinition();
		if (!visDefinition || this._isVisTypeUnsupported(visDefinition.getId()) || this._containsOlap(visOlapContentHelper)) {
			return true;
		}
		//OR if this visualization contains a filter on an autogrouped measure (legacy autogrouping)
		var binnedFilters = visualization.getLocalFilters().getFilterList().find(function (filter) {
			return filter.filterBins;
		});
		if (binnedFilters) {
			return true;
		}

		return false;
	};

	GetBadgesInfo.prototype.process = function process(renderContext) {
		var _this3 = this;

		return this._getContent().then(function () {
			// Skip the badges when we have a comet viz
			var visFeature = _this3.content.getFeature('Visualization');
			var visOlapContentHelper = _this3.content.getFeature('Visualization.olapContentHelper');
			var refreshData = renderContext.refresh && renderContext.refresh.data;

			if (_this3._shouldSkipBadges(visFeature, visOlapContentHelper)) {
				//In both case, there should not be any badges on the
				//widget, so we do clear badges info in these cases.
				_this3.badgesFeature.clearBadgesInfo();
				return Promise.resolve();
			} else if (!refreshData && _this3._isStepComplete(renderContext, 'getBadgeInfo')) {
				return Promise.resolve();
			} else {
				_this3.badgesFeature.clearBadgesInfo();
			}
			var badgeRenderContext = {
				requestMap: {}
			};
			var dataSlots = visFeature.getSlots();
			var processedDataItemIds = []; //Array that contains IDs of processed data items
			dataSlots.getMappedSlotList().forEach(function (slot, slotIndex) {
				//For Endor release, confirmed with Predict team that Drivers Analytics for Categories are not supported
				//We disable requests for such category slots or attributes assigned to ordinal slots for performances
				var dataItems = slot.getDataItemList();
				dataItems.forEach(function (dataItem) {
					if (!_this3._skipRequestForDataItem(dataItem, processedDataItemIds)) {
						var id = dataItem.getColumnId();
						var slotId = slot.getDefinition().getId();
						var requestId = slotId + '--' + id;
						// Skip the virtual multi measure series data item
						if (id !== '_multiMeasuresSeries' && !badgeRenderContext.requestMap[requestId]) {
							var badgeSlotIndex = -1;
							var tags = slot.getDefinition().getTags();
							if (tags && tags.indexOf('badge') !== -1) {
								badgeSlotIndex = slotIndex;
							}
							badgeRenderContext.requestMap[requestId] = _this3.getKeyDriverAnalysis(id, dataItem.getLabel(), badgeSlotIndex, slotId, renderContext);
						}
					}
				});
			});
			_this3._completeStep(renderContext, 'getBadgeInfo', badgeRenderContext);
			// resolve the step completion. This will start the execution of the rendering of the badges
			return Promise.resolve();
		});
	};

	GetBadgesInfo.prototype._skipRequestForDataItem = function _skipRequestForDataItem(dataItem, processedDataItemIds) {
		var dataItemMetadataColumn = dataItem.getMetadataColumn && dataItem.getMetadataColumn();
		// if the dataItem is _multiMeasuresSeries, then getMetadataColumn will return null for it
		if (!dataItemMetadataColumn) {
			return true;
		}
		if (SKIP_BADGEINFO_FOR_CATEGORIES && dataItemMetadataColumn.getType() !== 'fact') {
			return true;
		}
		//There should be no badge requests for OLAP items.
		if (dataItemMetadataColumn.isOlapColumn()) {
			return true;
		}

		var itemId = dataItem.getColumnId();
		//Only process the same dataItem ID once for the current widget
		if (processedDataItemIds.indexOf(itemId) > -1) {
			return true;
		} else {
			//Cache this dataItem ID to the array
			processedDataItemIds.push(itemId);
		}

		return false;
	};

	//TEMPORARY FUNCTION: Manage the "visKeyDriversFeature" feature flag.


	GetBadgesInfo.prototype._getKeyDrivers = function _getKeyDrivers() {
		return this._getContent().then(function (content) {
			var visKeyDrivers = content.getFeature('VisKeyDrivers');
			return visKeyDrivers && visKeyDrivers.isVisKeyDriversFeatureEnabled() ? visKeyDrivers : null;
		});
	};

	GetBadgesInfo.prototype._getPossibleKeyDrivers = function _getPossibleKeyDrivers(renderContext, columnId) {
		var _this4 = this;

		return this._getKeyDrivers().then(function (visKeyDrivers) {
			return visKeyDrivers ? visKeyDrivers.refreshPossibleKeyDrivers(columnId, false /* useModelData */) : _this4.visAPI.whenPossibleKeyDriversAreReady(renderContext, columnId, false /* useModelData */);
		});
	};

	GetBadgesInfo.prototype._executeFastPatternDetectionRequest = function _executeFastPatternDetectionRequest(columnId, inputs) {
		var _this5 = this;

		return this._getKeyDrivers().then(function (visKeyDrivers) {
			return visKeyDrivers ? visKeyDrivers.executeFastPatternDetectionRequest(columnId, inputs, /*methods*/null, /*parmValues*/null, /*isPreview*/false, /*notify*/false) : _this5.visAPI.executeFastPatternDetectionRequest(columnId, inputs, null /* method */, {} /* promptControlFunctions */);
		});
	};

	GetBadgesInfo.prototype.getKeyDriverAnalysis = function getKeyDriverAnalysis(columnId, label, badgeSlotIndex, slotId, renderContext) {
		var _this6 = this;

		// Set the parameter "useModelData" to false when retrieving key drivers to get fresh metadata for badges
		// todo: use PredictServiceDataProviderAPI.whenPossibleKeyDriversAreReady when it is ready
		return this._getPossibleKeyDrivers(renderContext, columnId).then(function (possibleKeyDrivers) {
			// Temporary until the live widget hooks up the smarts service caller
			// the current logic is returning all columns in the dataset
			var inputs = void 0;
			if (possibleKeyDrivers.recommendedDrivers) {
				inputs = possibleKeyDrivers.recommendedDrivers.map(function (entry) {
					return entry.fieldIDForExpression;
				});
			} else {
				inputs = [];
			}

			// List of key drivers used for FPD in badges may bring many prompts from other columns that user don't know much about.
			// Pass empty promptControlFunctions to ignore prompts for badges.
			// todo: use PredictServiceDataProviderAPI.executeFastPatternDetectionRequest when it is ready
			return _this6._executeFastPatternDetectionRequest(columnId, inputs).then(function (data) {
				_this6.badgesFeature.setBadgeData(columnId, label, badgeSlotIndex, slotId, data);
				return data;
			}, function (e) {
				var errorMsg = 'Error running the predict request for the badge: ' + columnId;
				_this6.dashboardApi.getGlassCoreSvc('.Logger').error(errorMsg);
				var data = {
					'error': {
						message: errorMsg,
						rootCause: e
					}
				};
				_this6.badgesFeature.setBadgeData(columnId, label, badgeSlotIndex, slotId, data);
				return data;
			});
		});
	};

	return GetBadgesInfo;
}(_BaseStep3.default);

exports.default = GetBadgesInfo;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseStep2 = __webpack_require__(114);

var _BaseStep3 = _interopRequireDefault(_BaseStep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RenderBadgesInfo = function (_BaseStep) {
	_inherits(RenderBadgesInfo, _BaseStep);

	function RenderBadgesInfo() {
		_classCallCheck(this, RenderBadgesInfo);

		return _possibleConstructorReturn(this, _BaseStep.apply(this, arguments));
	}

	RenderBadgesInfo.prototype.process = function process() /*renderContext*/{
		// Render is complete. Update the slot badge decorations.
		this.badgesFeature.renderBadges();
		return Promise.resolve();
	};

	return RenderBadgesInfo;
}(_BaseStep3.default);

exports.default = RenderBadgesInfo;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VisBadgesResources = __webpack_require__(472);

var _VisBadgesResources2 = _interopRequireDefault(_VisBadgesResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(18);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisBadgesResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

var amdi18n={"__root":{"badge_label":"Correlations","badge_significantly_correlated_one_driver":"Significantly correlated with %{column0} and  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Strongly correlated with %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Strongly correlated with %{column0} and %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positively correlated with %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positively correlated with %{column0} and %{column1} (%{percent})","badge_correlated_one_driver":"Correlated with %{column0} (%{percent})","badge_correlated_two_driver":"Correlated with %{column0} and %{column1} (%{percent})"},"__cs":{"badge_label":"Korelace","badge_significantly_correlated_one_driver":"Výrazně korelováno s %{column0} a %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Silně korelováno s %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Silně korelováno s %{column0} a %{column1} (%{percent})","badge_positively_correlated_one_driver":"Kladně korelováno s %{column0} (%{percent})","badge_positively_correlated_two_driver":"Kladně korelováno s %{column0} a %{column1} (%{percent})","badge_correlated_one_driver":"Korelováno s %{column0} (%{percent})","badge_correlated_two_driver":"Korelováno s %{column0} a %{column1} (%{percent})"},"__da":{"badge_label":"Korrelationer","badge_significantly_correlated_one_driver":"Signifikant korreleret med %{column0} og %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Stærkt korreleret med %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Stærkt korreleret med %{column0} og %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivt korreleret med %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivt korreleret med %{column0} og %{column1} (%{percent})","badge_correlated_one_driver":"Korreleret med %{column0} (%{percent})","badge_correlated_two_driver":"Korreleret med %{column0} og %{column1} (%{percent})"},"__de":{"badge_label":"Korrelationen","badge_significantly_correlated_one_driver":"Signifikante Korrelation mit %{column0} und  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Starke Korrelation mit %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Starke Korrelation mit %{column0} und %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positive Korrelation mit %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positive Korrelation mit %{column0} und %{column1} (%{percent})","badge_correlated_one_driver":"Korrelation mit %{column0} (%{percent})","badge_correlated_two_driver":"Korrelation mit %{column0} und %{column1} (%{percent})"},"__es":{"badge_label":"Correlaciones","badge_significantly_correlated_one_driver":"Correlacionado significativamente con %{column0} y %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Correlacionado fuertemente con %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Correlacionado fuertemente con %{column0} y %{column1} (%{percent})","badge_positively_correlated_one_driver":"Correlacionado positivamente con %{column0} (%{percent})","badge_positively_correlated_two_driver":"Correlacionado positivamente con %{column0} y %{column1} (%{percent})","badge_correlated_one_driver":"Correlacionado con %{column0} (%{percent})","badge_correlated_two_driver":"Correlacionado con %{column0} y %{column1} (%{percent})"},"__fi":{"badge_label":"Korrelaatiot","badge_significantly_correlated_one_driver":"Merkittävä korrelaatio kohteiden %{column0} ja  %{column1} kanssa (%{percent})","badge_strongly_correlated_one_driver":"Vahva korrelaatio kohteen %{column0} kanssa (%{percent})","badge_strongly_correlated_two_driver":"Vahva korrelaatio kohteiden %{column0} ja  %{column1} kanssa (%{percent})","badge_positively_correlated_one_driver":"Positiivinen korrelaatio kohteen %{column0} kanssa (%{percent})","badge_positively_correlated_two_driver":"Positiivinen korrelaatio kohteiden %{column0} ja  %{column1} kanssa (%{percent})","badge_correlated_one_driver":"Korrelaatio kohteen %{column0} kanssa (%{percent})","badge_correlated_two_driver":"Korrelaatio kohteiden %{column0} ja  %{column1} kanssa (%{percent})"},"__fr":{"badge_label":"Corrélations","badge_significantly_correlated_one_driver":"Corrélé de manière significative avec %{column0} et %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Fortement corrélé avec %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Fortement corrélé avec %{column0} et  %{column1} (%{percent})","badge_positively_correlated_one_driver":"Corrélé de manière positive avec %{column0} (%{percent})","badge_positively_correlated_two_driver":"Corrélé de manière positive avec %{column0} et  %{column1} (%{percent})","badge_correlated_one_driver":"Corrélé avec %{column0} (%{percent})","badge_correlated_two_driver":"Corrélé avec %{column0} et %{column1} (%{percent})"},"__hr":{"badge_label":"Korelacije","badge_significantly_correlated_one_driver":"Značajno korelira s %{column0} i  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Jaka korelacija s %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Jaka korelacija s %{column0} i %{column1} (%{percent})","badge_positively_correlated_one_driver":"Pozitivna korelacija s %{column0} (%{percent})","badge_positively_correlated_two_driver":"Pozitivna korelacija s %{column0} i %{column1} (%{percent})","badge_correlated_one_driver":"Korelira s %{column0} (%{percent})","badge_correlated_two_driver":"Korelira s %{column0} i %{column1} (%{percent})"},"__hu":{"badge_label":"Korrelációk","badge_significantly_correlated_one_driver":"Jelentősen összefüggésbe hozva a következővel: %{column0} és  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Erősen összefüggésbe hozva a következővel: %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Erősen összefüggésbe hozva a következővel: %{column0} és  %{column1} (%{percent})","badge_positively_correlated_one_driver":"Pozitívan összefüggésbe hozva a következővel: %{column0} (%{percent})","badge_positively_correlated_two_driver":"Pozitívan összefüggésbe hozva a következővel: %{column0} és  %{column1} (%{percent})","badge_correlated_one_driver":"Összefüggésbe hozva a következővel: %{column0} (%{percent})","badge_correlated_two_driver":"Összefüggésbe hozva a következővel: %{column0} és %{column1} (%{percent})"},"__it":{"badge_label":"Correlazioni","badge_significantly_correlated_one_driver":"Correlato significativamente con %{column0} e %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Correlato efficacemente con %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Correlato efficacemente con %{column0} e %{column1} (%{percent})","badge_positively_correlated_one_driver":"Correlato positivamente con %{column0} (%{percent})","badge_positively_correlated_two_driver":"Correlato positivamente con %{column0} e %{column1} (%{percent})","badge_correlated_one_driver":"Correlato con %{column0} (%{percent})","badge_correlated_two_driver":"Correlato con %{column0} e %{column1} (%{percent})"},"__ja":{"badge_label":"相関","badge_significantly_correlated_one_driver":"%{column0} および  %{column1} と著しく相関 (%{percent})","badge_strongly_correlated_one_driver":"%{column0} と強く相関 (%{percent})","badge_strongly_correlated_two_driver":"%{column0} および %{column1} と強く相関 (%{percent})","badge_positively_correlated_one_driver":"%{column0} と正の相関 (%{percent})","badge_positively_correlated_two_driver":"%{column0} および %{column1} と正の相関 (%{percent})","badge_correlated_one_driver":"%{column0} と相関 (%{percent})","badge_correlated_two_driver":"%{column0} および %{column1} と相関 (%{percent})"},"__kk":{"badge_label":"Корреляция","badge_significantly_correlated_one_driver":"%{column0} және %{column1} (%{percent}) -мен айтарлықтай байланысты","badge_strongly_correlated_one_driver":"%{column0} (%{percent}) -мен қатты байланысты","badge_strongly_correlated_two_driver":"%{column0} және %{column1} (%{percent}) -мен қатты байланысты","badge_positively_correlated_one_driver":"%{column0} (%{percent}) - мен оң байланысты","badge_positively_correlated_two_driver":"%{column0} және %{column1} (%{percent}) - мен оң байланысты","badge_correlated_one_driver":"%{column0} (%{percent}) байланысты","badge_correlated_two_driver":"%{column0} және %{column1} (%{percent}) - мен оң байланысты"},"__ko":{"badge_label":"상관","badge_significantly_correlated_one_driver":"%{column0} 및  %{column1}과(와) 상당히 상관관계가 있음(%{percent})","badge_strongly_correlated_one_driver":"%{column0}과(와) 매우 상관관계가 있음(%{percent})","badge_strongly_correlated_two_driver":"%{column0} 및  %{column1}과(와) 매우 상관관계가 있음(%{percent})","badge_positively_correlated_one_driver":"%{column0}과(와) 양의 상관관계가 있음(%{percent})","badge_positively_correlated_two_driver":"%{column0} 및  %{column1}과(와) 양의 상관관계가 있음(%{percent})","badge_correlated_one_driver":"%{column0}과(와) 상관관계가 있음(%{percent})","badge_correlated_two_driver":"%{column0} 및  %{column1}과(와) 상관관계가 있음(%{percent})"},"__nb":{"badge_label":"Korrelasjoner","badge_significantly_correlated_one_driver":"Betydelig korrelert med %{column0} og %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Sterkt korrelert med %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Sterkt korrelert med %{column0} og %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivt korrelert med %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivt korrelert med %{column0} og %{column1} (%{percent})","badge_correlated_one_driver":"Korrelert med %{column0} (%{percent})","badge_correlated_two_driver":"Korrelert med %{column0} og %{column1} (%{percent})"},"__nl":{"badge_label":"Correlaties","badge_significantly_correlated_one_driver":"Significante correlatie met  %{column0} en  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Sterke correlatie met %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Sterke correlatie met %{column0} en %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positieve correlatie met %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positieve correlatie met %{column0} en %{column1} (%{percent})","badge_correlated_one_driver":"Correlatie met %{column0} (%{percent})","badge_correlated_two_driver":"Correlatie met %{column0} en %{column1} (%{percent})"},"__no":{"badge_label":"Korrelasjoner","badge_significantly_correlated_one_driver":"Betydelig korrelert med %{column0} og %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Sterkt korrelert med %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Sterkt korrelert med %{column0} og %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivt korrelert med %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivt korrelert med %{column0} og %{column1} (%{percent})","badge_correlated_one_driver":"Korrelert med %{column0} (%{percent})","badge_correlated_two_driver":"Korrelert med %{column0} og %{column1} (%{percent})"},"__pl":{"badge_label":"Korelacje","badge_significantly_correlated_one_driver":"Istotnie skorelowane z %{column0} i %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Silnie skorelowane z %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Silnie skorelowane z %{column0} i %{column1} (%{percent})","badge_positively_correlated_one_driver":"Dodatnio skorelowane z %{column0} (%{percent})","badge_positively_correlated_two_driver":"Dodatnio skorelowane z %{column0} i %{column1} (%{percent})","badge_correlated_one_driver":"Skorelowane z %{column0} (%{percent})","badge_correlated_two_driver":"Skorelowane z %{column0} i %{column1} (%{percent})"},"__pt":{"badge_label":"Correlações","badge_significantly_correlated_one_driver":"Correlacionado significativamente com %{column0} e %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Fortemente correlacionado com %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Fortemente correlacionado com %{column0} e %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivamente correlacionado com %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivamente correlacionado com %{column0} e %{column1} (%{percent})","badge_correlated_one_driver":"Correlacionado com %{column0} (%{percent})","badge_correlated_two_driver":"Correlacionado com %{column0} e %{column1} (%{percent})"},"__pt-br":{"badge_label":"Correlações","badge_significantly_correlated_one_driver":"Correlacionado significativamente com %{column0} e %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Fortemente correlacionado com %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Fortemente correlacionado com %{column0} e %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivamente correlacionado com %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivamente correlacionado com %{column0} e %{column1} (%{percent})","badge_correlated_one_driver":"Correlacionado com %{column0} (%{percent})","badge_correlated_two_driver":"Correlacionado com %{column0} e %{column1} (%{percent})"},"__ro":{"badge_label":"Corelări","badge_significantly_correlated_one_driver":"Corelat semnificativ cu %{column0} şi %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Corelat puternic cu %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Corelat puternic cu %{column0} şi %{column1} (%{percent})","badge_positively_correlated_one_driver":"Corelat pozitiv cu %{column0} (%{percent})","badge_positively_correlated_two_driver":"Corelat pozitiv cu %{column0} şi %{column1} (%{percent})","badge_correlated_one_driver":"Corelat cu %{column0} (%{percent})","badge_correlated_two_driver":"Corelat cu %{column0} şi %{column1} (%{percent})"},"__ru":{"badge_label":"Корреляции","badge_significantly_correlated_one_driver":"Значительно коррелировано с %{column0} и %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Сильно коррелировано с %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Сильно коррелировано с %{column0} и %{column1} (%{percent})","badge_positively_correlated_one_driver":"Положительно коррелировано с %{column0} (%{percent})","badge_positively_correlated_two_driver":"Положительно коррелировано с %{column0} и %{column1} (%{percent})","badge_correlated_one_driver":"Коррелировано с %{column0} (%{percent})","badge_correlated_two_driver":"Коррелировано с %{column0} и %{column1} (%{percent})"},"__sl":{"badge_label":"Korelacije","badge_significantly_correlated_one_driver":"Bistvena korelacija s stolpcem %{column0} in %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Močna korelacija s stolpcem %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Močna korelacija s stolpcem %{column0} in %{column1} (%{percent})","badge_positively_correlated_one_driver":"Pozitivna korelacija s stolpcem %{column0} (%{percent})","badge_positively_correlated_two_driver":"Pozitivna korelacija s stolpcem %{column0} in %{column1} (%{percent})","badge_correlated_one_driver":"Korelacija s stolpcem %{column0} (%{percent})","badge_correlated_two_driver":"Korelacija s stolpcem %{column0} in %{column1} (%{percent})"},"__sv":{"badge_label":"Korrelationer","badge_significantly_correlated_one_driver":"Signifikant korrelerad med %{column0} och %{column1} (%{percent})","badge_strongly_correlated_one_driver":"Starkt korrelerad med %{column0} (%{percent})","badge_strongly_correlated_two_driver":"Starkt korrelerad med %{column0} och %{column1} (%{percent})","badge_positively_correlated_one_driver":"Positivt korrelated med %{column0} (%{percent})","badge_positively_correlated_two_driver":"Positivt korrelerad med %{column0} och %{column1} (%{percent})","badge_correlated_one_driver":"Korrelerad med %{column0} (%{percent})","badge_correlated_two_driver":"Korrelerad med %{column0} och %{column1} (%{percent})"},"__th":{"badge_label":"ความสัมพันธ์","badge_significantly_correlated_one_driver":"มีความสัมพันธ์อย่างชัดเจนกับ %{column0} และ  %{column1} (%{percent})","badge_strongly_correlated_one_driver":"มีความสัมพันธ์อย่างมากกับ %{column0} (%{percent})","badge_strongly_correlated_two_driver":"มีความสัมพันธ์อย่างมากกับ %{column0} และ %{column1} (%{percent})","badge_positively_correlated_one_driver":"มีความสัมพันธ์เชิงบวกกับ %{column0} (%{percent})","badge_positively_correlated_two_driver":"มีความสัมพันธ์เชิงบวกกับ %{column0} และ %{column1} (%{percent})","badge_correlated_one_driver":"มีความสัมพันธ์กับ %{column0} (%{percent})","badge_correlated_two_driver":"มีความสัมพันธ์กับ %{column0} และ %{column1} (%{percent})"},"__tr":{"badge_label":"Bağıntılar","badge_significantly_correlated_one_driver":"%{column0} ve  %{column1} ile önemli ölçüde bağıntılı (%{percent})","badge_strongly_correlated_one_driver":"%{column0} ile güçlü şekilde bağıntılı (%{percent})","badge_strongly_correlated_two_driver":"%{column0} ve %{column1} ile güçlü şekilde bağıntılı (%{percent})","badge_positively_correlated_one_driver":"%{column0} ile pozitif şekilde bağıntılı (%{percent})","badge_positively_correlated_two_driver":"%{column0} ve %{column1} ile pozitif şekilde bağıntılı (%{percent})","badge_correlated_one_driver":"%{column0} ile bağıntılı(%{percent})","badge_correlated_two_driver":"%{column0} ve %{column1} ile bağıntılı (%{percent})"},"__zh":{"badge_label":"相关性","badge_significantly_correlated_one_driver":"与 %{column0} 和 %{column1} 显著相关 (%{percent})","badge_strongly_correlated_one_driver":"与 %{column0} 强相关 (%{percent})","badge_strongly_correlated_two_driver":"与 %{column0} 和 %{column1} 强相关 (%{percent})","badge_positively_correlated_one_driver":"与 %{column0} 正相关 (%{percent})","badge_positively_correlated_two_driver":"与 %{column0} 和 %{column1} 正相关 (%{percent})","badge_correlated_one_driver":"与 %{column0} 相关 (%{percent})","badge_correlated_two_driver":"与 %{column0} 和 %{column1} 相关 (%{percent})"},"__zh-cn":{"badge_label":"相关性","badge_significantly_correlated_one_driver":"与 %{column0} 和 %{column1} 显著相关 (%{percent})","badge_strongly_correlated_one_driver":"与 %{column0} 强相关 (%{percent})","badge_strongly_correlated_two_driver":"与 %{column0} 和 %{column1} 强相关 (%{percent})","badge_positively_correlated_one_driver":"与 %{column0} 正相关 (%{percent})","badge_positively_correlated_two_driver":"与 %{column0} 和 %{column1} 正相关 (%{percent})","badge_correlated_one_driver":"与 %{column0} 相关 (%{percent})","badge_correlated_two_driver":"与 %{column0} 和 %{column1} 相关 (%{percent})"},"__zh-tw":{"badge_label":"相關性","badge_significantly_correlated_one_driver":"與 %{column0} 及 %{column1} 顯著相關 (%{percent})","badge_strongly_correlated_one_driver":"與 %{column0} 強烈相關 (%{percent})","badge_strongly_correlated_two_driver":"與 %{column0} 及 %{column1} 強烈相關 (%{percent})","badge_positively_correlated_one_driver":"與 %{column0} 正面相關 (%{percent})","badge_positively_correlated_two_driver":"與 %{column0} 及 %{column1} 正面相關 (%{percent})","badge_correlated_one_driver":"與 %{column0} 相關 (%{percent})","badge_correlated_two_driver":"與 %{column0} 及 %{column1} 相關 (%{percent})"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
	'use strict';

	/**
  * Create a Deferred from a Promise class
  * The reason this function is in common-core is because this is used in client and serveside JS
  * Instantiates the class and uses the promise instance and resolve/reject methods to create a deferred object.
  * @return {[type]}         [description]
  */

	return function () {
		var resolve = void 0,
		    reject = void 0;
		var promise = new Promise(function () {
			resolve = arguments[0];
			reject = arguments[1];
		});
		return { resolve: resolve, reject: reject, promise: promise };
	};
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
//# sourceMappingURL=Deferred.js.map

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ChartInsightsTask = __webpack_require__(475);

var _ChartInsightsTask2 = _interopRequireDefault(_ChartInsightsTask);

var _ChartInsightsQuery = __webpack_require__(477);

var _ChartInsightsQuery2 = _interopRequireDefault(_ChartInsightsQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * The ChartInsights feature is used to obtain chart-insights queries based on rendered results data.
 **/
var ChartInsights = function () {
	function ChartInsights(widgetApi, dashboardApi) {
		_classCallCheck(this, ChartInsights);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;

		this._fnResultsHandler = this.buildChartInsightsQuerySpecsFromUnprocessedData.bind(this);
	}

	ChartInsights.prototype.destroy = function destroy() {
		var queryAPI = this.getQueryAPI();
		queryAPI && queryAPI.deregisterUpdateHandler && queryAPI.deregisterUpdateHandler(this._fnResultsHandler);
	};

	ChartInsights.prototype.getAPI = function getAPI() {
		var _this = this;

		return {
			activate: function activate(options) {
				return _this.activate(options);
			},
			deactivate: function deactivate() {
				return _this.deactivate();
			},
			getInsights: function getInsights() {
				return _this.getInsights();
			},
			getChartInsightsCalculations: function getChartInsightsCalculations() {
				if (_this.chartInsightsQuery) {
					//this.chartInsightsQuery exists only if this.activate is called
					return _this.chartInsightsQuery.getChartInsightsCalculationArray();
				}
			},
			//getNLTData() IS DEPRECATED (same as getChartInsightsCalculations): will be removed on next live widget update.
			getNLTData: function getNLTData(asCalcArray, annotations) {
				if (_this.chartInsightsQuery) {
					//this.chartInsightsQuery exists only if this.activate is called
					return _this.chartInsightsQuery.getChartInsightsCalculationArray(annotations);
				}
			}
		};
	};

	ChartInsights.prototype.activate = function activate() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		this.widgetContentApi = options.widgetContentApi;
		this.chartInsightsQuery = new _ChartInsightsQuery2.default(this.widgetContentApi, this.dashboardApi);
		this.cbChartInsightsUpdated = options.cbChartInsightsUpdated;
		this._addUnprocessedResultDataHandler(this._fnResultsHandler);
	};

	ChartInsights.prototype.getQueryAPI = function getQueryAPI() {
		if (this.chartInsightsQuery.useFPDAsInsightsInput()) {
			//If this is an "FPD-type" visualization (like Driver Analysis), use the keyDrivers feature as the queryAPI
			//for getting relevant query results.
			var keyDrivers = this.widgetContentApi && this.widgetContentApi.getFeature('VisKeyDrivers');
			if (keyDrivers && keyDrivers.isVisKeyDriversFeatureEnabled()) {
				return keyDrivers;
			}
		}

		return null;
	};

	ChartInsights.prototype._addUnprocessedResultDataHandler = function _addUnprocessedResultDataHandler() {
		var queryAPI = this.getQueryAPI();
		return queryAPI && queryAPI.registerUpdateHandler && queryAPI.registerUpdateHandler(this._fnResultsHandler);
	};

	ChartInsights.prototype.deactivate = function deactivate() {
		this.cbChartInsightsUpdated = undefined;
	};

	/**
  * set data that will be the basis of a chartInsightsQuery for subsequent getInsights() calls.
  * This function also notifies a registered caller that insights have changed
  * (and the caller should call getInsights() to get the latest)
  * NOTE: Generally, setChartInsightsData should be used to set the data for chartInsights queries
  * (its very efficient for cases where data changes and you're not viewing the details panel)
  * The exception is when we need to use un-postprocessed or FPD data (see below)
  * @param chartInsightsData - the source data that needs to be used for the chartInsightsQuery.
  */


	ChartInsights.prototype.setChartInsightsData = function setChartInsightsData(chartInsightsData) {
		if (!this.chartInsightsQuery.useFPDAsInsightsInput()) {
			this.chartInsightsData = chartInsightsData;
			this.cbChartInsightsUpdated && this.cbChartInsightsUpdated();
		}
		this._addUnprocessedResultDataHandler(this.buildChartInsightsQuerySpecsFromUnprocessedData);
	};

	/**
  * For certain cases (aka multi-measure), the results postProcessor makes drastic changes to the DSS query response.
  * In this case, we need to use the preprocessed DSS response directly for chartInsights.
  * We could use this technique all the time but, since data will be changed during post-processing, we need to
  * take a copy (which is a bit more overhead).
  * Since we need to copy the data anyway, we might as well create the queries right away.
  * This function also notifies a registered caller that insights have changed
  * @param chartInsightsData - the source data that needs to be used for the chartInsightsQuery.
  * @param options For example, {type: 'FPD'}, used to customize the handler depending on needs
  *														 {layer: 'layerId'} for DSS data.
  */


	ChartInsights.prototype.buildChartInsightsQuerySpecsFromUnprocessedData = function buildChartInsightsQuerySpecsFromUnprocessedData(chartInsightsData, options) {
		if (this.chartInsightsQuery.useFPDAsInsightsInput() && options && options.type === 'FPD') {
			this._setQuerySpecs(chartInsightsData);
			this.cbChartInsightsUpdated && this.cbChartInsightsUpdated();
		}
	};

	ChartInsights.prototype._setQuerySpecs = function _setQuerySpecs() {
		var dataArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		this._querySpecs = !Array.isArray(dataArray) ? [dataArray] : dataArray;
	};
	/**
  * The main 'host-facing API' used to obtain chart-insights for a particular widget.
  * @returns a promise which is resolved when the insights are available (possibly empty)
  */


	ChartInsights.prototype.getInsights = function getInsights() {
		var _this2 = this;

		var getInsightsResponse = function getInsightsResponse() {
			var insights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			return { insights: insights };
		};
		if (!this.chartInsightsQuery.chartInsightsQuerySupported()) {
			return Promise.resolve(getInsightsResponse());
		}

		var state = this.widgetContentApi.getFeature('state');
		return state.whenStatusChanges(state.STATUS['RENDERED']).then(function () {
			if (_this2.chartInsightsQuery.useFPDAsInsightsInput()) {
				return _this2.chartInsightsQuery.executeQuerySpecs(_this2._querySpecs);
			} else {
				return _this2.chartInsightsQuery.execute(_this2.chartInsightsData);
			}
		}).then(function (nltResponse) {
			return getInsightsResponse(nltResponse);
		});
	};

	/**
 * Return the feature extra render sequence steps
 */


	ChartInsights.prototype.getExtraRenderSequenceSteps = function getExtraRenderSequenceSteps() {
		return [{
			id: 'ChartInsights',
			module: _ChartInsightsTask2.default,
			dependencies: ['data'],
			moduleOptions: {
				chartInsightsFeature: this
			}
		}];
	};

	return ChartInsights;
}();

exports.default = ChartInsights;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseStep2 = __webpack_require__(476);

var _BaseStep3 = _interopRequireDefault(_BaseStep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * The ChartInsightsTask is inserted into the renderSequence whenever the feature is available.
 * Its purpose is to save enough information to execute a chart insights query (but not actually execute it).
 */
var ChartInsightsTask = function (_BaseStep) {
  _inherits(ChartInsightsTask, _BaseStep);

  function ChartInsightsTask() {
    _classCallCheck(this, ChartInsightsTask);

    return _possibleConstructorReturn(this, _BaseStep.apply(this, arguments));
  }

  ChartInsightsTask.prototype.process = function process(renderContext) {
    //TODO: || renderContext.data.getDefaultQueryResult can be removed when the isNewQueryApiEnabled flag is removed.
    if (renderContext && renderContext.data && (renderContext.data.getResult || renderContext.data.getDefaultQueryResult)) {
      this.chartInsightsFeature.setChartInsightsData(renderContext.data);
    }
    return Promise.resolve(renderContext);
  };

  return ChartInsightsTask;
}(_BaseStep3.default);

exports.default = ChartInsightsTask;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var BaseStep = function () {
	function BaseStep(options, moduleOptions) {
		_classCallCheck(this, BaseStep);

		this.chartInsightsFeature = moduleOptions.chartInsightsFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.ownerWidget = options.ownerWidget;
		this.logger = options.logger;
		this.visAPI = options.visAPI;
		this.dashboardApi = options.dashboardApi;

		this._initializeStep = this.owner && this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner && this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner && this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner && this.owner._logRenderContext.bind(this.owner);

		if (this.id && this._initializeStep) {
			this._initializeStep(this.id);
		}
	}

	BaseStep.prototype.getRenderState = function getRenderState() {
		return this.owner && this.owner._renderState;
	};

	BaseStep.prototype.clearError = function clearError() {
		this.visAPI && this.visAPI.visHelper.clearError();
	};

	BaseStep.prototype.showError = function showError(msg, params) {
		this.visAPI && this.visAPI.visHelper && this.visAPI.visHelper.showError(msg, params);
	};

	return BaseStep;
}();

exports.default = BaseStep;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ChartInsightsQueryParams = __webpack_require__(478);

var _ChartInsightsQueryParams2 = _interopRequireDefault(_ChartInsightsQueryParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

/**
 * The chartInsightsQuerySpec is used to convert data into a valid querySpec for the chart-insights query.
 */
var chartInsightsQuery = function () {
	function chartInsightsQuery(widgetContentApi, dashboardApi) {
		_classCallCheck(this, chartInsightsQuery);

		this.widgetContentApi = widgetContentApi;
		this.dashboardApi = dashboardApi;
		this._useFPDAsInsightsInput = undefined;
	}

	/*For visualizations such as decision tree, Chart-Insgiths API supports using FPD call's response as input*/


	chartInsightsQuery.prototype.useFPDAsInsightsInput = function useFPDAsInsightsInput() {
		var visualization = this.widgetContentApi.getFeature('Visualization');
		var visDefinition = visualization && visualization.getDefinition();
		if (visDefinition) {
			this._useFPDAsInsightsInput = visDefinition.getProperty('useFPDAsInsightsInput');
		}
		return this._useFPDAsInsightsInput;
	};

	/**
  * execute chartInsights queries given a queryResults object (called by getInsights).
  * @param queryResultsObject - the queryResults which could contain 1 or more DSS Results for multi-layer
  * @returns a promise which is resolved with the insights resposes.
  */


	chartInsightsQuery.prototype.execute = function execute(queryResultsObject) {
		var querySpecs = this.getChartInsightsQuerySpecs(queryResultsObject);
		return this.executeQuerySpecs(querySpecs);
	};

	/**
  * execute chartInsights queries given a set of querySpecs (see getChartInsightsQuerySpecs)
  * @param querySpecs - the querySpecs to call chartInsights with
  * @returns a promise which is resolved with the insights resposes.
  */
	//Normally, this method will run a single smarts query.
	//For maps, there can be up to 3 layers and, up to 3 queries.


	chartInsightsQuery.prototype.executeQuerySpecs = function executeQuerySpecs() {
		var _this = this;

		var querySpecs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		var promises = [];
		var smartsService = this.dashboardApi.getFeature('SmartsService');
		querySpecs.forEach(function (querySpec) {
			return promises.push(_this._runSmartsQuery(querySpec, smartsService));
		});
		if (promises.length > 0) {
			return Promise.all(promises).then(function (results) {
				var finalInsightsArray = [];
				results.forEach(function (result) {
					if (result.data && result.data.insights) {
						finalInsightsArray = finalInsightsArray.concat(result.data.insights);
					}
				});
				return finalInsightsArray;
			});
		} else {
			return Promise.resolve([]);
		}
	};

	/**
  * @param chartInsightsData - the results data needed to construct the chart insights query spec.
  * @returns one or more smarts query specifications for the chart-insights query used by the execute() api.
  */


	chartInsightsQuery.prototype.getChartInsightsQuerySpecs = function getChartInsightsQuerySpecs(chartInsightsData) {
		var _this2 = this;

		var querySpecs = [];
		if (chartInsightsData && chartInsightsData.getResult) {
			//Make a query for each layer...usually 1 (maps can have up to 3 layers)
			chartInsightsData.getQueryResultIdList().forEach(function (layerId) {
				var queryResult = chartInsightsData.getResult(layerId);
				var dssQueryResultString = queryResult && queryResult.getPropertyValue('RawData.internal');
				var dssQueryResult = dssQueryResultString && JSON.parse(dssQueryResultString);
				var querySpec = _this2._buildQuerySpecFromUnprocessedDSSResponse(dssQueryResult, /*layerId*/layerId);
				if (querySpec) {
					querySpecs.push(querySpec);
				}
			});
		}
		return querySpecs;
	};

	/**
  * Get a chartInsights query specification given a raw dssResponse with a single query.
  * Currently, this path is only used for multi-measure (single response) but returns an array for possible future needs.
  * @param dssResponse - A json representation of the response from the main dss query.
  * @param options - options
  * @param options.layerId - the layerId this query response is for.
  * @returns An array with (currently) one smarts query specification for the chart-insights query used by the execute() api.
  */


	chartInsightsQuery.prototype.getChartInsightsQuerySpecsFromUnprocessedDSSResponse = function getChartInsightsQuerySpecsFromUnprocessedDSSResponse(dssResponse, options) {
		var querySpecs = [];
		var querySpec = this._buildQuerySpecFromUnprocessedDSSResponse(dssResponse, options && options.layerId);
		if (querySpec) {
			querySpecs.push(querySpec);
		}
		return querySpecs;
	};

	/**
  * @private
  * Build the chart-insights query spec
  * @param {Object} dssResponse - A json representation of the response from the main dss query.
  * @returns The chart-insights query spec (or null if the response is empty)
  */


	chartInsightsQuery.prototype._buildQuerySpecFromUnprocessedDSSResponse = function _buildQuerySpecFromUnprocessedDSSResponse(dssResponse, layerId) {
		if (dssResponse && dssResponse.data && layerId) {
			// NOTE: We should try to get DSS to add dataItemUniqueId's to nested data items, then we could simply use the response 'as-is'
			var querySpec = {
				data: {
					data: dssResponse.data,
					dataItems: this._getExecutionDataItemsDef(dssResponse.dataItems),
					hasNext: dssResponse.hasNext,
					version: dssResponse.version
				},
				params: this._getChartInsightsDictionary(layerId, dssResponse.version)
			};
			if (dssResponse.edges) {
				delete querySpec.data.dataItems;
				querySpec.data.edges = dssResponse.edges;
			}
			return querySpec;
		}
		return null;
	};

	chartInsightsQuery.prototype._runSmartsQuery = function _runSmartsQuery(querySpec, smartsService) {
		var options = {
			url: 'v1/predict/explorations/chart-insights',
			querySpec: querySpec,
			sender: 'getInsights'
		};
		return smartsService.runQuery(options).catch(function () {
			//Don't fail...just return no insights if a query fails.
			return [];
		});
	};

	/**
  * @private
  * @function _getExecutionDatapointsDef
  * Build the datapoints part of the execution query
  * @returns the datapoints part of the execution query spec
  */


	chartInsightsQuery.prototype._getExecutionDatapointsDef = function _getExecutionDatapointsDef(data) {
		//TODO: Following annotations but...is there anything in here other than pt?
		return data && data.map(function (row) {
			return {
				pt: row.pt
			};
		});
	};

	/**
  * @private
  * @function _getExecutionDataItemsDef
  * Build the dataitems part of the execution query
  * This is essentially equal to the result Data Items spec except that for nested items,
  * the 'hierarchy' definition needs to be augmented with the uniqueId of the dataItems in the 'h'
  * @returns the dataitems part of the execution query spec
  */


	chartInsightsQuery.prototype._getExecutionDataItemsDef = function _getExecutionDataItemsDef(dataItems) {
		var _this3 = this;

		return dataItems && dataItems.map(function (dataItem) {
			// Is the slot nested?
			return _this3._processResultDataItem(dataItem);
		});
	};

	//Process a single result data item (which could be a regular dataItem or a nested dataItem)
	//For non-nested dataItems, this is an identity function.
	//@returns a single result data item in the form needed by the chartInsights query.


	chartInsightsQuery.prototype._processResultDataItem = function _processResultDataItem(dataItem) {
		if (dataItem.itemClass.h.length > 1) {
			return this._processNestedResultDataItem(dataItem);
		}
		return dataItem;
	};

	//Process a single nested data item.
	//For chartInsights, the hierarchy entries for each item in the stacked resultDataItem need to include
	//the uniqueId of the dataItem (the normal queryResults don't include this)
	//@returns a single nested result data item in the form needed by the chartInsights Query.


	chartInsightsQuery.prototype._processNestedResultDataItem = function _processNestedResultDataItem(nestedDataItem) {
		var slots = this.widgetContentApi.getFeature('Visualization').getSlots();
		if (slots) {
			return {
				itemClass: {
					h: nestedDataItem.itemClass.h.map(function (header) {
						var dataItem = slots.getDataItemList().filter(function (dataitem) {
							return dataitem.getId() === header.id;
						});
						return {
							// inject the uniqueId
							id: dataItem[0].getId(),
							u: header.u,
							d: header.d
						};
					}),
					id: nestedDataItem.itemClass.id
				},
				items: nestedDataItem.items
			};
		}
		return nestedDataItem;
	};

	/**
  * @returns true if NLT is supported for this visualization/data configuration.
  *			false for visualizations that have no data (like comet or spiral) OR any othe unsupported cases (such as multi-measure)
  */


	chartInsightsQuery.prototype.chartInsightsQuerySupported = function chartInsightsQuerySupported() {
		var noDataQueryRequired = this.widgetContentApi.getFeature('Visualization').getDefinition().getProperty('noDataQuery');
		//Any visualization that has no data can't have nlt except those that declares use FPD request result as Insights inputs
		if (noDataQueryRequired && !this.useFPDAsInsightsInput()) {
			return false;
		}

		//There's no point in generating smartInsights for visualizations that don't have roles.
		var hasRolesDefined = this.widgetContentApi.getFeature('Visualization').getSlots().getMappedSlotList().some(function (slot) {
			return slot.getDefinition().getRole();
		});
		if (!hasRolesDefined) {
			return false;
		}

		//No checks have failed....the query is supported.
		return true;
	};

	chartInsightsQuery.prototype._containsOlap = function _containsOlap() {
		var visOlapQueryHelper = this.widgetContentApi.getFeature('Visualization.olapContentHelper');
		//We call an api "likelyContainsOlap" to ensure we don't add stats calculations for OLAP
		//OR for edge cases where calculations might contain OLAP in mixed packages
		//where we can't tell if the vis is OLAP or not from other items.
		return visOlapQueryHelper && visOlapQueryHelper.likelyContainsOlap();
	};

	//CALCULATIONS CASE: Calculations require each dataItem to be supplied as a calculation operand
	//					 (including stacked case)


	chartInsightsQuery.prototype.getChartInsightsCalculationArray = function getChartInsightsCalculationArray() {
		var _this4 = this;

		var annotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		this._buildRolesById(annotations);

		if (!this.chartInsightsQuerySupported()) {
			return annotations;
		} else if (this.useFPDAsInsightsInput() || this._containsOlap()) {
			//For charts that use FPD request results does not need build Calcualtion Array
			return [];
		}

		//Make a note of the dataItems that have calculations added to the query for
		//annotations or NLT insight types.
		var calculationItemsAlreadyAdded = {};

		var chartInsightsQueryParamsByLayer = {};

		var dataSourceId = this.dashboardApi.getActiveDataSourceId();
		var dataSource = this.widgetContentApi.getFeature('Visualization').getDataSource(dataSourceId);
		var dataItemSlotMappingInfo = this.widgetContentApi.getFeature('Visualization').getSlots().getMappingInfoList();

		dataItemSlotMappingInfo.forEach(function (dataItemSlotMapping) {
			var layerIds = dataItemSlotMapping.slot.getDefinition().getDatasetIdList();
			layerIds.forEach(function (layerId) {
				chartInsightsQueryParamsByLayer[layerId] = chartInsightsQueryParamsByLayer[layerId] || new _ChartInsightsQueryParams2.default(layerId);
				//If there is a role from the suggestion service, use it.  If there is a response role in the slot, we also need its calculations.
				var roleById = _this4.roleById[dataItemSlotMapping.dataItem.getId()] || dataItemSlotMapping.slot.getDefinition().getRole();
				var role = dataItemSlotMapping.slot.getDefinition().getRole() === 'response' ? 'response' : roleById;
				if (chartInsightsQueryParamsByLayer[layerId].addParam(dataItemSlotMapping.slot, dataItemSlotMapping.dataItem, false, role, dataSource)) {
					calculationItemsAlreadyAdded[dataItemSlotMapping.dataItem.getId()] = 1;
				}
			});
		});

		//Now, pass through the map, convert it to an array and make sure response is first and others are after for each entry.
		var chartInsightsCalculationArray = [];
		chartInsightsCalculationArray = chartInsightsCalculationArray.concat(annotations);
		for (var layerId in chartInsightsQueryParamsByLayer) {
			if (chartInsightsQueryParamsByLayer[layerId].hasParams()) {
				chartInsightsCalculationArray.push(chartInsightsQueryParamsByLayer[layerId].getParams());
			}
		}

		chartInsightsCalculationArray = chartInsightsCalculationArray.concat(this._addRowCountCalculationsForAverages(calculationItemsAlreadyAdded, dataItemSlotMappingInfo, dataSource));

		return chartInsightsCalculationArray;
	};

	//The compare table reports insights when the aggregation type of a measure is average.
	//Information such as the number of details that comprise the average of a chart or selection are reported in tooltips
	//These calculation results are also used to compute selection and summary weighted averages as well as combined averages.
	//This function Adds rowCount calculations to the DSS query (if not already added for use in smart annotations or NLT)
	//The Same rules and limitations are applied for adding these calculations (ie: not added for binned items or OLAP)


	chartInsightsQuery.prototype._addRowCountCalculationsForAverages = function _addRowCountCalculationsForAverages() {
		var calculationItemsAlreadyAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var dataItemSlotMappingInfo = arguments[1];
		var dataSource = arguments[2];

		var additionalCalculations = [];

		dataItemSlotMappingInfo.forEach(function (dataItemSlotMapping) {
			var layerIds = dataItemSlotMapping.slot.getDefinition().getDatasetIdList();
			layerIds.forEach(function (layerId) {
				var calcParams = new _ChartInsightsQueryParams2.default(layerId);
				var slotDefType = dataItemSlotMapping.slot.getDefinition().getType();
				var dataItemType = dataItemSlotMapping.dataItem.getType();
				var dataItemAggregateType = dataItemSlotMapping.dataItem.getAggregation();
				if ((slotDefType === 'ordinal' || dataItemType === 'fact' && slotDefType === 'any') && dataItemAggregateType === 'avg' && !calculationItemsAlreadyAdded[dataItemSlotMapping.dataItem.getId()]) {
					var dssRowCountCalculation = calcParams.addDSSRowCountCalculation(dataItemSlotMapping.slot, dataItemSlotMapping.dataItem, dataSource);
					if (dssRowCountCalculation) {
						additionalCalculations.push(dssRowCountCalculation);
					}
				}
			});
		});
		return additionalCalculations;
	};

	chartInsightsQuery.prototype._buildRolesById = function _buildRolesById(annotations) {
		var _this5 = this;

		this.roleById = {};
		annotations && annotations.forEach(function (annotation) {
			annotation.dataItems.forEach(function (dataItem, index) {
				_this5.roleById[dataItem] = annotation.roles[index];
			});
		});
	};

	//This helper function checks if the passed in Slot supports multimeasure series or not. The new Slot API does not have a way to do this, and LiveWiget uses a Helper class that is not exposed to us.


	chartInsightsQuery.prototype._isMultiMeasureSlot = function _isMultiMeasureSlot(slot) {
		var dataItemList = slot.getDataItemList();
		return !!dataItemList.find(function (dataItem) {
			return dataItem.getColumnId() == '_multiMeasuresSeries';
		});
	};
	//DICTIONARY CASE: 	For the dictionary, the id of the stacked item (not the dataItems that comprise it)
	//					should be shipped to the smarts query (since it matches the shape of the data)


	chartInsightsQuery.prototype._getChartInsightsDictionary = function _getChartInsightsDictionary(layerId, version) {
		var _this6 = this;

		var chartInsightsQueryParams = new _ChartInsightsQueryParams2.default(layerId, version);
		var dataItemSlotMappingInfo = this.widgetContentApi.getFeature('Visualization').getSlots().getMappingInfoList();
		var dataSourceId = this.dashboardApi.getActiveDataSourceId();
		var dataSource = this.widgetContentApi.getFeature('Visualization').getDataSource(dataSourceId);
		var dataSourceMoserApi = this.dashboardApi.getFeature('DataSources.moser').getModule(dataSourceId);

		dataItemSlotMappingInfo.forEach(function (dataItemSlotMapping) {
			var slot = dataItemSlotMapping.slot;
			//All dataItems in the same slot have the same role. (eg: explanatory or response)
			if (slot.getDefinition().getDatasetIdList().indexOf(layerId) !== -1 && !_this6._isMultiMeasureSlot(slot)) {
				chartInsightsQueryParams.addParam(dataItemSlotMapping.slot, dataItemSlotMapping.dataItem, true, /*role*/undefined, dataSource, dataSourceMoserApi);
			}
		});

		return { dictionary: chartInsightsQueryParams.getParams() };
	};

	return chartInsightsQuery;
}();

exports.default = chartInsightsQuery;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * The ChartInsightsQueryParams is used to hide the details of creating the parameters needed for NLT
 * both for addition to the data query and for the 'dictionary' section of the chart-insights query.
 */
var ChartInsightsQueryParams = function () {
	function ChartInsightsQueryParams(layerId, version) {
		_classCallCheck(this, ChartInsightsQueryParams);

		this.datasetId = layerId;
		this.version = version;

		this.dataItems = [];
		this.dataItemLabels = [];
		this.roles = [];
		this.dataItemsTypes = [];
		this.moduleAssetId = null;
		this.isShapedModule = false;
		this.tempModuleJSON = null;
	}

	/**
  * Add a new parameter to the set of parameters from the specified slot and dataItem sorting response items from all others.
  * @param slot - the slot (needed to determine the role and, when stacked, to supply the itemId for dictionary mode)
  * @param dataItem - the dataItem to add
  * @param isDictionary - when true, a nested slot will be added with the id of the slot...when false,
  *						the ids will always be the itemId of the dataItem.
  * @param dataSource - the dataSouce object will check if the source used is OLAP or not.
  */


	ChartInsightsQueryParams.prototype.addParam = function addParam(slot, dataItem, isDictionary, role, dataSource) {
		var dataSourceMoserApi = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

		role = role || slot.getDefinition().getRole();
		var isOlapPackage = false;
		if (dataSource && dataSource.isOlapPackage) {
			isOlapPackage = dataSource.isOlapPackage();
		}
		var isShapedModule = !!dataSourceMoserApi && !!dataSourceMoserApi.getShapingId();
		var tempModule = dataSourceMoserApi && dataSourceMoserApi.getTemporarySessionModuleJSON();
		var dataItemId = isDictionary && slot.isStacked() ? slot.getDefinition().getId() : dataItem.getId();
		if (!isDictionary && dataItem.getMetadataColumn() && dataItem.getMetadataColumn().isOlapColumn(isOlapPackage)) {
			//olap items can be sent to chart insights but do not include them in calculations.
			return false;
		}

		//Calculations should only be built on non-binned response items.
		//Dictionaries for the chartInsights request should include all roles.
		if (role === 'response') {
			if (isDictionary || !dataItem.getBinning()) {
				this.dataItems.push(dataItemId);
				this.dataItemLabels.push(dataItem.getLabel());
				this.dataItemsTypes.push(this._getDataItemType(dataItem));
				this.moduleAssetId = dataSource && dataSource.getAssetId();
				this.roles.push(role);
				return true;
			}
		} else if (isDictionary) {
			this.isShapedModule = isShapedModule;
			this.dataItems.push(dataItemId);
			this.dataItemLabels.push(dataItem.getLabel());
			this.dataItemsTypes.push(this._getDataItemType(dataItem));
			this.moduleAssetId = dataSource && dataSource.getAssetId();
			this.roles.push(role);
			this.tempModuleJSON = tempModule;
			return true;
		}
		return false;
	};

	/**
  * Add a calculation to the calculation array in the form expected by Live Widget for adding calculations to the DSS query.
  * NOTE: This function is not used in the chart-insights query to predict.
  * @param {Object} slot - the slot (needed to determine the role and, when stacked, to supply the itemId for dictionary mode)
  * @param {Object} dataItem - the dataItem to add
  * @param {Object} dataSource, the dataSource object, needed to determine if the soure is an OLAP package  or not.
  * @returns {Object} the new calculation in the form expected by Live Widget for adding to the query.
  */


	ChartInsightsQueryParams.prototype.addDSSRowCountCalculation = function addDSSRowCountCalculation(slot, dataItem, dataSource) {
		if (this.addParam(slot, dataItem, false, 'response', dataSource)) {
			return this.getParams(['rowCount']);
		}
		return null;
	};

	ChartInsightsQueryParams.prototype.hasParams = function hasParams() {
		return this.dataItems.length > 0 && this.roles.length > 0 || false;
	};

	ChartInsightsQueryParams.prototype._getDataItemType = function _getDataItemType(dataItem) {
		var dateTypes = ['datetime', 'time', 'date'];
		var metadata = dataItem.getMetadataColumn();
		var taxonomyList = metadata && metadata.getTaxonomyList();
		var itemDataType = dataItem.getType();
		if (dateTypes.indexOf(itemDataType) > -1 || taxonomyList && taxonomyList.length && taxonomyList[0].getClass() === 'cTime') {
			return 'datetime';
		} else if (itemDataType === 'attribute') {
			return 'categorical';
		} else if (itemDataType === 'fact') {
			return 'continuous';
		}
		return '';
	};

	/**
  * get the parameters needed both for the DSS query (to append calculations)
  * AND for the chart Insights dictionary (for the chart insights request).
  * @param {String[]} [reqStats] the calculations to add (by default, these are rowcount and sum of squares)
  * @returns {Object} the new calculation in the form expected by both Live Widget for adding to the DSS query
  *										AND for the dictionary section of the chart-insights query
  */


	ChartInsightsQueryParams.prototype.getParams = function getParams(reqStats) {
		var params = {
			shapedModule: this.isShapedModule,
			datasetId: this.datasetId,
			dataItems: this.dataItems,
			dataItemsTypes: this.dataItemsTypes,
			roles: this.roles,
			moduleAssetId: this.moduleAssetId,
			reqStats: reqStats || ['rowCount', 'sumSqr'],
			type: 'chartInsights'
		};

		if (this.isShapedModule) {
			params.tempModule = JSON.stringify(this.tempModuleJSON);
		}

		if (this.version === '2') {
			params.dataItemLabels = this.dataItemLabels;
		}

		return params;
	};

	return ChartInsightsQueryParams;
}();

exports.default = ChartInsightsQueryParams;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _MinMaxCollector = __webpack_require__(480);

var _MinMaxCollector2 = _interopRequireDefault(_MinMaxCollector);

var _MeasureIndex = __webpack_require__(481);

var _MeasureIndex2 = _interopRequireDefault(_MeasureIndex);

var _CrosshairsViewCtrl = __webpack_require__(482);

var _CrosshairsViewCtrl2 = _interopRequireDefault(_CrosshairsViewCtrl);

var _RenderCrosshairsStep = __webpack_require__(489);

var _RenderCrosshairsStep2 = _interopRequireDefault(_RenderCrosshairsStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


/**
 * The Crosshairs feature is used to collect data for and render crosshairs on a visualization.
 **/
var CrosshairsFeature = function () {
	function CrosshairsFeature(widgetApi, dashboardApi) {
		_classCallCheck(this, CrosshairsFeature);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.isNewQueryApiEnabled = this._isNewQueryApiEnabled();

		this._activated = false;

		this.measureIndexes = {};
		this.rangePercent = 5; //Points will be highlighted in a range that is rangePercent% of the domain wide.

		this.viewCtrl = new _CrosshairsViewCtrl2.default(this, widgetApi, dashboardApi);

		this._featureTags = [];
	}

	CrosshairsFeature.prototype.destroy = function destroy() {
		this.viewCtrl.destroy();
		this.viewCtrl = null;
	};

	CrosshairsFeature.prototype._isNewQueryApiEnabled = function _isNewQueryApiEnabled() {
		//TODO: This function can be removed when the feature flag is removed.
		return !this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'queryApi', 'disabled');
	};

	//Identify this feature as a plugin for the resultDataReaderPlugin and visEventHandler.
	//NOTE: See ResultDataReader and VisEventHandler for expected api's


	CrosshairsFeature.prototype.getFeatureTags = function getFeatureTags() {
		return this._featureTags;
	};

	CrosshairsFeature.prototype.getAPI = function getAPI() {
		return {
			//Host applications can use these api's to turn on/off crosshairs
			activate: this.activate.bind(this), //set up callbacks for synchronizing.
			deactivate: this.deactivate.bind(this),
			isActivated: this.isActivated.bind(this),
			isSupported: this.isSupported.bind(this),

			//ResultDataReader plugin api's
			onDataStart: this.onDataStart.bind(this),
			onDataRow: this.onDataRow.bind(this),
			onDataDone: this.onDataDone.bind(this),

			//Creating Popover specific API's
			getCrossHairMatchingPoints: this.getCrossHairMatchingPoints.bind(this),
			renderPopOver: this.renderPopOver.bind(this),

			//Crosshairs-specific api's
			getDataPoints: this.getDataPoints.bind(this),
			renderCrosshairs: this.renderCrosshairs.bind(this), //call used to 'render in synch'
			getOptimalLineValue: this.getOptimalLineValue.bind(this) // call used to get the line value for default position
		};
	};

	/**
  * @returns true if this visualization supports crosshairs
  */


	CrosshairsFeature.prototype.isSupported = function isSupported() {
		//NOTE: When changing visApi to visualizationApi, we should
		//implement a supportsDecoration on the new decorator api
		//so that we can get this information directly from vipr.
		var visId = this.widgetApi.getVisId();

		var supportedVisTypes = ['com.ibm.vis.rave2bundlearea', 'com.ibm.vis.rave2bundlebar', 'com.ibm.vis.rave2bundlecolumn', 'com.ibm.vis.rave2bundlestackedbar', 'com.ibm.vis.rave2bundlestackedcolumn', 'com.ibm.vis.rave2line', 'com.ibm.vis.rave2point', 'com.ibm.vis.rave2bundlewaterfall'];

		return supportedVisTypes.some(function (supportedVisType) {
			return supportedVisType === visId;
		});
	};

	CrosshairsFeature.prototype.isActivated = function isActivated() {
		return this._activated;
	};

	CrosshairsFeature.prototype.activate = function activate() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		//When activated, this feature will be executed as a plugin to the ResultsDataReader render sequence task
		//(to cross-reference datapoints with measure values)
		this._activated = true;
		this._featureTags = ['ResultDataReaderPlugin'];
		this.viewCtrl.activate(options);
	};

	CrosshairsFeature.prototype.deactivate = function deactivate() {
		//When activated, this feature will be executed as a plugin to the ResultsDataReader render sequence task
		//(to cross-reference datapoints with measure values)
		this._activated = false;
		this.viewCtrl.deactivate();
	};

	/**
  * Process Query result based on the passed options to constructor.
  * For instance, limit the rows of DataPoints so that in the response, for
  * specified dataitem, 'product', there will be only three tuples returned
  *
  * @returns A promise which resolves with the resulting statistics. (This will be useful to be symmetrical with the query promise for totals).
  */


	CrosshairsFeature.prototype.onDataStart = function onDataStart(queryResultsData, rowHeaders) {
		var _this = this;

		this.queryResultsData = queryResultsData;

		//We use a minMax collector to collect min/max for each measure.
		this.minMaxCollector = new _MinMaxCollector2.default();
		this.minMaxCollector.reset();

		this.valueSlotMeasureCount = rowHeaders.valueSlotMeasureCount;
		this.measureItemHeaders = rowHeaders.measureItemHeaders;
		this.categoryItemHeaders = rowHeaders.categoryItemHeaders;

		this.measureItemHeaders.forEach(function (measureItemHeader) {
			_this.measureIndexes[measureItemHeader.dataItemUniqueId] = new _MeasureIndex2.default(measureItemHeader.dataItemUniqueId);
		});
	};

	CrosshairsFeature.prototype.onDataRow = function onDataRow(rowIdx) {
		var _this2 = this;

		var rowMinMaxEntries = [];
		this.measureItemHeaders.forEach(function (measureItemHeader) {
			var minMaxEntry = _this2.minMaxCollector.getMinMaxEntry(measureItemHeader.dataItemUniqueId);
			var value = _this2._getCellValue(_this2.queryResultsData, rowIdx + measureItemHeader.valueItemIndex, measureItemHeader.index) || 0;
			_this2.minMaxCollector.updateMinMaxEntry(minMaxEntry, value);
			rowMinMaxEntries.push({ dataItemUniqueId: measureItemHeader.dataItemUniqueId, value: value });
		});

		this._saveMeasureValuesForRow(rowIdx, rowMinMaxEntries);
	};

	CrosshairsFeature.prototype.onDataDone = function onDataDone() {};

	CrosshairsFeature.prototype.getCrossHairMatchingPoints = function getCrossHairMatchingPoints() {
		var _viewCtrl;

		if (!this.viewCtrl) {
			// destroyed
			return;
		}
		return (_viewCtrl = this.viewCtrl).getCrossHairMatchingPoints.apply(_viewCtrl, arguments);
	};

	CrosshairsFeature.prototype.renderPopOver = function renderPopOver() {
		var _viewCtrl2;

		if (!this.viewCtrl) {
			// destroyed
			return;
		}
		return (_viewCtrl2 = this.viewCtrl).renderPopOver.apply(_viewCtrl2, arguments);
	};

	/**
  * returns the data points that are associated with the given dataItemUniqueId for this measure (ordinal)
  * @param measureDataItemUniqueId - the dataItemUniqueId of the measure (ordinal) we're rendering crosshairs for
  * @param measureValue - the value we want associated DataPoints for.
  * @returns the set of DataPoints that are associated with this measurevalue.
  */


	CrosshairsFeature.prototype.getDataPoints = function getDataPoints(measureDataItemUniqueId, measureValue) {
		var points = [];
		var thisMeasureIndex = this.measureIndexes[measureDataItemUniqueId];
		var minMaxEntry = this.minMaxCollector.getMinMaxEntry(measureDataItemUniqueId);
		if (!thisMeasureIndex || !minMaxEntry) {
			return points;
		}

		var valueRange = (minMaxEntry.maxUse - minMaxEntry.minUse) * (this.rangePercent / 100);

		return thisMeasureIndex.getEntries(measureValue, valueRange);
	};

	//Process the categorical items in a row returning their values as an array... eg [2005, Camping, Fax]


	CrosshairsFeature.prototype.getRowTuple = function getRowTuple(rowIdx) {
		var _this3 = this;

		var tuple = [];
		this.categoryItemHeaders.columnIndexes.forEach(function (columnIndex) {
			//Note: getValue returns the tuple of categorical values at that cell index for stacked items.
			tuple = tuple.concat(_this3._getCellValueObject(_this3.queryResultsData, rowIdx, columnIndex));
		});
		return tuple;
	};

	//TODO: Remove this function when  isNewQueryApiEnabled is removed.


	CrosshairsFeature.prototype._getCellValueObject = function _getCellValueObject(queryResult, row, column) {
		return this.isNewQueryApiEnabled ? queryResult.getValue(row, column) : queryResult.getCellValue(row, column);
	};

	//TODO: Remove this function when  isNewQueryApiEnabled is removed.


	CrosshairsFeature.prototype._getCellValue = function _getCellValue(queryResult, row, column) {
		var cellValueObject = this._getCellValueObject(queryResult, row, column);
		if (this.isNewQueryApiEnabled) {
			return cellValueObject && cellValueObject.getValue ? cellValueObject.getValue() : cellValueObject.value;
		} else {
			return cellValueObject && cellValueObject.getValue ? cellValueObject.getValue() : cellValueObject.v;
		}
	};

	CrosshairsFeature.prototype.getItemValue = function getItemValue(rowIdx, dataItemUniqueId) {
		return this.measureIndexes[dataItemUniqueId] && this.measureIndexes[dataItemUniqueId].getValue(rowIdx);
	};

	CrosshairsFeature.prototype._saveMeasureValuesForRow = function _saveMeasureValuesForRow(rowIdx, rowMinMaxEntries) {
		var _this4 = this;

		//for each row, if the categorical tuple for that row is selected, add it to selection minMax.
		if (this.measureIndexes) {
			rowMinMaxEntries.forEach(function (rowMinMaxEntry) {
				var thisMeasureIndex = _this4.measureIndexes[rowMinMaxEntry.dataItemUniqueId];
				thisMeasureIndex.add(rowIdx, rowMinMaxEntry.value);
			});
		}
	};

	//TODO: If we ever support crosshairs on multi-layer charts, we'll need to do this differently.


	CrosshairsFeature.prototype.getItemToDecorate = function getItemToDecorate() {
		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var mappingInfoList = content.getFeature('Visualization').getSlots().getMappingInfoList();
		var ordinalDataItemAPI = mappingInfoList.find(function (item) {
			return item.slot.getDefinition().getType() === 'ordinal';
		});
		if (ordinalDataItemAPI) {
			var ordinalSlotIndex = content.getFeature('Visualization').getSlots().getMappedSlotList().findIndex(function (slotAPI) {
				return slotAPI.getDefinition().getType() === 'ordinal';
			});

			return {
				itemIndex: ordinalSlotIndex,
				sourceItemUniqueId: ordinalDataItemAPI.dataItem.getId(),
				itemId: ordinalDataItemAPI.dataItem.getColumnId(),
				format: ordinalDataItemAPI.dataItem.getFormat()
			};
		}
	};

	/**
 * Return the feature extra render sequence steps
 */


	CrosshairsFeature.prototype.getExtraRenderSequenceSteps = function getExtraRenderSequenceSteps() {
		return [{
			id: 'renderVisCrosshairs',
			dependencies: ['render'],
			module: _RenderCrosshairsStep2.default,
			moduleOptions: {
				visCrosshairFeature: this
			}
		}];
	};

	/**
  * gets the optimal line value
  * if the previous value is still within range of current measure's range, we use the previous value of the line (eg. a render from resizing) 
  * otherwise we will calculate an optimal value from min max collector by taking the average between min and max
  * @return {number} optimalValue
  */


	CrosshairsFeature.prototype.getOptimalLineValue = function getOptimalLineValue() {
		var itemToDecorate = this.getItemToDecorate();
		var previousValue = this.viewCtrl.getPreviousValue();
		var optimalValue = void 0;
		if (itemToDecorate) {
			var itemUniqueId = itemToDecorate.sourceItemUniqueId;
			if (this.minMaxCollector && this.minMaxCollector.minMaxTable && this.minMaxCollector.minMaxTable[itemUniqueId]) {
				var itemStat = this.minMaxCollector.minMaxTable[itemUniqueId];
				// if the previous value is still within range of current measure's range, we use the previous value of the line (eg. a render from resizing)
				// otherwise we will calculate an optimal value from min max collector by taking the average between min and max
				// this case of defined previous value can be hit when 
				// a) user drag the compare line to xx value, then toggle to hide and toggle to show compare line
				// b) user changes the data in the vis (eg. apply filters, top bottom, properties)
				if ((previousValue || previousValue === 0) && previousValue <= itemStat.maxUse && previousValue >= itemStat.minUse) {
					optimalValue = previousValue;
				} else {
					// default to the middle of the range for easier discovery of the compare line
					optimalValue = (itemStat.maxUse + itemStat.minUse) / 2;
				}
			}
		}
		return optimalValue;
	};

	/**
  * renderCrosshairs at the specified value (for now, the value is single dimension)
  * @param {number} value - the measure value to render the crosshairs at.
  */


	CrosshairsFeature.prototype.renderCrosshairs = function renderCrosshairs(value) {
		if (!this.viewCtrl) {
			// destroyed
			return Promise.resolve();
		}
		var optimalValue = value;
		// when value is falsy but not zero, calculate an optimal value to make sure the value is within the range.
		// The optimal value will be previous value if previous value is defined and still within the range
		if (!(value || value === 0)) {
			optimalValue = this.getOptimalLineValue();
		}
		if (this.isSupported() && this.isActivated()) {
			return this.viewCtrl.renderCrosshairs(optimalValue);
		} else {
			// clear crosshairs since the new vis type no longer supports and the value is set as previous value so we can clear highlights next time
			this.viewCtrl.clearCrosshairs();
			this.viewCtrl.setPreviousValue(optimalValue);
			return;
		}
	};

	return CrosshairsFeature;
}();

exports.default = CrosshairsFeature;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * The MinMaxCollector is used to find minimums and maximums based on one or more values for one or more measures.
 * The table it owns is keyed one per measure item.
 **/
var MinMaxCollector = function () {
	/**
  * @Constructor
  * @param {Object} options
  */
	function MinMaxCollector() {
		_classCallCheck(this, MinMaxCollector);

		this.minMaxTable = {};
	}

	/**
  * Clear out the minMaxTable for starting a new pass through the data.
  */


	MinMaxCollector.prototype.reset = function reset() {
		this.minMaxTable = {};
	};

	/**
  * get the minmax entry for the passed key (or add a new minmaxEntry)
  * @param dataItemUniqueId - the id of the dataItem to return the minMaxEntry for.
  * @returns the minmax entry.
  */


	MinMaxCollector.prototype.getMinMaxEntry = function getMinMaxEntry(dataItemUniqueId) {
		if (!this.minMaxTable[dataItemUniqueId]) {
			this._initializeMinMaxEntry(dataItemUniqueId);
		}
		return this.minMaxTable[dataItemUniqueId];
	};

	/**
  * incorporate a single value into the minmax
  * @param minmaxEntry - the minmaxEntry of interest
  * @param value - the value to incorporate
  */


	MinMaxCollector.prototype.updateMinMaxEntry = function updateMinMaxEntry(minmaxEntry, value) {
		if (minmaxEntry.maxUse === undefined || minmaxEntry.maxUse < value) {
			minmaxEntry.maxUse = value;
		}
		if (minmaxEntry.minUse === undefined || minmaxEntry.minUse > value) {
			minmaxEntry.minUse = value;
		}
	};

	/**
  * add a new minmaxItemEntry to the minMaxTable.
  * @param itemKey - the key (unique to this measure)
  * @param dataItemUniqueId - the uniqueId of the dataItem.
  */


	MinMaxCollector.prototype._initializeMinMaxEntry = function _initializeMinMaxEntry(dataItemUniqueId) {
		this.minMaxTable[dataItemUniqueId] = {
			dataItemUniqueId: dataItemUniqueId
		};
	};

	return MinMaxCollector;
}();

exports.default = MinMaxCollector;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * A MeasureIndex stores a cross-reference between measure values for a particular measure dataItem
 * and the row(s) where they occur.  It is implemented as an array so that there can be duplicates (ie: 10 occurrences of 1000 means 10 index entries)
 *
 **/
var MeasureIndex = function () {
	/**
  * @Constructor
  * @param {Object} options
  */
	function MeasureIndex(measureDataItemUniqueId) {
		_classCallCheck(this, MeasureIndex);

		this.measureDataItemUniqueId = measureDataItemUniqueId;
		this.measureIndex = [];
	}

	/**
  * Clear out the minMaxTable to collect new stats.
  */


	MeasureIndex.prototype.reset = function reset() {
		this.measureIndex = [];
	};

	MeasureIndex.prototype.getValue = function getValue(rowIdx) {
		return this.measureIndex[rowIdx] && this.measureIndex[rowIdx].v;
	};

	/**
  * get an array of all entries in the measure index that have value +/- range/2
  *
  * TODO: So far, getEntries appears to perform well with no performance optimizations, however;
  *		if performance becomes an issue, the array could be sorted and recent value to index could be stored to make retrieval very fast.
  * @returns an array of value to row object that match the value +/- range/2
  */


	MeasureIndex.prototype.getEntries = function getEntries(value, range) {
		var minValue = value - range / 2;
		var maxValue = value + range / 2;
		return this.measureIndex.filter(function (indexEntry) {
			return indexEntry.v >= minValue && indexEntry.v <= maxValue;
		});
	};

	/**
  * Add a single value/row cross-reference to the measureIndex.
  * @param row - the row# from the queryResults.
  * @param value - the measure value to incorporate
  */


	MeasureIndex.prototype.add = function add(row, value) {
		this.measureIndex.push({ v: value, r: row });
	};

	return MeasureIndex;
}();

exports.default = MeasureIndex;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CrosshairsPopOver = __webpack_require__(483);

var _CrosshairsPopOver2 = _interopRequireDefault(_CrosshairsPopOver);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


/**
 * The Crosshairs view controller is used to interact with the liveWidget view
 * and event handlers.
 **/
var lineColor = '#C0BFC0'; //The lineColor as specified by UE.

var CrosshairsViewCtrl = function () {
	function CrosshairsViewCtrl(feature, widgetApi, dashboardApi) {
		_classCallCheck(this, CrosshairsViewCtrl);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.feature = feature;

		//Any callbacks registered with activate will be called on move.
		this._onMoveCrosshairsHandlers = [];

		//Internal handlers
		this._widgetApiOnMoveListener = null;
	}

	/**
  * Any user of this feature can register a callback which will be called when the crosshairs move.
  * The callback will receive a payload that includes:
  *		- the widgetApi,
  *		- the value that the crosshair has been moved to
  *		- whether the mouse is down or not (ie: dragging)
  * @param options - an object that contains (currently) 1 callback  'cbOnMoveCrosshairs'
  */


	CrosshairsViewCtrl.prototype.activate = function activate(options) {
		options && this._onMoveCrosshairsHandlers.push(options.cbOnMoveCrosshairs);
		if (!this._widgetApiOnMoveListener) {
			this._widgetApiOnMoveListener = this.widgetApi.on('visevent:onmove', this.onMove, this);
		}
	};

	/**
  * API which implements "turn off crosshairs" (by making the feature stop listening to the onMove event.)
  * This api also must "unrender the existing crosshair" (ie: clearCrosshairs()).
  */


	CrosshairsViewCtrl.prototype.deactivate = function deactivate() {
		if (this._widgetApiOnMoveListener) {
			this._widgetApiOnMoveListener.remove();
			this._widgetApiOnMoveListener = null;
		}
		return this.clearCrosshairs();
	};

	CrosshairsViewCtrl.prototype.destroy = function destroy() {
		this._onMoveCrosshairsHandlers = [];
		this.deactivate();
	};

	//VIEW methods (render support) ==========================================


	CrosshairsViewCtrl.prototype.onMove = function onMove(payload) {
		return this._onMove(payload.event, payload.target, payload.items, payload.mouseDown || payload.onHold);
	};

	CrosshairsViewCtrl.prototype._onMove = function _onMove(event, target, chartItems, mouseDown) {
		var _this = this;

		this._isDragging = mouseDown ? this._isDragging : false;
		var isGrabbingCompareLine = this._isDragging;
		// if we are about drag, check the event target is on the compare line
		if (mouseDown && !this._isDragging) {
			// Find if the event target's closest parent is the compare line. 
			// closest function is similar to jQuery $.closest()
			var closest = function closest(el, fn) {
				return el && (fn(el) ? el : closest(el.parentNode, fn));
			};
			closest(event.target, function (el) {
				var className = el.getAttribute && el.getAttribute('class');
				isGrabbingCompareLine = isGrabbingCompareLine || className && className.indexOf('lineDecorations') > -1;
				return isGrabbingCompareLine;
			});
		}

		if (target && target.getValuesAtPoint && isGrabbingCompareLine) {
			this._isDragging = true;
			/* offset is a pixel offset to ensure line is drawn slightly above/right of the pointer so that selection can still be done */
			var axisItemsAtPoint = target.getValuesAtPoint(event, 3 /*offset*/);
			var contField = axisItemsAtPoint && axisItemsAtPoint.find(function (axisItem) {
				return axisItem.type === 'cont';
			});
			if (contField && contField.value) {
				var value = contField.value;
				this._onMoveCrosshairsHandlers.forEach(function (onMoveCrosshairsHandler) {
					onMoveCrosshairsHandler({ widgetApi: _this.widgetApi, value: value, mouseDown: mouseDown });
				});
				return this.feature.renderCrosshairs(value);
			}
		}
		return Promise.resolve({});
	};

	/**
  * renderCrosshairs at the specified value (for now, the value is single dimension)
  * TODO: need to complete this part when vida story is implemented.
  * @param value - the measure value to render the crosshairs at.
  */


	CrosshairsViewCtrl.prototype.renderCrosshairs = function renderCrosshairs(value) {
		var _this2 = this;

		var decoratorAPIs = this.widgetApi.getVisApi().getDecoratorAPIs();
		if (!decoratorAPIs || !decoratorAPIs.length) {
			return Promise.resolve({});
		}
		decoratorAPIs.forEach(function (decoratorAPI) {
			_this2._decorateDataPointsNearCrosshairs(decoratorAPI, value);
		});
		//Note: Any decoratorAPI can be used to update decorations.
		return decoratorAPIs[0].updateDecorations();
	};

	CrosshairsViewCtrl.prototype.clearCrosshairs = function clearCrosshairs() {
		var _this3 = this;

		var pointsCleared = null;
		var decoratorAPIs = this.widgetApi.getVisApi().getDecoratorAPIs();
		if (!decoratorAPIs || !decoratorAPIs.length) {
			return Promise.resolve({});
		}

		var itemToClearDecorations = this.feature.getItemToDecorate();
		if (itemToClearDecorations) {
			if (typeof this._prevValue !== 'undefined') {
				decoratorAPIs.forEach(function (decoratorAPI) {
					pointsCleared = _this3._decoratePoints(decoratorAPI, itemToClearDecorations, _this3._prevValue, false);
					decoratorAPI.decorateItem(itemToClearDecorations.itemIndex, 'baseLines', null);
				});
			}
		}
		// the previous value is not cleared so we can reuse it if user toggles the show/hide compare line
		//Note: Any decoratorAPI can be used to update decorations.
		return pointsCleared ? decoratorAPIs[0].updateDecorations() : Promise.resolve({});
	};

	CrosshairsViewCtrl.prototype.getPreviousValue = function getPreviousValue() {
		return this._prevValue;
	};

	CrosshairsViewCtrl.prototype.setPreviousValue = function setPreviousValue(value) {
		this._prevValue = value;
	};

	//Read the result datapoints that are within the threshold and highlight the corresponding visualization datapoints.


	CrosshairsViewCtrl.prototype._decorateDataPointsNearCrosshairs = function _decorateDataPointsNearCrosshairs(decoratorAPI, value) {
		value = value || 0;

		var itemToDecorate = this.feature.getItemToDecorate();

		var pointsCleared = null;
		var pointsDecorated = null;
		if (itemToDecorate) {
			if (this._prevValue) {
				pointsCleared = this._decoratePoints(decoratorAPI, itemToDecorate, this._prevValue, false);
			}
			pointsDecorated = this._decoratePoints(decoratorAPI, itemToDecorate, value, true);

			var Formatter = this.widgetApi.getVisApi().getFormatter();
			var formatSpec = itemToDecorate.format;
			var vaneCaption = formatSpec ? Formatter.format(value, formatSpec) : (Math.round(value * 100) / 100).toString();
			decoratorAPI.decorateItem(itemToDecorate.itemIndex, 'baseLines', {
				baseLine: { position: value, color: lineColor },
				grabber: { positionType: 'BEGIN' },
				vane: { caption: vaneCaption }
			});
		}
		this._prevValue = value;
		return pointsCleared || pointsDecorated;
	};

	/**
  * @return {Array} Returns a nested array of captions for the values from moving the compare line.
  * Return value format: [[point1, value1], [point2, value2]
  */


	CrosshairsViewCtrl.prototype.getCrossHairMatchingPoints = function getCrossHairMatchingPoints(value) {
		var _this4 = this;

		var itemToDecorate = this.feature.getItemToDecorate();
		var decoratorAPIs = this.widgetApi.getVisApi().getDecoratorAPIs();
		var pointsDecorated = null;
		var captionPoints = [];
		var captionArray = [];
		if (!decoratorAPIs || !decoratorAPIs.length) {
			return captionArray;
		}
		if (itemToDecorate) {
			pointsDecorated = this._decoratePoints(decoratorAPIs[0], itemToDecorate, value, true);
		}
		if (pointsDecorated && pointsDecorated.length) {
			var Formatter = this.widgetApi.getVisApi().getFormatter();
			var formatSpec = itemToDecorate.format;

			captionPoints = pointsDecorated;

			captionPoints.forEach(function (arrayEntry) {
				var value = _this4.feature.getItemValue(arrayEntry.r, itemToDecorate.sourceItemUniqueId);
				captionArray.push(_this4._addCaption(arrayEntry.r, value, Formatter, formatSpec));
			});
		}
		return captionArray;
	};

	/**
  * Renders a popover with the given parameters when called.
  * @param {Object} crossHairInfo - the info to show inside the popover
  * @param {Object} renderNode - the node to render the popover to
  * @param {Number} totalItems - the number of rows in the popover
  * @param {Boolean} footerinfo.showFooter - true to show footer, false to hide footer
  * @param {Number} footerinfo.footerHeight - height of the footer
  * @param {Object} containerNode - the container node that the popover will be limited to
  */


	CrosshairsViewCtrl.prototype.renderPopOver = function renderPopOver(crossHairInfo, renderNode, totalItems, footerInfo, containerNode) {
		renderNode && _reactDom2.default.render(_react2.default.createElement(_CrosshairsPopOver2.default, { crossHairInfo: crossHairInfo, totalItems: totalItems, footerInfo: footerInfo, containerNode: containerNode }), renderNode);
	};

	//Given a valuesArrayEntry (of form { value: value, row: rowIdx} ),
	//return the tuple at that row and its formatted value as an array of length 2.


	CrosshairsViewCtrl.prototype._addCaption = function _addCaption(row, value, Formatter, formatSpec) {
		var tuple = this.feature.getRowTuple(row);
		var tupleDisplayValues = tuple && tuple.map(function (tuplePart) {
			return tuplePart.d;
		}) || [];
		var valueStr = formatSpec ? Formatter.format(value, formatSpec) : value;
		return [tupleDisplayValues.join(' | '), valueStr];
	};

	//Set the highlighted decoration on the specified datapoints in the visualization.


	CrosshairsViewCtrl.prototype._decoratePoints = function _decoratePoints(decoratorDataSet, itemToDecorate, value, highlightValue) {
		var dataPointsToHighlight = this.feature.getDataPoints(itemToDecorate.sourceItemUniqueId, value);
		dataPointsToHighlight.forEach(function (dataPointToHighlight) {
			decoratorDataSet.decoratePoint(dataPointToHighlight.r, 'highlighted', highlightValue);
		});
		return dataPointsToHighlight;
	};

	return CrosshairsViewCtrl;
}();

exports.default = CrosshairsViewCtrl;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019, 2021
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baUiCarbonToolkit = __webpack_require__(4);

var _resizePanel_ = __webpack_require__(484);

var _resizePanel_2 = _interopRequireDefault(_resizePanel_);

var _mobxReact = __webpack_require__(3);

var _StringResources = __webpack_require__(485);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(487);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESIZE_OFFSET = 2;
var MOVE_STEP = 5;
var HANDLE_BAR_HEIGHT = 10;
var TOP_PADDING = 8;
var ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'];

/*
 * The CrosshairsPopOver is a resizable, movable popover
 * It provides information about matching data points if used with the compare line
 * This component can also be used indepently to display data provided to it.
*/

var CrosshairsPopOver = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CrosshairsPopOver, _Component);

	function CrosshairsPopOver(props) {
		_classCallCheck(this, CrosshairsPopOver);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.mouseDown = function (e) {
			_this.onMouseDown(e);
		};

		_this.mouseUp = function (e) {
			_this.onMouseUp(e);
		};

		_this.mouseMove = function (e) {
			_this.onMouseMove(e);
		};

		_this.mouseLeave = function (e) {
			_this.onMouseLeave(e);
		};

		_this.touchStart = function (e) {
			_this.onTouchStart(e);
		};

		_this.touchMove = function (e) {
			_this.onTouchMove(e);
		};

		_this.touchEnd = function (e) {
			_this.onTouchEnd(e);
		};

		_this.resizeStartMouse = function (e) {
			_this.onResizeStart(e);
		};

		_this.resizeMoveMouse = function (e) {
			_this.onResizeMove(e);
		};

		_this.resizeStopMouse = function (e) {
			_this.onResizeStop(e);
		};

		_this.resizeStartTouch = function (e) {
			_this.onTouchResizeStart(e);
		};

		_this.resizeMoveTouch = function (e) {
			_this.onTouchResizeMove(e);
		};

		_this.resizeStopTouch = function (e) {
			_this.onTouchResizeStop(e);
		};

		_this.onKeySelect = function (e) {
			_this.onKeyDown(e);
		};

		_this.state = {
			x: 0, y: 0,
			dragging: false,
			resizing: false,
			footerItemsVisible: 2
		};
		_this.footerHeight = _this.props.footerInfo.footerHeight;
		_this.containerNode = _this.props.containerNode;

		_this.popover = _react2.default.createRef();
		_this.handle = _react2.default.createRef();
		_this.crossHairInfo = _react2.default.createRef();
		return _this;
	}

	CrosshairsPopOver.prototype.onStart = function onStart(e) {
		this.element = this.popover.current;
		var box = this.element.getBoundingClientRect();
		this.setState({
			x: e.pageX,
			y: e.pageY,
			relX: e.pageX - box.left,
			relY: e.pageY - box.top
		});
	};

	// Mouse move events


	CrosshairsPopOver.prototype.onMouseDown = function onMouseDown(e) {
		if (e.button !== 0) return;
		this.setState({ dragging: true });
		this.onStart(e);
		this.containerNode && this.containerNode.addEventListener('mousemove', this.mouseMove);
		this.containerNode && this.containerNode.addEventListener('mouseup', this.mouseUp);
		this.containerNode && this.containerNode.addEventListener('mouseleave', this.mouseLeave);
		e.preventDefault();
	};

	CrosshairsPopOver.prototype.onMouseUp = function onMouseUp(e) {
		this.setState({ dragging: false });
		this.containerNode && this.containerNode.removeEventListener('mousemove', this.mouseMove);
		this.containerNode && this.containerNode.removeEventListener('mouseup', this.mouseUp);
		this.containerNode && this.containerNode.removeEventListener('mouseleave', this.mouseLeave);
		e.preventDefault();
	};

	CrosshairsPopOver.prototype.onMouseMove = function onMouseMove(e) {
		if (this.state.dragging) {
			this.onMove(e);
			e.preventDefault();
		}
	};

	CrosshairsPopOver.prototype.onMouseLeave = function onMouseLeave(e) {
		this.onMouseUp(e);
		e.preventDefault();
	};

	CrosshairsPopOver.prototype.onMove = function onMove(e) {
		var x = e.pageX;
		var y = e.pageY;
		var diffX = x - this.state.x;
		var diffY = y - this.state.y;

		if (x !== this.state.x || y !== this.state.y) {
			this.setState({ x: x, y: y });
			var element = this.element;
			if (this._isBound(element, diffX, diffY)) {
				element.style.left = element.offsetLeft + diffX + 'px';
				element.style.top = element.offsetTop + diffY + 'px';
			}
		}
	};

	// Touch move events


	CrosshairsPopOver.prototype.onTouchStart = function onTouchStart(e) {
		this.setState({ dragging: true });
		this.onStart(e.touches[0]);
		this.containerNode && this.containerNode.addEventListener('touchmove', this.touchMove);
		this.containerNode && this.containerNode.addEventListener('touchend', this.touchEnd);
		e.preventDefault();
	};

	CrosshairsPopOver.prototype.onTouchMove = function onTouchMove(e) {
		if (this.state.dragging) {
			this.onMove(e.touches[0]);
			e.preventDefault();
			e.stopPropagation();
		}
	};

	CrosshairsPopOver.prototype.onTouchEnd = function onTouchEnd(e) {
		this.setState({ dragging: false });
		this.containerNode && this.containerNode.removeEventListener('touchmove', this.touchMove);
		this.containerNode && this.containerNode.removeEventListener('touchend', this.touchEnd);
		e.preventDefault();
	};

	// Resize mouse events


	CrosshairsPopOver.prototype.onResizeStart = function onResizeStart(e) {
		if (e.button !== 0) return;
		this.setState({ resizing: true });
		this.onStart(e);
		this.containerNode && this.containerNode.addEventListener('mousemove', this.resizeMoveMouse);
		this.containerNode && this.containerNode.addEventListener('mouseup', this.resizeStopMouse);
		this.containerNode && this.containerNode.addEventListener('mouseleave', this.resizeStopMouse);
		e.preventDefault();
		e.stopPropagation();
	};

	CrosshairsPopOver.prototype.onResizeMove = function onResizeMove(e) {
		this.resizeBox(e, false);
	};

	//Resizes the popover to fit into current view when view is resized.


	CrosshairsPopOver.prototype.resizeBox = function resizeBox(e, isTouchEvent) {
		var event = isTouchEvent ? e.touches[0] : e;
		if (this.state.resizing) {
			var crossHairInfo = this.crossHairInfo;
			var element = this.element;
			var x = event.pageX;
			var y = event.pageY;
			var diffX = x - this.state.x;
			var diffY = y - this.state.y;
			var horizontalOffset = diffX - RESIZE_OFFSET;
			var verticalOffset = diffY - RESIZE_OFFSET;
			if (x !== this.state.x || y !== this.state.y) {
				this.setState({ x: x, y: y });
				if (this._isBoundDuringResize(element, horizontalOffset, verticalOffset)) {
					element.style.width = element.offsetWidth + horizontalOffset + 'px';
					element.style.height = element.offsetHeight + verticalOffset + 'px';
					crossHairInfo.current.style.height = element.offsetHeight - (HANDLE_BAR_HEIGHT + TOP_PADDING + this.footerHeight + RESIZE_OFFSET) + 'px';
					if (this.props.footerInfo.showFooter) {
						this._calculateVisibleItemsOnResize();
					}
				}
			}
			e.preventDefault();
		}
	};

	CrosshairsPopOver.prototype.onResizeStop = function onResizeStop(e) {
		this.setState({ resizing: false });
		this.containerNode && this.containerNode.removeEventListener('mousemove', this.resizeMoveMouse);
		this.containerNode && this.containerNode.removeEventListener('mouseup', this.resizeStopMouse);
		this.containerNode && this.containerNode.removeEventListener('mouseleave', this.resizeStopMouse);
		e.preventDefault();
	};

	// Resize touch events


	CrosshairsPopOver.prototype.onTouchResizeStart = function onTouchResizeStart(e) {
		this.setState({ resizing: true });
		this.onStart(e.touches[0]);
		this.containerNode && this.containerNode.addEventListener('touchmove', this.resizeMoveTouch, { passive: false });
		this.containerNode && this.containerNode.addEventListener('touchend', this.resizeStopTouch, { passive: false });
		e.preventDefault();
		e.stopPropagation();
	};

	CrosshairsPopOver.prototype.onTouchResizeMove = function onTouchResizeMove(e) {
		this.resizeBox(e, true);
	};

	CrosshairsPopOver.prototype.onTouchResizeStop = function onTouchResizeStop(e) {
		this.setState({ resizing: false });
		this.containerNode && this.containerNode.removeEventListener('touchmove', this.resizeMoveTouch, { passive: false });
		this.containerNode && this.containerNode.removeEventListener('touchend', this.resizeStopTouch, { passive: false });
		e.preventDefault();
	};

	// Move key press events


	CrosshairsPopOver.prototype.onKeyDown = function onKeyDown(e) {
		var element = this.element ? this.element : this.popover.current;
		var reduceOffset = -(MOVE_STEP + RESIZE_OFFSET);
		var increaseOffset = MOVE_STEP - RESIZE_OFFSET;
		var crossHairInfo = this.crossHairInfo;
		switch (e.key) {
			case 'ArrowUp':
				if (e.shiftKey) {
					if (this._isBoundDuringResize(element, 0, reduceOffset)) {
						element.style.height = element.offsetHeight + reduceOffset + 'px';
					}
				} else {
					if (this._isBound(element, 0, -MOVE_STEP)) {
						element.style.top = element.offsetTop - MOVE_STEP + 'px';
					}
				}
				break;
			case 'ArrowDown':

				if (e.shiftKey) {
					if (this._isBoundDuringResize(element, 0, reduceOffset)) {
						element.style.height = element.offsetHeight + increaseOffset + 'px';
					}
				} else {
					if (this._isBound(element, 0, MOVE_STEP)) {
						element.style.top = element.offsetTop + MOVE_STEP + 'px';
					}
				}

				break;
			case 'ArrowRight':
				if (e.shiftKey) {
					if (this._isBoundDuringResize(element, 0, reduceOffset)) {
						element.style.width = element.offsetWidth + increaseOffset + 'px';
					}
				} else {
					if (this._isBound(element, MOVE_STEP, 0)) {
						element.style.left = element.offsetLeft + MOVE_STEP + 'px';
					}
				}
				break;
			case 'ArrowLeft':
				if (e.shiftKey) {
					if (this._isBoundDuringResize(element, 0, reduceOffset)) {
						element.style.width = element.offsetWidth + reduceOffset + 'px';
					}
				} else {
					if (this._isBound(element, -MOVE_STEP, 0)) {
						element.style.left = element.offsetLeft - MOVE_STEP + 'px';
					}
				}
				break;
		}
		if (ARROW_KEYS.indexOf(e.key) !== -1 && e.shiftKey) {
			crossHairInfo.current.style.height = element.offsetHeight - (HANDLE_BAR_HEIGHT + TOP_PADDING + this.footerHeight + RESIZE_OFFSET) + 'px';
			this.props.footerInfo.showFooter && this._calculateVisibleItemsOnResize();
		}
		e.preventDefault();
		e.stopPropagation();
	};

	CrosshairsPopOver.prototype._parentResize = function _parentResize() {
		var element = this.element ? this.element : this.popover.current;
		var parentWidth = this.containerNode ? this.containerNode.offsetWidth : 0;
		var parentHeight = this.containerNode ? this.containerNode.offsetHeight : 0;
		var elementRight = element.offsetLeft + element.offsetWidth;
		var elementBottom = element.offsetTop + element.offsetHeight;
		if (elementRight > parentWidth) {
			element.style.left = Math.max(parentWidth - element.offsetWidth, 0) + 'px';
		}
		if (elementBottom > parentHeight) {
			element.style.top = Math.max(parentHeight - element.offsetHeight, 0) + 'px';
		}
	};

	// Bound Validators


	CrosshairsPopOver.prototype._isBound = function _isBound(element, diffX, diffY) {
		var dimensions = this._getDimensions(element, diffX, diffY);
		var isHorizontallyBound = dimensions.elementLeft >= 0 && dimensions.elementRight - RESIZE_OFFSET <= dimensions.parentWidth;
		var isVerticallyBound = dimensions.elementTop >= 0 && dimensions.elementBottom - RESIZE_OFFSET <= dimensions.parentHeight;
		return isHorizontallyBound && isVerticallyBound;
	};

	CrosshairsPopOver.prototype._isBoundDuringResize = function _isBoundDuringResize(element, diffX, diffY) {
		var dimensions = this._getDimensions(element, diffX, diffY);
		var isHorizontallyBound = dimensions.elementRight - RESIZE_OFFSET <= dimensions.parentWidth;
		var isVerticallyBound = dimensions.elementBottom - RESIZE_OFFSET <= dimensions.parentHeight;
		return isHorizontallyBound && isVerticallyBound;
	};

	CrosshairsPopOver.prototype._getDimensions = function _getDimensions(element, diffX, diffY) {
		var parentWidth = this.containerNode && this.containerNode.offsetWidth;
		var parentHeight = this.containerNode && this.containerNode.offsetHeight;

		var elementLeft = element.offsetLeft + diffX;
		var elementRight = elementLeft + element.offsetWidth;

		var elementTop = element.offsetTop + diffY;
		var elementBottom = elementTop + element.offsetHeight;
		return {
			parentWidth: parentWidth,
			parentHeight: parentHeight,
			elementLeft: elementLeft,
			elementRight: elementRight,
			elementTop: elementTop,
			elementBottom: elementBottom
		};
	};

	CrosshairsPopOver.prototype._calculateVisibleItemsOnResize = function _calculateVisibleItemsOnResize() {
		var popoverHeight = this.popover && this.popover.current.offsetHeight;
		var onResizeVisibleItems = Math.round(Math.abs(popoverHeight - (HANDLE_BAR_HEIGHT + TOP_PADDING + this.footerHeight)) / this.footerHeight);
		this.setState({ footerItemsVisible: onResizeVisibleItems });
	};

	CrosshairsPopOver.prototype.render = function render() {
		this.popover && this.popover.current && this._parentResize();
		return _react2.default.createElement(
			'div',
			{ draggable: 'true', tabIndex: '0', className: 'vis_crosshair_popover resizabe', autoFocus: true, ref: this.popover,
				onMouseDown: this.mouseDown, onTouchStart: this.touchStart, onKeyDown: this.onKeySelect },
			_react2.default.createElement(
				'div',
				{ className: 'dragHandle', tabIndex: '0', ref: this.handle },
				_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { className: 'dragIcon', iconId: _resizePanel_2.default.id })
			),
			_react2.default.createElement(
				'div',
				{ className: 'crossHairInfo', ref: this.crossHairInfo, onTouchMove: function onTouchMove(e) {
						return e.stopPropagation();
					} },
				this.props.crossHairInfo
			),
			this.props.footerInfo.showFooter && this.props.totalItems > 2 && this.state.footerItemsVisible <= this.props.totalItems && _react2.default.createElement(
				'div',
				{ className: 'footerNotes' },
				_StringResources2.default.get('n1_of_n2_items', { n1: this.state.footerItemsVisible, n2: this.props.totalItems })
			),
			_react2.default.createElement('div', { className: 'resize', onMouseDown: this.resizeStartMouse,
				onTouchStart: this.resizeStartTouch })
		);
	};

	return CrosshairsPopOver;
}(_react.Component)) || _class;

CrosshairsPopOver.propTypes = {
	crossHairInfo: _propTypes2.default.object,
	totalItems: _propTypes2.default.number,
	footerInfo: _propTypes2.default.object,
	containerNode: _propTypes2.default.object
};

CrosshairsPopOver.defaultProps = {
	crossHairInfo: _react2.default.createElement('div', null),
	totalItems: 0,
	footerInfo: {},
	containerNode: _react2.default.createElement('div', null)
};

exports.default = CrosshairsPopOver;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

!function(e,s){if(true)module.exports=s(__webpack_require__(11));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],s);else{var a=s("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([306],{"6873601dfe1d9459c1a9":function(s,a){s.exports=e},"7667499d15310359d2e2":function(e,s,a){"use strict";Object.defineProperty(s,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),i=(a.n(o),a("ad59a288d9f216911e36"));s.default=i.a},ad59a288d9f216911e36:function(e,s,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),i=a.n(o),n=a("9ce58a7deea14f49ef01"),c=a.n(n),t=new i.a({id:"resize-panel_24_v7",use:"resize-panel_24_v7-usage",viewBox:"0 0 24 24",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="resize-panel_24_v7"><path d="M9.8,22.5H8.2v-21h1.5V22.5z M15.8,1.5h-1.5v21h1.5V1.5z" /></symbol>'});c.a.add(t);s.a=t}},["7667499d15310359d2e2"])});

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VisCrosshairsResources = __webpack_require__(486);

var _VisCrosshairsResources2 = _interopRequireDefault(_VisCrosshairsResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(18);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisCrosshairsResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

var amdi18n={"__root":{"n1_of_n2_items":"%{n1} of %{n2} items"},"__cs":{"n1_of_n2_items":"%{n1} z %{n2} položek"},"__da":{"n1_of_n2_items":"%{n1} af %{n2} elementer"},"__de":{"n1_of_n2_items":"%{n1} von %{n2} Elementen"},"__es":{"n1_of_n2_items":"%{n1} de %{n2} elementos"},"__fi":{"n1_of_n2_items":"%{n1} / %{n2} kohdetta"},"__fr":{"n1_of_n2_items":"%{n1} sur %{n2} éléments"},"__hr":{"n1_of_n2_items":"%{n1} od %{n2} stavki"},"__hu":{"n1_of_n2_items":"%{n1} / %{n2} elem"},"__it":{"n1_of_n2_items":"%{n1} di %{n2} elementi"},"__ja":{"n1_of_n2_items":"%{n2} 個のアイテム中 %{n1} 個"},"__kk":{"n1_of_n2_items":"%{n2} элементтің %{n1}"},"__ko":{"n1_of_n2_items":"%{n2}개 중 %{n1}개의 항목"},"__nb":{"n1_of_n2_items":"%{n1} av %{n2} elementer"},"__nl":{"n1_of_n2_items":"%{n1} van %{n2} items"},"__pl":{"n1_of_n2_items":"%{n1} z %{n2} elementów"},"__pt-br":{"n1_of_n2_items":"%{n1} de %{n2} itens"},"__ro":{"n1_of_n2_items":"%{n1} din %{n2} articole"},"__ru":{"n1_of_n2_items":"%{n1} из %{n2} элементов"},"__sl":{"n1_of_n2_items":"%{n1} od %{n2} postavk"},"__sv":{"n1_of_n2_items":"%{n1} av %{n2} objekt"},"__th":{"n1_of_n2_items":"%{n1} จาก %{n2} รายการ"},"__tr":{"n1_of_n2_items":"%{n1} / %{n2} öğe"},"__zh":{"n1_of_n2_items":"第 %{n1} 项（共 %{n2} 项）"},"__zh-cn":{"n1_of_n2_items":"第 %{n1} 项（共 %{n2} 项）"},"__zh-tw":{"n1_of_n2_items":"%{n1} / %{n2} 個項目"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(488);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--1-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--1-4!./CrosshairsPopOver.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--1-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--1-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--1-4!./CrosshairsPopOver.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.vis_crosshair_popover {\n  width: 25%;\n  height: 12%;\n  min-width: 130px;\n  min-height: 68px;\n  max-width: 100%;\n  max-height: 100%;\n  top: 10%;\n  left: 1%;\n  z-index: 550;\n  position: absolute;\n  background-color: white;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #eaeaea;\n  white-space: pre;\n  touch-action: none;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  cursor: move;\n  box-shadow: -2px 3px 5px 0px rgba(130, 125, 125, 0.75);\n}\n\n.vis_crosshair_popover .dragHandle {\n  background-color: #eaeaea;\n  height: 10px;\n}\n\n.vis_crosshair_popover .dragHandle .dragIcon {\n  position: relative;\n  left: 50%;\n  bottom: 85%;\n  width: 8px;\n  height: 14px;\n  transform: rotate(90deg);\n}\n\n.vis_crosshair_popover .resize {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  touch-action: none;\n  cursor: se-resize;\n}\n\n.vis_crosshair_popover .crossHairInfo {\n  height: 50%;\n  display: flex;\n  overflow: auto;\n  padding-top: 8px;\n}\n\n.vis_crosshair_popover .footerNotes {\n  font-size: 12px;\n  text-align: center;\n}\n\n", ""]);

// exports


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * this class is invoked from render sequence for rendering crosshair step.
 * The dependency for this step is render step. 
 */
var RenderCrosshairStep = function () {
	function RenderCrosshairStep(options, moduleOptions) {
		_classCallCheck(this, RenderCrosshairStep);

		this.crosshairFeature = moduleOptions.visCrosshairFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.visAPI = options.visAPI;

		this._initializeStep = this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner._logRenderContext.bind(this.owner);

		if (this.id) {
			this._initializeStep(this.id);
		}
	}

	RenderCrosshairStep.prototype.getRenderState = function getRenderState() {
		return this.owner._renderState;
	};

	RenderCrosshairStep.prototype.clearError = function clearError() {
		this.visAPI.visHelper.clearError();
	};

	RenderCrosshairStep.prototype.showError = function showError(msg, params) {
		this.visAPI.visHelper.showError(msg, params);
	};

	RenderCrosshairStep.prototype.process = function process(renderContext) {
		if (this._isStepComplete(renderContext, 'renderVisCrosshairs')) {
			return Promise.resolve(renderContext);
		}
		// Render is complete. Update the vis crosshairs decorations if the feature is activated
		if (this.crosshairFeature.isActivated()) {
			this.crosshairFeature.renderCrosshairs();
		}
		return Promise.resolve(true);
	};

	return RenderCrosshairStep;
}();

exports.default = RenderCrosshairStep;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _OverallSummaryValueQuery = __webpack_require__(491);

var _OverallSummaryValueQuery2 = _interopRequireDefault(_OverallSummaryValueQuery);

var _FilteredSummaryValueQuery = __webpack_require__(115);

var _FilteredSummaryValueQuery2 = _interopRequireDefault(_FilteredSummaryValueQuery);

var _SummaryCollector = __webpack_require__(116);

var _SummaryCollector2 = _interopRequireDefault(_SummaryCollector);

var _SummarizerHostAPI = __webpack_require__(492);

var _SummarizerHostAPI2 = _interopRequireDefault(_SummarizerHostAPI);

var _CombinedSummaryValidator = __webpack_require__(493);

var _CombinedSummaryValidator2 = _interopRequireDefault(_CombinedSummaryValidator);

var _CombinedSummaryValueQuery = __webpack_require__(494);

var _CombinedSummaryValueQuery2 = _interopRequireDefault(_CombinedSummaryValueQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * The SummarizerFeature is a plugin to the resultdatareader that is
 * responsible for collecting statistics for both default and selected data.
 * (Note: the slected data case is needed for the open case or when data is sliced/changed in some way.
 **/
var SummarizerFeature = function () {
	function SummarizerFeature(widgetApi, dashboardApi) {
		_classCallCheck(this, SummarizerFeature);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;

		this.logger = dashboardApi.getDashboardCoreSvc('Logger');

		//Identify this feature as a plugin for the resultDataReaderPlugin
		this.resultDataReaderPlugin = true;

		this._activated = false;

		this.overallSummaryValueQuery = new _OverallSummaryValueQuery2.default(this.widgetApi, this.dashboardApi, this.logger);

		this.filteredSummaryValueQuery = new _FilteredSummaryValueQuery2.default(this.widgetApi, this.dashboardApi, this.logger, /*cbGetRowTuples*/this.getRowTuples.bind(this));

		this.hostAPI = new _SummarizerHostAPI2.default(this, widgetApi, dashboardApi);

		this.combinedSummaryValidator = new _CombinedSummaryValidator2.default(widgetApi, dashboardApi, this.logger);

		this.hasResultData = false;

		this.rowCountCalcs = {};

		this.isNewQueryApiEnabled = this._isNewQueryApiEnabled();

		this.firstRowDepths = [];

		this.isExpandCollapseEnabled = this._isExpandCollapseEnabled();

		this.hasOlapColumns = false;
	}

	SummarizerFeature.prototype.destroy = function destroy() {
		this.deactivate();
	};

	SummarizerFeature.prototype._isNewQueryApiEnabled = function _isNewQueryApiEnabled() {
		//TODO: This function can be removed when the feature flag is removed.
		return !this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'queryApi', 'disabled');
	};

	SummarizerFeature.prototype._isExpandCollapseEnabled = function _isExpandCollapseEnabled() {
		return this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'expandCollapse', 'enabled');
	};

	SummarizerFeature.prototype.setActivated = function setActivated(flag) {
		this._activated = flag;
	};

	SummarizerFeature.prototype.isActivated = function isActivated() {
		return this._activated;
	};

	/**
  * checks if a chart is supported for stats by checking there is data query in vis definition
  */


	SummarizerFeature.prototype._isSupported = function _isSupported() {
		var isSupported = true;
		if (this.widgetApi && this.widgetApi.getVisApi()) {
			var visDefinition = this.widgetApi.getVisApi().getDefinition();
			if (visDefinition && visDefinition.noDataQuery) {
				isSupported = false;
			}
		}
		return isSupported;
	};

	SummarizerFeature.prototype.getAPI = function getAPI() {
		return {
			isActivated: this.isActivated.bind(this),
			setActivated: this.setActivated.bind(this),

			getSummaryCollector: this.getSummaryCollector.bind(this),
			getSelectionSummaryCollector: this.getSelectionSummaryCollector.bind(this),

			//ResultDataReader plugin api's
			onNewResults: this.onNewResults.bind(this),

			onDataStart: this.onDataStart.bind(this),
			onDataRow: this.onDataRow.bind(this),
			onDataDone: this.onDataDone.bind(this),

			//host api
			activate: this.activate.bind(this),

			getCombinedSummaryValidator: this.getCombinedSummaryValidator.bind(this),

			createCombinedSummaryValueQuery: this.createCombinedSummaryValueQuery.bind(this)
		};
	};

	SummarizerFeature.prototype.activate = function activate(options) {
		//Capture events from the event source when a select or clear select happens for 'immediate stats update' on that widget.

		//Capture events from any widget whose selection state has been affected (ie: no new query)
		this.widgetApi.on('visevent:selectionchanged', this.recalculateSelectionData, this);

		this.overallSummaryValueQuery.activate();
		this.filteredSummaryValueQuery.activate();

		this.cbDeactivate = options.cbDeactivate;

		this.queryAPI = this.widgetApi.getVisApi() && this.widgetApi.getVisApi().getQueryAPI();
		if (this.queryAPI) {
			this._resultDataHandler = this.queryAPI.addUnprocessedResultDataHandler(this.processDetailRowCountCalculations.bind(this));
		}

		return this.hostAPI.activate(options);
	};

	SummarizerFeature.prototype.deactivate = function deactivate() {

		if (this.isActivated()) {
			this.widgetApi.off('visevent:selectionchanged', this.recalculateSelectionData, this);
			if (this.cbDeactivate) {
				this.cbDeactivate();
			}
		}

		this.overallSummaryValueQuery.deactivate();
		this.filteredSummaryValueQuery.deactivate();

		if (this.queryAPI) {
			this.queryAPI.removeUnprocessedResultDataHandler(this.processDetailRowCountCalculations.bind(this));
		}

		//When deactivate, set _activated to false;
		this.setActivated(false);
	};

	//Identify this feature as a plugin for the resultDataReaderPlugin


	SummarizerFeature.prototype.getFeatureTags = function getFeatureTags() {
		return this._activated ? ['ResultDataReaderPlugin'] : [];
	};

	SummarizerFeature.prototype.getCombinedSummaryValidator = function getCombinedSummaryValidator() {
		return this.combinedSummaryValidator;
	};

	/**
  * A caller calls this function to create a query object to determine combined summary values across a set of widgets.
  * @param widgetApis {Object[]} - an array of widgetApis to consider combining.
  * @param isSelectionStats {Boolean} - true if these summaries are for selected data (visible selections should be part of the filter).
  * @returns the query API for the combined summary query.
  */


	SummarizerFeature.prototype.createCombinedSummaryValueQuery = function createCombinedSummaryValueQuery(widgetApis, isSelectionStats) {
		return new _CombinedSummaryValueQuery2.default(widgetApis, this.dashboardApi, this.logger, isSelectionStats);
	};

	/**
  * @returns the 'default stats collector' which contains general measure stats for the data rendered.
  */


	SummarizerFeature.prototype.getSummaryCollector = function getSummaryCollector() {
		this.summaryCollector = this.summaryCollector || new _SummaryCollector2.default(this.dashboardApi, this.widgetApi, false);
		return this.summaryCollector;
	};

	/**
  * @returns the 'selections stats collector' which contains measure stats for the selected categories.
  */


	SummarizerFeature.prototype.getSelectionSummaryCollector = function getSelectionSummaryCollector() {
		this.selectionSummaryCollector = this.selectionSummaryCollector || new _SummaryCollector2.default(this.dashboardApi, this.widgetApi, /*selection*/true);
		return this.selectionSummaryCollector;
	};

	/**
  * row count calculations are used by summarizer when detail averages need to be computed.
  * This function does the following:
  * 1) When there are averages (and rowCounts) in a result, map the columnId to its rowCount.
  * 2) When there are multi-measures in the value slot, the rowCount values are cached by item
  *		for use later on (see _getDetailRowCount())
  * @param {object} dssResultData - result data JSON as returned by DSS.
  * @param {object} options
  * @param {string} options.layerId - the layer for this data.
  */


	SummarizerFeature.prototype.processDetailRowCountCalculations = function processDetailRowCountCalculations(dssResultData, options) {
		var _this = this;

		var visAPI = this.widgetApi.getVisualization();
		var layerId = options.layerId;
		this.cachedRowCounts = {};

		//Do nothing if there are no rowCounts or no summarized items that need them.
		this.rowCountCalcs[layerId] = this._buildRowCountCalculationsMap(dssResultData, layerId, visAPI);
		if (!Object.keys(this.rowCountCalcs[layerId]).length) {
			return;
		}

		var containsMultiMeasure = visAPI.getSlots().getSlotList().find(function (slot) {
			return _this._isMultiMeasuresValueSlot(slot);
		});

		if (containsMultiMeasure) {
			Object.keys(this.rowCountCalcs[layerId]).forEach(function (resultItemId) {
				_this.cachedRowCounts[resultItemId] = [];
				for (var rowIdx = 0; rowIdx < dssResultData.data.length; ++rowIdx) {
					var rowCountColumnIndex = _this.rowCountCalcs[layerId][resultItemId];
					var rowData = dssResultData.data[rowIdx].pt;
					var rowCountValue = rowData[rowCountColumnIndex];
					_this.cachedRowCounts[resultItemId].push(rowCountValue && rowCountValue.v);
				}
			});
		}
	};

	SummarizerFeature.prototype._isMultiMeasuresValueSlot = function _isMultiMeasuresValueSlot(slotAPI) {
		return slotAPI.getDefinition().isMultiMeasureSupported() && slotAPI.getDataItemList().length > 1;
	};

	/**
  * recalculateSelectionData is called any time the selection has changed in this widget but only decorations need
  * to be updated (ie: a change of selection in one widget causes a change in selection in another with no change in
 	 * its query).  In this case, the target widget will send a widget level event notifying of the change.
  * We need to reprocess the same results with the updated selections and notify the hostApp of the update.
  * NOTE: This function is only needed for "other widgets" in cases where their query didn't change (aka no re-render)
  * @param payload - the event payload which includes information about whether this widget was the originator of the event
  */


	SummarizerFeature.prototype.recalculateSelectionData = function recalculateSelectionData() /*payload*/{
		var _this2 = this;

		if (this.queryResultDataByLayer && this.rowHeadersByLayer) {
			//Reprocess the values...
			Object.keys(this.rowHeadersByLayer).forEach(function (layerId) {
				var queryResultData = _this2.queryResultDataByLayer[layerId];
				var rowHeaders = _this2.rowHeadersByLayer[layerId];
				if (rowHeaders && queryResultData) {
					var rowCount = _this2._getRowCount(queryResultData);
					_this2.onDataStart(queryResultData, rowHeaders);
					for (var rowIdx = 0; rowIdx < rowCount; rowIdx += rowHeaders.valueSlotMeasureCount) {
						_this2.onDataRow(rowIdx);
					}
					//Whether re-processing the values or not, we need to update the last category selection.
					_this2.updateLastCategorySelected();
					_this2.filteredSummaryValueQuery.execute(_this2.selectionSummaryCollector).then(function () {
						_this2.hostAPI.updateSelectionSummaries();
					});
				}
			});
			this._forceRecalculateSelections = false;
		}
	};

	SummarizerFeature.prototype.getSelectedContent = function getSelectedContent() {
		return this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
	};

	SummarizerFeature.prototype.updateLastCategorySelected = function updateLastCategorySelected() {
		//The last category selection will be the last selected tuple.
		var content = this.getSelectedContent();
		var controller = content.getFeature('InteractivityController.deprecated');
		var selectedTuples = controller.getSelectedTuples(this.categoryItemHeaders.itemIds);
		if (selectedTuples && selectedTuples.length) {
			//The lastTuple in the set of selected tuples could be an array or a single value.
			//The single value (or an array entry) could be null (no value).
			var lastTuple = this.findLastSelectedTupleInVisualization(selectedTuples);
			if (lastTuple) {
				this._setLastSelectedTuple(lastTuple);
			}
		}
	};

	SummarizerFeature.prototype._setLastSelectedTuple = function _setLastSelectedTuple(lastTuple) {
		if (Array.isArray(lastTuple)) {
			this.selectionSummaryCollector.setLastCategorySelection(lastTuple.map(function (tuplePart) {
				return tuplePart ? tuplePart.d : tuplePart;
			}));
		} else {
			this.selectionSummaryCollector.setLastCategorySelection([lastTuple ? lastTuple.d : lastTuple]);
		}
	};

	//Reverse-search the array of selectedTuples for the last one that occurs in this visualization.


	SummarizerFeature.prototype.findLastSelectedTupleInVisualization = function findLastSelectedTupleInVisualization(selectedTuples) {
		for (var i = selectedTuples.length - 1; i >= 0; --i) {
			if (this.selectionSummaryCollector.isTupleInSelectionSummary(selectedTuples[i])) {
				return selectedTuples[i];
			}
		}
		return null;
	};

	/**
  * This event is called at the very beginning of a render with new data
  * or a render of placeholder without data( i.e. when the viz placeholder
  * is rendered, this function is still called with empty resultData. When
  * resultData is empty, onDataStart, onDataRow and onDataEnd won't be run)
  *
  * It is similar to onDataStart but allows for process initialization
  * to be separated from onDataStart
  */


	SummarizerFeature.prototype.onNewResults = function onNewResults(resultData) {
		var _this3 = this;

		//When new data is rendered, initialize rowHeader and result pointers (one per layer).
		this.rowHeadersByLayer = {};
		this.queryResultDataByLayer = {};
		this.queryResultData = null;
		var returnPromise = Promise.resolve({});
		var hasResultData = this._getResultHasData(resultData);
		if (!this._isSupported()) {
			return returnPromise;
		}

		this._resetSummaryCollectors();

		if (this.hasResultData && !hasResultData) {
			//Deleting a slot case:
			//resultData is not empty previously, but new returned resultData
			//is empty. In this case, reset and update summary table
			returnPromise = this.hostAPI.updateSummaries().then(function () {
				_this3.selectionSummaryCollector.setLastCategorySelection([]);
				_this3.hostAPI.updateSelectionSummaries();
			});
		}
		this.hasResultData = hasResultData ? true : false;
		if (this.isNewQueryApiEnabled && resultData.getQueryResultIdList) {
			resultData.getQueryResultIdList().forEach(function (layerId) {
				var queryResult = resultData.getResult(layerId);
				var dssQueryResultString = queryResult && queryResult.getPropertyValue('RawData.internal');
				var dssQueryResult = dssQueryResultString && JSON.parse(dssQueryResultString);
				_this3.processDetailRowCountCalculations(dssQueryResult, { layerId: layerId });
			});
		}

		return returnPromise || Promise.resolve(true);
	};

	/**
  * Function run at start-of-data.
  * @param {Object} queryResultData
  * @param {function} rowHeaders - a structure describing the category and measure (ordinal) row Headers and their positions in the row.
  */

	SummarizerFeature.prototype.onDataStart = function onDataStart(queryResultData, rowHeaders) {
		var _this4 = this;

		this.visAPI = this.widgetApi.getVisApi();

		//onDataStart/onDataRow/OnDataDone is called once for each layer (usually 1)
		this.activeLayerId = rowHeaders.layerId;

		//Save results and headers by layer for recalculateSelectionData...
		this.queryResultDataByLayer = this.queryResultDataByLayer || {};
		this.rowHeadersByLayer = this.rowHeadersByLayer || {};
		this.queryResultDataByLayer[rowHeaders.layerId] = queryResultData;
		this.rowHeadersByLayer[rowHeaders.layerId] = rowHeaders;

		this.queryResultData = queryResultData;

		//TODO: This special logic for setting the domain of a waterfall chart will change when the VIDA api is ready (RTC258118)
		//A waterfall chart is much like a single column stacked chart (where the grouping column is always 0)
		this.isWaterfallStack = this.visAPI.getVisId() === 'com.ibm.vis.rave2bundlewaterfall';

		this.widgetContentApi = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());

		//Is there a stacked summary slot that is populated with items?
		var stackedSummarySlot = this.widgetContentApi.getFeature('Visualization').getSlots().getMappedSlotList().find(function (slot) {
			return _this4.isWaterfallStack ? slot : slot.getDefinition().getProperty('stackValuesOnAxis');
		});

		//Is it a regular item or a stacked Multi Measure item?
		this.stackedMultiMeasures = !!(stackedSummarySlot && this._isMultiMeasuresSeriesSlot(stackedSummarySlot));
		this.stackedSummaries = this.isWaterfallStack || !!(stackedSummarySlot && !this.stackedMultiMeasures);

		this._resetSummaryCollectors(rowHeaders.layerId);

		this.valueSlotMeasureCount = rowHeaders.valueSlotMeasureCount;
		this.measureItemHeaders = rowHeaders.measureItemHeaders;
		this.categoryItemHeaders = rowHeaders.categoryItemHeaders;

		this.visSelected = this._getSelected(this.categoryItemHeaders);

		//get all mapped dataitems
		var mappedItems = this.widgetContentApi.getFeature('Visualization').getSlots().getMappingInfoList();
		mappedItems.forEach(function (item) {
			if (item.dataItem.getMetadataColumn() && item.dataItem.getMetadataColumn().isOlapColumn()) {
				_this4.hasOlapColumns = true;
			}
		});
	};

	SummarizerFeature.prototype._isMultiMeasuresSeriesSlot = function _isMultiMeasuresSeriesSlot(slotAPI) {
		var dataItemList = slotAPI.getDataItemList();
		return dataItemList.find(function (dataItem) {
			return dataItem.getId() === '_multiMeasuresSeries';
		}) ? true : false;
	};

	/**
  * function run on each data row
  * @param rowIdx - the row index
  */


	SummarizerFeature.prototype.onDataRow = function onDataRow(rowIdx) {
		var _this5 = this;

		var rowSummaries = [];

		//This local variable is only used for stacked charts (stacked area/bar/column)
		//when the components of the stack are measures (in this case, the stacked summary value is the total of all measure values in the stack)
		var multiMeasuresStackedSummaryValue = 0;

		var skipRow = false;
		if (this.queryResultData.getVersion && this.queryResultData.getVersion() === '2') {
			var rowTuple = this._getRowTuple(rowIdx, this.categoryItemHeaders);
			if (this.hasOlapColumns && this.isExpandCollapseEnabled) {
				if (rowIdx === 0) {
					this.firstRowDepths = rowTuple.map(function (tuple) {
						return tuple['ln'];
					});
				} else {
					rowTuple.forEach(function (tuple) {
						_this5.firstRowDepths.forEach(function (depthOfCategory) {
							skipRow = skipRow || tuple.ln > depthOfCategory || tuple.type === _this5.queryResultData.VALUE_TYPE.SUMMARY;
						});
					});
				}
			} else {
				skipRow = skipRow || this.queryResultData.VALUE_TYPE && rowTuple.find(function (tuple) {
					return tuple.type === _this5.queryResultData.VALUE_TYPE.SUMMARY;
				});
			}
		}

		this.measureItemHeaders.forEach(function (measureItemHeader) {
			var value = _this5._getMeasureCellValue(rowIdx, measureItemHeader);
			var detailRowCount = _this5._getDetailRowCount(rowIdx, measureItemHeader);
			if (!skipRow) {
				rowSummaries.push({ dataItemUniqueId: measureItemHeader.dataItemUniqueId, value: value, detailRowCountUse: detailRowCount });

				var itemSummaryEntry = _this5.summaryCollector.getSummary(measureItemHeader.dataItemUniqueId);
				_this5.summaryCollector.updateSummary(itemSummaryEntry, value, detailRowCount);
				if (_this5.stackedSummaries) {
					_this5._applyStackedSummaries(rowIdx, itemSummaryEntry, measureItemHeader, value);
				} else if (_this5.stackedMultiMeasures) {
					//This is a measure stack so we need the total of all of the measure values in the stack.
					multiMeasuresStackedSummaryValue += value;
				}
			}
		});

		if (this.stackedMultiMeasures) {
			//If this is a measure in a measure stack, AND this is a stacked chart (stacked column/bar/area),
			//apply the same stacked summary value to all measure entries (it will become the domain of the value item when applicable)
			this.measureItemHeaders.forEach(function (measureItemHeader) {
				if (measureItemHeader.multiMeasuresValueItem) {
					var itemSummaryEntry = _this5.summaryCollector.getSummary(measureItemHeader.dataItemUniqueId);
					_this5._applyStackedSummaries(rowIdx, itemSummaryEntry, measureItemHeader, multiMeasuresStackedSummaryValue);
				}
			});
		}

		this._processSelectionsForRow(rowIdx, rowSummaries);
	};

	SummarizerFeature.prototype._applyStackedSummaries = function _applyStackedSummaries(rowIdx, itemSummaryEntry, measureItemHeader, value) {
		var rowDataArray = this._getRowDataArray(this.queryResultData);
		var rowData = rowDataArray && rowDataArray[rowIdx + measureItemHeader.valueItemIndex];
		//For all Stacked visualizations we support, the grouping column is the first (the category)
		//The grouping column is categorical so the row data will store the value index (have values from 0-n)
		//A waterfallStack is a special case...it is like a single stack where the values from row0..n result in a single sum (groupId=0)
		var groupingColumnValueId = this.isWaterfallStack ? 0 : rowData && rowData.pt && rowData.pt[0];
		if (groupingColumnValueId >= 0) {
			this.summaryCollector.updateStackedSummary(itemSummaryEntry, value, groupingColumnValueId);
		}
	};

	SummarizerFeature.prototype._getMeasureCellValue = function _getMeasureCellValue(rowIdx, measureItemHeader) {
		var columnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : measureItemHeader.index;

		//rowIdx is normally 1:1 with the row of data....so any measure cell value is found at row=rowIdx, column=slotIndex+indexInSlot
		//For multiMeasureValue slots (valueSlotMeasureCount is > 1),the data is returned as "rowgroups" where
		//rowIdx is a group index and groupX, rowNInTheGroup represents the row data plus the Nth measure in the value slot.
		//In this case, for 2 measures, this function gets called with rowIdx,valueItemIndex (0, 0), (0, 1), (2, 0), (2, 1)

		var measureCellValue = this.valueSlotMeasureCount > 1 ? this._getCellValue(this.queryResultData, rowIdx + measureItemHeader.valueItemIndex, columnIndex) : this._getCellValue(this.queryResultData, rowIdx, columnIndex + measureItemHeader.valueItemIndex);
		return measureCellValue === '' ? 0 : measureCellValue;
	};

	//TODO: Remove this function when  isNewQueryApiEnabled is removed


	SummarizerFeature.prototype._getCellValueObject = function _getCellValueObject(queryResult, row, column) {
		return this.isNewQueryApiEnabled ? queryResult.getValue(row, column) : queryResult.getCellValue(row, column);
	};

	SummarizerFeature.prototype._getCellValue = function _getCellValue(queryResult, row, column) {
		var cellValueObject = this._getCellValueObject(queryResult, row, column);
		if (this.isNewQueryApiEnabled) {
			return cellValueObject && cellValueObject.getValue ? cellValueObject.getValue() : cellValueObject.value;
		} else {
			return cellValueObject && cellValueObject.getValue ? cellValueObject.getValue() : cellValueObject.v;
		}
	};

	//DETAIL ROWCOUNT SUPPORT....


	SummarizerFeature.prototype._getRowCount = function _getRowCount(queryResultData) {
		return this.isNewQueryApiEnabled ? queryResultData.getRowCount() : queryResultData.getDatapointCount();
	};

	SummarizerFeature.prototype._getRowDataArray = function _getRowDataArray(queryResultData) {
		return this.isNewQueryApiEnabled ? queryResultData.getDataPointValueList() : queryResultData.getDatapoints();
	};

	SummarizerFeature.prototype._getResultHasData = function _getResultHasData(resultData) {
		return this.isNewQueryApiEnabled && resultData.getResult || !this.isNewQueryApiEnabled && resultData.getQueryResults;
	};

	//NOTE: ResultDataReader plugins (including Summarizer) currently are given the old result API (queryResultData).
	//A number of methods will change (slightly) when the new queryResultAPI is available

	//return the detail rowCount associated with this measure for row X (or NO_DETAIL_ROWCOUNT if none exists)


	SummarizerFeature.prototype._getDetailRowCount = function _getDetailRowCount(rowIdx, measureItemHeader) {
		var layerId = this.activeLayerId;
		var rowCountIdx = this.rowCountCalcs && this.rowCountCalcs[layerId] && this.rowCountCalcs[layerId][measureItemHeader.dataItemUniqueId];
		if (measureItemHeader.aggregate !== 'avg' || rowCountIdx === undefined) {
			//If there's no rowcount for this item or it doesn't apply to this aggregation type, return 'NO_DETAIL_ROWCOUNT' value (-1)
			return _SummaryCollector2.default.NO_DETAIL_ROWCOUNT;
		}
		var cacheDetailRow = Math.floor(rowIdx / this.valueSlotMeasureCount);
		var cachedRowCountsForItem = this.cachedRowCounts && this.cachedRowCounts[measureItemHeader.dataItemUniqueId];
		if (cachedRowCountsForItem && cachedRowCountsForItem[cacheDetailRow]) {
			return cachedRowCountsForItem[cacheDetailRow];
		}
		return this._getMeasureCellValue(rowIdx, measureItemHeader, rowCountIdx);
	};

	//Create a mapping between measure ids and the column indexes where rowCount data is found (for the active layer).
	//This function will compute the rowCounts only if the data items contains Averages.


	SummarizerFeature.prototype._buildRowCountCalculationsMap = function _buildRowCountCalculationsMap(dssResultData, layerId) {
		var rowCountCalcs = {};
		var measureDataItems = [];
		//We only need to compute detail averages for visualizations if they include an average.
		var containsAverage = false;

		var widgetContentApi = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var mappedItems = widgetContentApi.getFeature('Visualization').getSlots().getMappingInfoList();
		mappedItems.forEach(function (item) {
			if (item.slot.getDefinition().getDatasetIdList().some(function (dataSetId) {
				return dataSetId === layerId;
			}) && item.dataItem.getAggregation() === 'avg') {
				containsAverage = true;
				if (!dssResultData.dataItems) {
					measureDataItems.push(item.dataItem.getId());
				}
			}
		});

		if (containsAverage) {
			var resultItemMap = {};
			if (dssResultData.dataItems) {
				dssResultData.dataItems.forEach(function (resultItem, idx) {
					resultItemMap[resultItem.itemClass.id] = idx;
				});
				rowCountCalcs = this._computeRowCountCalcs(resultItemMap);
			} else {
				//For multi-edge, all measures and calculations are on the same edge (usually edge 1 or 2)
				var measureEdgeIndex = dssResultData.edges.findIndex(function (edge) {
					return edge.itemClasses && edge.itemClasses.some(function (itemClass) {
						return itemClass.h && itemClass.h[0] && measureDataItems.some(function (measureDataItem) {
							return measureDataItem === itemClass.h[0].di;
						});
					});
				});
				if (measureEdgeIndex >= 0) {
					//Extract the di's from the itemClasses on the measure edge
					var measureItemIds = dssResultData.edges[measureEdgeIndex].itemClasses.map(function (itemClass) {
						return itemClass.h[0];
					});
					measureItemIds.forEach(function (item, index) {
						resultItemMap[item.di] = measureEdgeIndex + index;
					});
					rowCountCalcs = this._computeRowCountCalcs(resultItemMap);
				}
			}
		}
		return rowCountCalcs;
	};

	//Given a map of itemIds keyed to their indexes { 'rowCount:id1': 2, 'rowCount:id2': 6}
	//Return a map keyed by "baseId" to the corresponding rowCount index: rowCountMap: { 'id1': 2, 'id2': 6 }


	SummarizerFeature.prototype._computeRowCountCalcs = function _computeRowCountCalcs(resultItemMap) {
		var rowCountCalcs = {};
		var resultItemMapKeys = Object.keys(resultItemMap);
		resultItemMapKeys.forEach(function (dataItemId) {
			var rowCountIdx = resultItemMap['rowCount:' + dataItemId];
			if (rowCountIdx !== undefined) {
				rowCountCalcs[dataItemId] = rowCountIdx;
			}
		});
		return rowCountCalcs;
	};

	/**
  * function run at end of data...this function returns a promise.
  * @param renderContext - the renderContext as used in the render sequence.
  * @returns a promise
 */


	SummarizerFeature.prototype.onDataDone = function onDataDone(renderContext) {
		var _this6 = this;

		var rowCount = this._getRowCount(this.queryResultData);

		this.measureItemHeaders.forEach(function (measureItemHeader) {
			var itemSummaryEntry = _this6.summaryCollector.getSummary(measureItemHeader.dataItemUniqueId);

			_this6.summaryCollector.finalizeSummaries(itemSummaryEntry, rowCount / _this6.valueSlotMeasureCount, measureItemHeader.aggregate);
		});

		var valuesNeeded = this.summaryCollector.areOverallSummaryValuesNeeded();
		if (valuesNeeded) {
			// wiring off until query work is complete
			//Augment the summary info with the query results from a query for unfiltered measures.
			return this.overallSummaryValueQuery.execute(this.summaryCollector).then(function () {
				return _this6.filteredSummaryValueQuery.execute(_this6.summaryCollector).then(function () {
					return _this6.filteredSummaryValueQuery.execute(_this6.selectionSummaryCollector).then(function () {
						return _this6._updateSummaries(renderContext);
					});
				});
			});
		}

		return this._updateSummaries(renderContext);
	};

	SummarizerFeature.prototype._resetSummaryCollectors = function _resetSummaryCollectors() {
		var layerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		this.summaryCollector = this.getSummaryCollector();
		this.selectionSummaryCollector = this.getSelectionSummaryCollector();
		this.summaryCollector.reset(layerId);
		this.selectionSummaryCollector.reset(layerId);
	};

	SummarizerFeature.prototype._updateSummaries = function _updateSummaries(renderContext) {
		var _this7 = this;

		return this.hostAPI.updateSummaries().then(function (topBottomSpec) {
			//NOTE: Selection summaries cb (when selections exist) are expected after the default summaries cb.
			_this7.updateLastCategorySelected();
			_this7.hostAPI.updateSelectionSummaries();
			// make sure topBottomSpec is a truthy Object
			if (topBottomSpec && (typeof topBottomSpec === 'undefined' ? 'undefined' : _typeof(topBottomSpec)) === 'object') {
				if (_this7.isNewQueryApiEnabled) {
					var contentAPI = _this7.dashboardApi.getCanvas().getContent(_this7.widgetApi.getId());
					var queryExecutionAPI = contentAPI && contentAPI.getFeature('DataQueryExecution.internal');
					queryExecutionAPI && queryExecutionAPI.setMinMaxQueryResults(topBottomSpec[_this7.widgetApi.getId()]);
				} else if (renderContext) {
					renderContext.data.setTopBottomMappings && renderContext.data.setTopBottomMappings(topBottomSpec[_this7.widgetApi.getId()], 0 /*query result index*/);
				}
			}
			return {};
		});
	};

	SummarizerFeature.prototype._getSelected = function _getSelected(categoryItemHeaders) {
		//Get the visualization selected api but add the option to ignoreEdgeSelections.
		//We need to handle edge selections differently to give more appropriate summary totals when multiple edges intersect.
		//Even though the visualization highlights the union of intersected edges, the intersection values make more sense.
		//In future, this behaviour may be incorporated into the visSelected object.
		var content = this.getSelectedContent();
		var dataPointSelections = content.getFeature('DataPointSelections.deprecated');
		return dataPointSelections.getSelection(categoryItemHeaders.itemIds, { ignoreEdgeSelections: true });
	};

	//Process the categorical items in a row returning their values as an array... eg [2005, Camping, Fax]


	SummarizerFeature.prototype._getRowTuple = function _getRowTuple(rowIdx, categoryItemHeaders) {
		var _this8 = this;

		var tuple = [];
		categoryItemHeaders.columnIndexes.forEach(function (columnIndex) {
			//Note: getValue returns the tuple of categorical values at that cell index for stacked items.
			var cellValue = _this8._getCellValueObject(_this8.queryResultData, rowIdx, columnIndex);
			if (cellValue && cellValue.type) {
				cellValue = cellValue.map(function (value) {
					return _extends({}, value, { type: cellValue.type });
				});
			}
			tuple = tuple.concat(cellValue);
		});
		return tuple;
	};

	/**
  * Return the categorical information rendered in a visualization.
  * @param {string} [selectionsOnly=false] - only include the selected rows.
  * @param {string} [layerId='data'] - the layer for this query result.
  * @returns the categorical data tuples and item Ids for the rendered rows (or selected rows)
  */


	SummarizerFeature.prototype.getRowTuples = function getRowTuples() {
		var selectionsOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		var layerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';

		var tuples = [];
		var rowHeaders = this.rowHeadersByLayer[layerId];
		var queryResult = this.queryResultDataByLayer[layerId];
		if (queryResult && rowHeaders && rowHeaders.categoryItemHeaders) {
			var rowCount = this._getRowCount(queryResult);
			for (var rowIdx = 0; rowIdx < rowCount; rowIdx += rowHeaders.valueSlotMeasureCount) {
				if (!selectionsOnly || this._processSelectionsForRow(rowIdx)) {
					tuples.push(this._getRowTuple(rowIdx, rowHeaders.categoryItemHeaders));
				}
			}
		}

		//At this point, we have a parallel array of itemIds and tuple part use/display values.
		//If one of the itemIds is multiMeasuresSeries, strip it and the corresponding tuplepart out.
		//The value is an itemLabel (like Revenue) not a data value (like 2004)
		var itemIds = rowHeaders && rowHeaders.categoryItemHeaders && rowHeaders.categoryItemHeaders.itemIds || [];
		var multiMeasuresIndex = itemIds.indexOf('_multiMeasuresSeries');
		if (multiMeasuresIndex !== -1) {
			itemIds.splice(multiMeasuresIndex, 1);
			tuples.forEach(function (tuple) {
				return tuple.splice(multiMeasuresIndex, 1);
			});
		}
		return {
			itemIds: itemIds,
			tuples: tuples
		};
	};

	//Return true if this row is selected.  If rowSummaries are passed, update the selectionSummaryCollector with the values.


	SummarizerFeature.prototype._processSelectionsForRow = function _processSelectionsForRow(rowIdx) {
		var _this9 = this;

		var rowSummaries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		//for each row, if the categorical tuple for that row is selected, add it to selection summaries.
		var tuple = this._getRowTuple(rowIdx, this.categoryItemHeaders);
		//FIRST, process any edge selections.
		var isSelected = this._processEdgeSelectionsForRow(tuple, rowSummaries);
		//THEN, process datapoint selections.
		if (this.visSelected && this.visSelected.isSelected(tuple)) {
			if (rowSummaries) {
				rowSummaries.forEach(function (rowSummary) {
					var selectionEntry = _this9.selectionSummaryCollector.getSummary(rowSummary.dataItemUniqueId);
					_this9.selectionSummaryCollector.updateSelectionSummary(selectionEntry, rowSummary, tuple);
				});
				//Handle cases where selections are not an exact match
				//(eg: in chartA, 2004 is selected but chartB projects Year.Country.
				//means that in chartB 2004.Canada, 2004.USA, 2004.France etc are all selected tuples.
				this._setLastSelectedTuple(tuple, rowSummaries);
			}
			isSelected = true;
		}
		return isSelected;
	};

	//Find the intersected result of any edge selections.


	SummarizerFeature.prototype._processEdgeSelectionsForRow = function _processEdgeSelectionsForRow(tuple, rowSummaries) {
		var _this10 = this;

		//Edge selections are analagous to selecting N values from 1 item, then M values from another etc.
		//Tables are 'edge selectors', outer crosstab labels, legend/axis selections are other examples.
		//Edge example A: Camping, Golf, then B: 2004, 2005, 2006
		//(They are 'symmetrical' meaning you Cant have 2 values of A without all 3 values of B)

		//Use the Selection Controller rather than visSelected for this.
		var content = this.getSelectedContent();
		var selectionCtrlr = content.getFeature('InteractivityController.deprecated');

		if (!selectionCtrlr) {
			return false;
		}

		//RULE: Values for this tuple should be part of the total IF the value for that tuple part is selected OR
		//there are no selections for that item in the tuple.
		var someItemHasSelections = this.categoryItemHeaders.itemIds.find(function (itemId) {
			return selectionCtrlr.isItemSelected(itemId);
		});

		if (someItemHasSelections) {
			var thisTupleIsNotSelected = tuple.find(function (tuplePart, ci) {
				var itemId = _this10.categoryItemHeaders.itemIds[ci];
				return selectionCtrlr.isItemSelected(itemId) && !selectionCtrlr.isValueSelected(itemId, tuplePart);
			});

			if (!thisTupleIsNotSelected) {
				if (rowSummaries) {
					rowSummaries.forEach(function (rowSummary) {
						var selectionEntry = _this10.selectionSummaryCollector.getSummary(rowSummary.dataItemUniqueId);
						_this10.selectionSummaryCollector.updateSelectionSummary(selectionEntry, rowSummary, tuple);
					});
					this._setLastSelectedTuple(tuple);
				}
				return true;
			}
		}
		return false;
	};

	return SummarizerFeature;
}();

exports.default = SummarizerFeature;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseSummarizerQuery2 = __webpack_require__(56);

var _BaseSummarizerQuery3 = _interopRequireDefault(_BaseSummarizerQuery2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var __SUMMARY_MIN_PREFIX__ = '__min__';

/**
 * The OverallSummaryValueQuery is a single query that updates summaryCollector entries
 * with the single row result of the aggregated summary values
 * for all measures (ordinals) that are projected. (Because they're overall summaries, all layers can also be done at once for multi-layer)
 * It also is used to detect if datasets include negatives - mins are negative (to warn the user summaries may be > 100% of the data)
 * NOTE: it may return cached results for performance.
 * Case1: Initial execute (will query for all items)
 * Case2: User inserted a new measure(s) (will query for that measure)
 * Case3: Shaping changed...all measures will be queried for.
 **/

var OverallSummaryValueQuery = function (_BaseSummarizerQuery) {
	_inherits(OverallSummaryValueQuery, _BaseSummarizerQuery);

	/**
  * @Constructor
  * @param {Object} widgetApi - the owner widget (needed to access services)
  * @param {Object} dashboardApi - the dashboardApi
  * @param {Object} logger - The logger
  */
	function OverallSummaryValueQuery(widgetApi, dashboardApi, logger) {
		_classCallCheck(this, OverallSummaryValueQuery);

		//The overallSummariesCache maintains previous results since values rarely change.
		var _this = _possibleConstructorReturn(this, _BaseSummarizerQuery.call(this, widgetApi, dashboardApi, logger));

		_this.overallSummariesCache = {};

		//The overallSummaryValue query should not be filtered (it is measuring all data)
		_this.includeFilters = false;
		return _this;
	}

	//If the widget shaping changed, we need to refresh overall summaries.


	OverallSummaryValueQuery.prototype.onWidgetShapingChanged = function onWidgetShapingChanged() {
		this.overallSummariesCache = {};
	};

	/**
  * Add an item to the overallSummaryValue query definition UNLESS
  * 1) it is not a fact
  * 2) if has been requested before (in which case there's no need to query for it again)
  * @param {object} queryDef - the queryDefinition that will be modified with this item if it applies
  * @param {object[]} queryDef.dataItems - simple data item _querySpec
  * @param {String[]} queryDef.projections - the list of projected items (ids same as dataItems list)
  * @param summaryCollector - a summaryCollector (or selectionSummaryCollector) whose entries are to be augmented with the overallSummary values.
 */


	OverallSummaryValueQuery.prototype.addQueryItem = function addQueryItem(queryDef, mappedDataItem, summaryCollector) {
		if (mappedDataItem.getType() === 'fact') {
			var itemUpdated = false;
			var itemSummaryCacheEntry = this.overallSummariesCache[mappedDataItem.getId()];
			if (itemSummaryCacheEntry && itemSummaryCacheEntry.aggregationType === mappedDataItem.getAggregation()) {
				var summaryEntry = this.updateSummaryEntry(summaryCollector, mappedDataItem.getId(), itemSummaryCacheEntry.value, 'summaryValueUse', 'summaryValue');
				if (summaryEntry && itemSummaryCacheEntry.hasNegativeValues) {
					summaryEntry.hasNegativeValues = itemSummaryCacheEntry.hasNegativeValues;
				}
				itemUpdated = true;
			}
			if (!itemUpdated) {
				var hasDataItem = function hasDataItem(id) {
					return queryDef.dataItems.some(function (e) {
						return e.id === id;
					});
				};
				var dataItemJSON = {
					aggregate: mappedDataItem.getAggregation(),
					itemId: mappedDataItem.getColumnId(),
					id: mappedDataItem.getId()
				};
				var dataItemMinJSON = {
					aggregate: 'min',
					itemId: mappedDataItem.getColumnId(),
					id: __SUMMARY_MIN_PREFIX__ + mappedDataItem.getId()
				};
				if (!hasDataItem(mappedDataItem.getId()) && !hasDataItem(__SUMMARY_MIN_PREFIX__ + mappedDataItem.getId())) {
					queryDef.dataItems.push(dataItemJSON);
					queryDef.projections.push(mappedDataItem.getId());
					queryDef.dataItems.push(dataItemMinJSON);
					queryDef.projections.push(dataItemMinJSON.id);
				}
			}
		}
	};

	/**
  * Process the value of an item returned from the query by adding it to the summaryCollector
  * @param {String} dataItemUniqueId - the id of the dataItem.
  * @param {String} aggregate - the aggregation type (eg countdistinct)
  * @param {String} overallSummaryUseValue - the actual value (to be added as either a total or a min (for finding negatives).
  * @param {Object} summaryCollector - the summaryCollector to add the value to.
  */


	OverallSummaryValueQuery.prototype.processValue = function processValue(dataItemUniqueId, aggregate, overallSummaryUseValue, summaryCollector) {
		if (!this._isSummaryMinResult(dataItemUniqueId)) {
			this.overallSummariesCache[dataItemUniqueId] = {
				aggregationType: aggregate,
				value: overallSummaryUseValue
			};
			this.updateSummaryEntry(summaryCollector, dataItemUniqueId, overallSummaryUseValue, 'summaryValueUse', 'summaryValue');
		} else {
			this._updateHasNegativeValuesFromSummaryMin(summaryCollector, dataItemUniqueId, overallSummaryUseValue);
		}
	};

	OverallSummaryValueQuery.prototype._isSummaryMinResult = function _isSummaryMinResult(dataItemUniqueId) {
		//A summary min is prefixed with __min__
		return dataItemUniqueId.indexOf(__SUMMARY_MIN_PREFIX__) === 0 ? true : false;
	};

	//If this item is a 'summary min' (uniqueId starts with __min__), update the summary min.  If not, return false.


	OverallSummaryValueQuery.prototype._updateHasNegativeValuesFromSummaryMin = function _updateHasNegativeValuesFromSummaryMin(summaryCollector, dataItemUniqueId, overallSummaryMin) {
		if (this._isSummaryMinResult(dataItemUniqueId)) {
			var baseUniqueId = dataItemUniqueId.substr(__SUMMARY_MIN_PREFIX__.length);
			var summaryEntry = summaryCollector.getSummary(baseUniqueId);
			if (summaryEntry && overallSummaryMin < 0) {
				summaryEntry.hasNegativeValues = true;
				this.overallSummariesCache[baseUniqueId].hasNegativeValues = true;
			}
			return true;
		}
		return false;
	};

	return OverallSummaryValueQuery;
}(_BaseSummarizerQuery3.default);

exports.default = OverallSummaryValueQuery;

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
var SummarizerHostAPI = function () {
	//The role of the summarizer host API is to communicate with the host application (usu. Explore)
	//The host registers a set of callbacks using the activate api and is notified of changes to stats via those callbacks.
	function SummarizerHostAPI(feature, widgetApi, dashboardApi) {
		_classCallCheck(this, SummarizerHostAPI);

		this.feature = feature;
		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.statsReadyBeforeActivated = false;
	}

	/**
  * Activate the summarizer by supplying callbacks from the host application
  * @param options - The options which includes:
  *					options.cb - a callback for updating default summary data
  *					options.cbSel - a callback for updating selection-based summary data
  *					options.cbDomain - a callback for handling data domains.
  * @returns a promise which is resolved immediately (or, in case where summaries must be
 	 * 			updated on activate, when the update is complete.  (mostly for testing purposes).
  */


	SummarizerHostAPI.prototype.activate = function activate(options) {
		var _this = this;

		this.summaryCollector = this.feature.getSummaryCollector();
		this.selectionSummaryCollector = this.feature.getSelectionSummaryCollector();

		this.cb = options.cb;
		//cbSel is defined for selection callbacks.
		this.cbSel = options.cbSel;
		//cbDomain is defined for domain updating callbacks.
		this.cbDomain = options.cbDomain;

		this.feature.setActivated(true);

		if (this.statsReadyBeforeActivated) {
			//If we attempted to call updateData or updateSelectionData before
			//callbacks were set up, the 'statsReadyBeforeActivated' flag is set (and we need to call again).
			this.statsReadyBeforeActivated = false;
			return this._onStatsReady().then(function () {
				return _this._onSelectedStatsReady();
			});
		}
		return Promise.resolve();
	};

	//Called during render to update the default stats for this render (cached)


	SummarizerHostAPI.prototype.updateSummaries = function updateSummaries() {
		return this._onStatsReady();
	};

	//TODO: This header should probably be taken care of by the host application.


	SummarizerHostAPI.prototype._addHeader = function _addHeader() {
		return [{ id: 'min', name: 'Min' }, { id: 'max', name: 'Max' }, { id: 'avg', name: 'Average' }, { id: 'total', name: 'Total' }, { id: 'totalPercent', name: '%Total' }];
	};

	//Called on a selection change to update the stats for the selections


	SummarizerHostAPI.prototype.updateSelectionSummaries = function updateSelectionSummaries() {
		this._onSelectedStatsReady();
	};

	//Notify the host application of an overall stats update (ie: render/reRender)


	SummarizerHostAPI.prototype._onStatsReady = function _onStatsReady() {
		var stats = this.summaryCollector && this.summaryCollector.getSummaryTableJSON() || {};
		stats.header = this._addHeader();
		//FOR TESTING: console.log('RENDER:', JSON.stringify(stats));

		if (this.cb) {
			this.cb(stats);
		} else {
			this.statsReadyBeforeActivated = true;
		}
		return this.cbDomain && this.cbDomain(stats) || Promise.resolve();
	};

	//Notify the host application of a selection stats update.


	SummarizerHostAPI.prototype._onSelectedStatsReady = function _onSelectedStatsReady() {
		var stats = this.selectionSummaryCollector && this.selectionSummaryCollector.getSummaryTableJSON() || {};
		stats.header = this._addHeader();
		//FOR TESTING: console.log('SELECT:', JSON.stringify(stats));

		if (this.cbSel) {
			this.cbSel(stats);
		} else {
			this.statsReadyBeforeActivated = true;
		}
	};

	return SummarizerHostAPI;
}();

exports.default = SummarizerHostAPI;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * The CombinedSummaryValidator tests that the data that has been summarized in one widget is disjoint from data summarized in another.
 **/
var CombinedSummaryValidator = function () {
	/**
  * @Constructor
  * @param {Object} widgetApi - the widgetApi for the widget being summarized.
  */
	function CombinedSummaryValidator(widgetApi, dashboardApi, logger) {
		_classCallCheck(this, CombinedSummaryValidator);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.otherWidgetApi = null;
		this.logger = logger;
	}

	/**
  * add an 'other' widgetApi to test against.
  * The validate() method will determine if the summarized data in otherWidgetApi and summarized data in this widgetApi
  * would lead to double-counting
  * @param otherWidgetApi - the widget to compare against.
  */


	CombinedSummaryValidator.prototype.combineSummariesWith = function combineSummariesWith(otherWidgetApi) {
		this.otherWidgetApi = otherWidgetApi;
	};

	/**
  * The combined summary validator is only initialized once it has 2 widgetApi's to test.
  */


	CombinedSummaryValidator.prototype.isInitialized = function isInitialized() {
		return !!(this.widgetApi && this.otherWidgetApi);
	};

	/**
  * Validate that the data in the widgets being combined are disjoint.
  * Disjoint data can be combined (aka summed)
  * Non-Disjoint data means summing would result in double-counting.
  * @return true if the data being summarized in the two widgets can be combined.
  */


	CombinedSummaryValidator.prototype.validate = function validate() {
		var thisVisAPI = this.widgetApi.getVisualization();
		var otherVisAPI = this.otherWidgetApi.getVisualization();

		//Same module? (if not, the answer is no)
		if (thisVisAPI && otherVisAPI && thisVisAPI.getDataSource().getId() === otherVisAPI.getDataSource().getId()) {
			return this._testForDisjointFilters(thisVisAPI, otherVisAPI);
		}

		//Disjoint local filters?
		return Promise.resolve(false);
	};

	//Use a server query to test if data in two widgets is disjoint or not.
	//Limitation: The two widgets must be against the same dataset.
	//
	//Perform the test by combining the filters of both widgets and executing a single item query for a measure.
	//If the data returned is null, the two visualizations are presenting disjoint data.


	CombinedSummaryValidator.prototype._testForDisjointFilters = function _testForDisjointFilters(thisVisAPI, otherVisAPI) {
		var _this = this,
		    _arguments = arguments;

		var queryDef = this._createQuerySpecForDisjointFilterTest(thisVisAPI, otherVisAPI);
		if (!queryDef || !queryDef.dataItems || !queryDef.filters) {
			return Promise.resolve(false);
		}
		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var visualization = content.getFeature('Visualization');
		var queryService = this.dashboardApi.getFeature('QueryService');
		var dataSource = visualization.getDataSource();

		var aggregations = queryDef.dataItems.map(function (dataItem) {
			return dataItem.getAggregation();
		});
		var columnIds = queryDef.dataItems.map(function (dataItem) {
			return dataItem.getColumnId();
		});
		var filters = queryDef.filters;

		return queryService.getColumnValues(dataSource.getId(), columnIds, filters, undefined, [], aggregations).then(function (queryResultData) {
			//const queryResultData = queryService.createQueryResultData(testQueryResults);
			var rowCount = queryResultData && queryResultData.getRowCount();
			if (rowCount === 0) {
				return true;
			} else if (rowCount === 1) {
				var cellValue = queryResultData.getValue(0, 0);
				var projectedItemAggregate = queryDef.dataItems[0].getAggregation();
				if (projectedItemAggregate === 'count' || projectedItemAggregate === 'countdistinct') {
					//Countable aggregation types will come back as 0 when there is no intersection.
					return cellValue && cellValue.v === 0 ? true : false;
				}
				return cellValue && cellValue.v === null ? true : false;
			}
			return false;
		}).catch(function () {
			//If the query fails for some reason, log the error but don't be destructive.  Simply return that the data is not disjoint.
			_this.logger.error('An error occured while testing for disjoint filters', _arguments, thisVisAPI);
			return false;
		});
	};

	/**
  * Create a queryDefinition that can be used to detect whether filters are disjoint in two widgets
  * If there are structures in the data that
  * @returns a queryDef if the query should be performed or null if there is no need to query.
  */


	CombinedSummaryValidator.prototype._createQuerySpecForDisjointFilterTest = function _createQuerySpecForDisjointFilterTest(thisVisAPI, otherVisAPI) {
		var queryDef = {
			dataItems: [],
			filters: []
		};

		//Extract the first projected ordinal (really, could be any ordinal or any measure dataItem in the dataset)
		//Using a measure with no projected categories ensures a single row query result.
		var firstOrdinal = thisVisAPI.getSlots().getDataItemList().find(function (d) {
			return d.getType() === 'fact';
		});
		var otherApiOrdinal = otherVisAPI.getSlots().getDataItemList().find(function (d) {
			return d.getType() === 'fact';
		});

		if (!firstOrdinal || !otherApiOrdinal) {
			//No need to query...we can't support a chart that has no ordinals.
			return null;
		}

		queryDef.dataItems = [firstOrdinal];

		if (!thisVisAPI.getLocalFilters().getFilterList().length || !otherVisAPI.getLocalFilters().getFilterList().length) {
			//If either widget has no filters, there's no need to query....the data overlaps.
			return null;
		}

		thisVisAPI.getLocalFilters().getFilterList().forEach(function (filterEntry) {
			queryDef.filters.push(filterEntry);
		});

		otherVisAPI.getLocalFilters().getFilterList().forEach(function (filterEntry) {
			queryDef.filters.push(filterEntry);
		});

		return queryDef;
	};

	return CombinedSummaryValidator;
}();

exports.default = CombinedSummaryValidator;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseSummarizerQuery2 = __webpack_require__(56);

var _BaseSummarizerQuery3 = _interopRequireDefault(_BaseSummarizerQuery2);

var _FilteredSummaryValueQuery = __webpack_require__(115);

var _FilteredSummaryValueQuery2 = _interopRequireDefault(_FilteredSummaryValueQuery);

var _SummaryCollector = __webpack_require__(116);

var _SummaryCollector2 = _interopRequireDefault(_SummaryCollector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The CombinedSummaryValueQuery determines when and how to query for a combined summary value based on a set of rules.
 * A caller simply calls the function and a value is returned which is either null or the query result as values in a
 * summary collector (for the ones it calculated).
 * In general, the query works by producing an "OR'ed result" of the filter state of the widgets passed in in the constructor.
 * Currently, this query is only made for aggregation type countdistinct but in theorym, could be extended to other aggregation types.
 */
var CombinedSummaryValueQuery = function (_BaseSummarizerQuery) {
	_inherits(CombinedSummaryValueQuery, _BaseSummarizerQuery);

	/**
  * @Constructor
  * @param {Object} widgetApis - An array of widgetApis to consider.
  * @param {Object} dashboardApi - the dashboardApi
  * @param {Object} logger - The logger
  * @param {boolean} isSelectionStats - true if this is a selection summary.
  * @param {Object} summaryCollector - (optional) For testing.
  */
	function CombinedSummaryValueQuery(widgetApis, dashboardApi, logger, isSelectionStats) {
		var summaryCollector = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

		_classCallCheck(this, CombinedSummaryValueQuery);

		var _this = _possibleConstructorReturn(this, _BaseSummarizerQuery.call(this, widgetApis[0], dashboardApi, logger));

		_this.widgetApis = widgetApis;

		_this.summaryCollector = summaryCollector || new _SummaryCollector2.default(dashboardApi, _this.widgetApi, isSelectionStats);

		_this.summaryValueQueries = [];
		widgetApis.forEach(function (widgetApi) {
			//When doing combined summaries, we don't want to use cached single values
			//Because they need to be "OR'ed" into the combined filter.
			_this.summaryValueQueries.push(new _FilteredSummaryValueQuery2.default(widgetApi, dashboardApi, logger));
		});

		_this.widgetFilters = [];
		_this.isSelectionStats = isSelectionStats;
		return _this;
	}

	/**
  * @returns true if some unprocessed item is common to both visualizations.
  */


	CombinedSummaryValueQuery.prototype.hasUnprocessedItems = function hasUnprocessedItems() {
		var commonItems = null;
		this.summaryValueQueries.forEach(function (summaryValueQuery) {
			var thisWidgetItems = summaryValueQuery.getUnprocessedItems();
			commonItems = commonItems ? commonItems.filter(function (checkItem) {
				return thisWidgetItems.indexOf(checkItem) !== -1;
			}) : thisWidgetItems;
		});
		return commonItems.length > 0;
	};

	/**
  * Build a query definition for the combined Summary value query if it applies.
  * The items/widgets involved in the query must meet a number of conditions in order to build the query definition.
  * If they do not meet the criteria, no query is needed and this funtion returns null.
  * @returns queryDef - a queryDefinition JSON spec (or NULL if no query should be executed)
  */


	CombinedSummaryValueQuery.prototype.build = function build() {
		var _this2 = this;

		var queryDef = {
			dataItems: [],
			projections: []
		};

		//RULE: Need at least 2 widgets (query object) to need a combined value.
		if (this.summaryValueQueries.length < 2) {
			return null;
		}
		var widgetsWithSummaryItemsToCombine = 0;
		var commonItems = null;
		this.summaryValueQueries.forEach(function (summaryValueQuery) {
			queryDef.dataItems = [];
			queryDef.projections = [];
			summaryValueQuery.build(_this2.summaryCollector, queryDef, _this2.isSelectionStats);
			//Keep tabs on the number of widgets whose summaries need to be combined (have countdistinct measures)
			widgetsWithSummaryItemsToCombine += queryDef.dataItems.length > 0 ? 1 : 0;
			//Only widgets where both have the same countdistinct itemId need a combinedSummaryValue
			var thisWidgetItems = queryDef.dataItems.map(function (dataItem) {
				return dataItem.aggregate + ':' + dataItem.itemId;
			});
			commonItems = commonItems ? commonItems.filter(function (checkItem) {
				return thisWidgetItems.indexOf(checkItem) !== -1;
			}) : thisWidgetItems;

			if (queryDef.filters && queryDef.filters.length > 0) {
				_this2.widgetFilters.push(queryDef.filters);
				queryDef.filters = null;
			}
		});

		//RULE: Need at least 2 queries with applicable items (count distinct measures) to need a combined value.
		if (widgetsWithSummaryItemsToCombine < 2) {
			return null;
		}

		//RULE: Need at least 2 queries with common items to need a combined value.
		if (commonItems.length === 0) {
			return null;
		}

		//Now that we've collected all of the filters, "OR" them together (or return [] if either has no filters.)
		queryDef.filters = this.combineFilters();

		return queryDef;
	};

	/**
  * If necessary, execute a query for summary values combined across the set of visualizations
  * specified in the constructor.
  * @returns a promise with the query result....or null if no query needed to execute (see build rules)
  */


	CombinedSummaryValueQuery.prototype.execute = function execute() {
		var _this3 = this;

		var queryDef = this.build();
		if (!queryDef) {
			return Promise.resolve(null);
		}

		//Query for any summaries that passed all the "need to query rules"
		return this._execute(this.summaryCollector, queryDef).then(function () {
			return _this3.summaryCollector;
		});
	};

	/**
  * Process the value of an item returned from the query by adding it to the summaryCollector
  * @param {String} dataItemUniqueId - the id of the dataItem.
  * @param {String} aggregate - the aggregation type (eg countdistinct)
  * @param {String} filteredSummaryUseValue - the actual value (to be added as the filteredSummaryUseValue)
  * @param {Object} summaryCollector - the summaryCollector to add the value to.
  */


	CombinedSummaryValueQuery.prototype.processValue = function processValue(dataItemUniqueId, aggregate, filteredSummaryUseValue, summaryCollector) {
		this.updateSummaryEntry(summaryCollector, dataItemUniqueId, filteredSummaryUseValue, 'filteredSummaryValueUse', 'filteredSummaryValue');
	};

	/**
  * Produce a combined summary result by OR'ing the filters on the two visualizations.
  * ie: if Widget1 is filtered on Canada and Mexico and widget2 is filtered on USA,
  * the combined count would be the union count for Canada, USA and Mexico
  * @returns a filterJSON spec that is the union of A and B.  If A or BV has no filters, it returns [].
  */


	CombinedSummaryValueQuery.prototype.combineFilters = function combineFilters() {
		if (this.widgetFilters.length < 2) {
			//If either of the widgets are unfiltered, OR is like ALL so no filtering is needed.
			return [];
		}

		var combinedFilters = {
			operator: 'or',
			values: []
		};

		this.widgetFilters.forEach(function (filters) {
			var widgetFilters = { operator: 'and', values: [] };
			filters.forEach(function (widgetFilter) {
				//TODO: guard against post-aggregate filters.
				widgetFilters.values.push(widgetFilter);
			});
			combinedFilters.values.push(widgetFilters);
		});
		return [combinedFilters];
	};

	return CombinedSummaryValueQuery;
}(_BaseSummarizerQuery3.default);

exports.default = CombinedSummaryValueQuery;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VisImageCaptureController = __webpack_require__(496);

var _VisImageCaptureController2 = _interopRequireDefault(_VisImageCaptureController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var API_METHODS = [
// host applications can use these api's to turn on/off image-capture feature
'activate', 'deactivate', 'isActivated',

// image capture specific APIs
'registerCaptureHandlers'];

/**
 * Visualization image capture feature is used to manage the thumbnail
 * generation in widgets.
 **/

var VisImageCaptureFeature = function () {

	/**
  * Visualization Image Capture feature constructor
  *
  * @param {WidgetAPI} widgetApi - widget API
  * @param {DashboardAPI} dashboardApi - dashboard API
  * @param {VisImageCaptureController} [controller] - feature controller
  */
	function VisImageCaptureFeature(widgetApi, dashboardApi, controller) {
		_classCallCheck(this, VisImageCaptureFeature);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;

		this._activated = false;

		this.controller = controller || new _VisImageCaptureController2.default(this, widgetApi, dashboardApi);
	}

	/**
  * Visualization Image Capture feature destructor
  */


	VisImageCaptureFeature.prototype.destroy = function destroy() {
		this.deactivate();
		this.controller.destroy();
		this.controller = null;
	};

	/**
  * Get feature API
  *
  * @return {VisImageCaptureFeatureAPI} API
  */


	VisImageCaptureFeature.prototype.getAPI = function getAPI() {
		var _this = this;

		var api = {};
		API_METHODS.forEach(function (method) {
			return api[method] = _this[method].bind(_this);
		});
		return api;
	};

	/**
  * Activate feature
  *
  * @param {Object} [options={}] - options
  */


	VisImageCaptureFeature.prototype.activate = function activate() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		this._activated = true;
		this.controller.activate(options);
	};

	/**
  * Deactivate feature
  */


	VisImageCaptureFeature.prototype.deactivate = function deactivate() {
		this._activated = false;
		this.controller.deactivate();
	};

	/**
  * Check whether the feature is activated
  *
  * @return {boolean} TRUE if activated and FALSE if not
  */


	VisImageCaptureFeature.prototype.isActivated = function isActivated() {
		return this._activated;
	};

	/**
  * Register a capture handlers handler
  *
  * @param {Function} success - callback to call on successful image capture
  * @param {Function} error - callback to call on error image capture
  */


	VisImageCaptureFeature.prototype.registerCaptureHandlers = function registerCaptureHandlers(success, error) {
		this.controller.registerCaptureHandlers(success, error);
	};

	return VisImageCaptureFeature;
}();

VisImageCaptureFeature.API_METHODS = API_METHODS;

exports.default = VisImageCaptureFeature;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: BI Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


/**
 * The Visualization image capture controller is used to interact with the
 * liveWidget view and event handlers.
 **/
var VisImageCaptureController = function () {

	/**
  * Constructor
  *
  * @param {VisImageCaptureFeature} feature - Visualization image capture instance
  * @param {WidgetAPI} widgetApi - widget API
  * @param {DashboardAPI} dashboardApi - dashboard API
  */
	function VisImageCaptureController(feature, widgetApi, dashboardApi) {
		var _this = this;

		_classCallCheck(this, VisImageCaptureController);

		this.delay = function () {
			var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

			return new Promise(function (resolve) {
				_this.timeout = setTimeout(resolve, time);
			});
		};

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this.feature = feature;

		// any callbacks registered with activate will be called each thumbnail generation
		this._resetCaptureHandlers();

		//Internal handlers
		this._widgetApiHandlers = {
			onRenderStart: null,
			onRenderComplete: null
		};
	}

	VisImageCaptureController.prototype._resetCaptureHandlers = function _resetCaptureHandlers() {
		this._captureHandlers = {
			success: [],
			error: [],
			warning: [],
			clear: [],
			relink: []
		};
	};

	/**
  * Activate controller
  *
  * @param [options] - an object that contains (currently) 1 callback  'cbOnThumbnailGenerated'
  */


	VisImageCaptureController.prototype.activate = function activate() {
		var _this2 = this;

		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


		if (options.captureHandlers) {
			if (options.captureHandlers.success) {
				this.registerSuccessCaptureHandler(options.captureHandlers.success);
			}
			if (options.captureHandlers.error) {
				this.registerErrorCaptureHandler(options.captureHandlers.error);
			}
			if (options.captureHandlers.warning) {
				this.registerWarningCaptureHandler(options.captureHandlers.warning);
			}
			if (options.captureHandlers.clear) {
				this.registerClearCaptureHandler(options.captureHandlers.clear);
			}
			if (options.captureHandlers.relink) {
				this.registerRelinkCaptureHandler(options.captureHandlers.relink);
			}
		}
		var canvas = this.dashboardApi.getCanvas();
		var content = canvas && canvas.getContent(this.widgetApi.getId());
		var state = content && content.getFeature('state');
		state && state.whenStatusChanges(state.STATUS.RENDERED).then(function () {
			var initialRenderInfo = {
				isInitial: true,
				isResizing: false
			};
			_this2.onRenderStart(initialRenderInfo);
			_this2.onRenderComplete(initialRenderInfo);

			if (!_this2._widgetApiHandlers.onRenderStart) {
				//todo: no equivalent new api for this.widgetApi.on;
				_this2._widgetApiHandlers.onRenderStart = _this2.widgetApi.on('renderStart', _this2.onRenderStart, _this2);
			}
			if (!_this2._widgetApiHandlers.onRenderComplete) {
				//todo: no equivalent new api for this.widgetApi.on;
				_this2._widgetApiHandlers.onRenderComplete = _this2.widgetApi.on('renderComplete', _this2.onRenderComplete, _this2);
			}
		});

		this.dashboardApi.getDashboardSvc('.LifeCycleManager').then(function (LifeCycleManager) {
			LifeCycleManager.registerLifeCycleHandler('pre:relink', _this2.onRelinkStart.bind(_this2));
		});
	};

	/**
  * Deactivate controller
  */


	VisImageCaptureController.prototype.deactivate = function deactivate() {
		if (this._widgetApiHandlers.onRenderComplete) {
			this._widgetApiHandlers.onRenderComplete.remove();
			this._widgetApiHandlers.onRenderComplete = null;
		}

		// clear out the capture handlers
		this._resetCaptureHandlers();
		return Promise.resolve();
	};

	/**
  * Destructor
  */


	VisImageCaptureController.prototype.destroy = function destroy() {
		this._onThumbnailGeneratedHandlers = [];
		this.deactivate();
	};

	/**
  * Register capture handlers
  *
  * @param {Function} [successCallback=null] - success capture handler
  * @param {Function} [errorCallback=null] - error capture handler
  */


	VisImageCaptureController.prototype.registerCaptureHandlers = function registerCaptureHandlers() {
		var successCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var errorCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var warningCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		if (successCallback) {
			this.registerSuccessCaptureHandler(successCallback);
		}
		if (errorCallback) {
			this.registerErrorCaptureHandler(errorCallback);
		}
		if (warningCallback) {
			this.registerWarningCaptureHandler(warningCallback);
		}
	};

	/**
  * Register success capture handler
  *
  * @param {Function} callback - success callback handler to register
  */


	VisImageCaptureController.prototype.registerSuccessCaptureHandler = function registerSuccessCaptureHandler(callback) {
		this._captureHandlers.success.push(callback);
	};

	/**
  * Register waring capture handler
  * @param {Function} callback - warning callback handler to register
  */


	VisImageCaptureController.prototype.registerWarningCaptureHandler = function registerWarningCaptureHandler(callback) {
		this._captureHandlers.warning.push(callback);
	};

	/**
  * Register error capture handler
  *
  * @param {Function} callback - error callback handler to register
  */


	VisImageCaptureController.prototype.registerErrorCaptureHandler = function registerErrorCaptureHandler(callback) {
		this._captureHandlers.error.push(callback);
	};

	/**
  * Register clear capture handler
  *
  * @param {Function} callback - clear callback handler to register
  */


	VisImageCaptureController.prototype.registerClearCaptureHandler = function registerClearCaptureHandler(callback) {
		this._captureHandlers.clear.push(callback);
	};

	/**
  * Register relink capture handler
  *
  * @param {Function} callback - clear callback handler to register
  */


	VisImageCaptureController.prototype.registerRelinkCaptureHandler = function registerRelinkCaptureHandler(callback) {
		this._captureHandlers.relink.push(callback);
	};

	/**
  * Call all previously registered success capture handlers
  */


	VisImageCaptureController.prototype.callSuccessCaptureHandlers = function callSuccessCaptureHandlers(result) {
		this._captureHandlers.success.forEach(function (callback) {
			return callback(result);
		});
	};

	/**
  * Call all previously registered error capture handlers
  */


	VisImageCaptureController.prototype.callErrorCaptureHandlers = function callErrorCaptureHandlers(error) {
		this._captureHandlers.error.forEach(function (callback) {
			return callback(error);
		});
	};

	/**
  * Call all previously registered warning capture handlers
  */


	VisImageCaptureController.prototype.callWarningCaptureHandlers = function callWarningCaptureHandlers() {
		var warning = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { message: 'Widget has a warning.' };

		this._captureHandlers.warning.forEach(function (callback) {
			return callback(warning);
		});
	};

	/**
  * Call all previously registered clear capture handlers
  */


	VisImageCaptureController.prototype.callClearCaptureHandlers = function callClearCaptureHandlers() {
		this._captureHandlers.clear.forEach(function (callback) {
			return callback();
		});
	};

	/**
  * Call all previously registered clear capture handlers
  */


	VisImageCaptureController.prototype.callRelinkCaptureHandlers = function callRelinkCaptureHandlers() {
		this._captureHandlers.relink.forEach(function (callback) {
			return callback();
		});
	};

	/**
  * Check whether a specific renderInfo needs regeneration
  *
  * @param {object} renderInfo - rendering information
  * @param {boolean} [renderInfo.isResizing] - boolean to signal whether renderComplete happened as a result of a resize or not
  *
  * @return {boolean} TRUE if needs re-generation and FALSE if not
  */


	VisImageCaptureController.prototype.needsReGeneration = function needsReGeneration(renderInfo) {
		return !renderInfo.isResizing;
	};

	/**
  * Check whether a specific renderInfo needs clearing
  *
  * @param {object} renderInfo - render information
  * @param {boolean} [renderInfo.isInitial] - boolean to signal whether renderStart happened as a result of an initial render or not
  * @param {boolean} [renderInfo.isResizing] - boolean to signal whather renderStart happened as a result of a resize or not
  *
  * @return {boolean} TRUE if needs clearing or not
  */


	VisImageCaptureController.prototype.needsClearing = function needsClearing(renderInfo) {
		return !renderInfo.isResizing && !renderInfo.isInitial;
	};

	/**
  * Handler called on widget render start
  *
  * @param {object} [renderInfo={}] - render information
  * @param {boolean} [renderInfo.isInitial] - boolean to signal whether renderStart happened as a result of an initial render or not
  * @param {boolean} [renderInfo.isResizing] - boolean to signal whather renderStart happened as a result of a resize or not
  */


	VisImageCaptureController.prototype.onRenderStart = function onRenderStart() {
		var renderInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		//todo: no equivalent new api;
		if (this.widgetApi.hasError() || this.needsClearing(renderInfo)) {
			this.callClearCaptureHandlers();
		}
	};

	/**
  * Handler called on widget render complete
  *
  * @param {object} [renderInfo={}] - render information
  * @param {boolean} [renderInfo.isResizing=false] - boolean to signal whether renderComplete happened as a result of a resize or not
  *
  * @return {Promise} Promise that is resolved or rejected based on the success of the image capture
  */


	VisImageCaptureController.prototype.onRenderComplete = function onRenderComplete() {
		var _this3 = this;

		var renderInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		var promise = void 0;
		//todo: no equivalent new api;
		if (this.widgetApi.hasError()) {
			this.callErrorCaptureHandlers(new Error('Widget has error'));
			promise = Promise.resolve();
			//todo: no equivalent new api;
		} else if (this.widgetApi.hasWarning()) {
			this.callWarningCaptureHandlers();
			promise = Promise.resolve();
		} else if (this.needsReGeneration(renderInfo)) {
			this.timeout && clearTimeout(this.timeout);
			promise = this.delay().then(function () {
				return _this3._generateCapture();
			}).then(function (result) {
				return _this3.callSuccessCaptureHandlers(result);
			}).catch(function (error) {
				return _this3.callErrorCaptureHandlers(error);
			});
		} else {
			promise = Promise.resolve();
		}
		return promise;
	};

	// introduce a setTimeout to slightly delay thumbnail generation to allow explore's properties panel to finish rendering


	/**
  * Handler called right before relink process starts
  */
	VisImageCaptureController.prototype.onRelinkStart = function onRelinkStart() {
		this.callRelinkCaptureHandlers();
	};

	VisImageCaptureController.prototype._generateCapture = function _generateCapture() {

		var thumbnailConfig = this.dashboardApi.getAppConfig('thumbnail');

		if (!thumbnailConfig) {
			return Promise.resolve();
		}
		//todo: no equivalent new layoutAPI;
		var layoutApi = this.widgetApi.getLayoutAPI();

		var _layoutApi$getSelfRat = layoutApi.getSelfRatio(),
		    widthRatio = _layoutApi$getSelfRat.width,
		    heightRatio = _layoutApi$getSelfRat.height;

		var _thumbnailConfig$size = thumbnailConfig.size,
		    widthConfig = _thumbnailConfig$size.width,
		    heightConfig = _thumbnailConfig$size.height,
		    _thumbnailConfig$type = thumbnailConfig.type,
		    type = _thumbnailConfig$type === undefined ? 'svg' : _thumbnailConfig$type;

		// 244560: since we cant properly scale svg using viewBox(+ some other attribute) as it crashes IE11,
		// and we apply 8px padding on each side within thumbnail, we request an image deducting 16 to account for padding.
		// When VIDA identifies which attribute(in concert with viewBox) causes IE11 to crash, we can remove deduction of 16px
		// from thumbnail dimentions below and use viewBox to scale SVG correctly.

		var imageWidth = widthConfig * widthRatio - 16;
		var imageHeight = heightConfig * heightRatio - 16;

		var size = {
			width: imageWidth,
			height: imageHeight
		};
		//todo: no equivalent new APIs.
		return this.widgetApi.getVisApi().generateThumbnail({
			size: size,
			type: type
		}).then(function (result) {
			var res = void 0;

			var thumbnail = void 0;
			if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
				thumbnail = result.thumbnail;
			} else {
				thumbnail = result;
			}

			if (thumbnail) {
				// for now, we'll pre-process the thumbnail and remove it manually,
				// but there is a fix coming, whenever that is fixed, this hack can be removed
				// more info: RTC 217310
				var content = (0, _jquery2.default)(thumbnail);
				var wrappedContent = (0, _jquery2.default)('<div>').append(content);
				content.first().removeAttr('class').attr('class', 'visThumbnail');
				res = wrappedContent.html();
			}
			return _extends({}, (typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' ? result : {}, {
				thumbnail: res
			});
		});
	};

	return VisImageCaptureController;
}();

exports.default = VisImageCaptureController;

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var VisTitleFetcherFeature = function () {
	function VisTitleFetcherFeature(widgetApi, dashboardApi) {
		_classCallCheck(this, VisTitleFetcherFeature);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this._initialRequestDone = false;

		this._widgetApiHandlers = {
			_onRenderStart: this.widgetApi.on('renderStart', this._onRenderStart.bind(this)),
			_onChangeDefinition: this.widgetApi.on('visevent:changeDefinition', this._triggerTitleUpdate.bind(this))
		};

		this._dashboardApiHandlers = {
			_onShapingModelChange: this.dashboardApi.on('shapingmodel:changed', this._onShapingModelChange, this)
		};
	}

	VisTitleFetcherFeature.prototype.destroy = function destroy() {
		this._deregisterAllListeners();
		return Promise.resolve(true);
	};

	VisTitleFetcherFeature.prototype._deregisterAllListeners = function _deregisterAllListeners() {
		this._deregisterOnRenderStartListener();

		if (this._widgetApiHandlers._onChangeDefinition) {
			this._widgetApiHandlers._onChangeDefinition.remove();
			this._widgetApiHandlers._onChangeDefinition = null;
		}
		if (this._dashboardApiHandlers._onShapingModelChange) {
			this._dashboardApiHandlers._onShapingModelChange.remove();
			this._dashboardApiHandlers._onShapingModelChange = null;
		}
	};

	VisTitleFetcherFeature.prototype._deregisterOnRenderStartListener = function _deregisterOnRenderStartListener() {
		if (this._widgetApiHandlers._onRenderStart) {
			this._widgetApiHandlers._onRenderStart.remove();
			this._widgetApiHandlers._onRenderStart = null;
		}
	};

	/**
  * Handler called on widget render start
  * Only trigger title update for initial render when title is not already set in the LW model
  * This covers 2 cases:
  * 	- setting title in Live widget preview in comet card
  *  - add LW from dashboard into explore
  * For all the other cases, title is set in the widget spec before its loaded
  * or title is set on data slot change (already handled in Live widget)
  */


	VisTitleFetcherFeature.prototype._onRenderStart = function _onRenderStart() {
		var visApi = this.widgetApi.getVisApi();
		if (visApi && !this._initialRequestDone) {
			this._initialRequestDone = true;
			this._deregisterOnRenderStartListener();
			if (!visApi.getTitle()) {
				this.widgetApi.updateTitle && this.widgetApi.updateTitle();
			}
		}
	};

	/**
  * Handler is called on dashboard api shaping model change
  * Idea is to only trigger title update when the no refresh flag is false (i.e. needs to refresh)
  * eg. Change the name of a context calculation
  * 1) The calculation is projected in the visualization -> title update is called in widgetApi
  * 2) The calculation is not projected in the visualization -> title update is not called
  * shaping model change can trigger onRenderStart above but it is handled here
  * because there can exist a title already, a new title needs to replace the old one.
  *
  * @param {object} [payload] - event payload
  * @param {boolean} [payload.noRefresh] - boolean to signal whether widget needs to be refreshed hence the title needs to update
  */


	VisTitleFetcherFeature.prototype._onShapingModelChange = function _onShapingModelChange(payload) {
		if (payload && !payload.noRefresh) {
			this._triggerTitleUpdate();
		}
	};

	VisTitleFetcherFeature.prototype._triggerTitleUpdate = function _triggerTitleUpdate() {
		this.widgetApi.updateTitle && this.widgetApi.updateTitle();
	};

	return VisTitleFetcherFeature;
}();

exports.default = VisTitleFetcherFeature;

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _StringResources = __webpack_require__(1);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019, 2022
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var MULTI_MEASURES_SERIES = '_multiMeasuresSeries';

var ShowByAction = function () {
	function ShowByAction(options) {
		_classCallCheck(this, ShowByAction);

		this.content = options.content;
		this.content.getFeature('DataPointActions').registerProvider('ShowByAction', this);
		this.dashboardApi = options.dashboardAPI;
		this.visApi = null;
		this._showbyIdCntr = 0;
	}

	ShowByAction.prototype.getAPI = function getAPI() {
		return {
			setOnSelectCallback: this.setOnSelectCallback.bind(this)
		};
	};

	ShowByAction.prototype.setOnSelectCallback = function setOnSelectCallback(onSelect) {
		this.onSelectCallback = onSelect.cb;
	};

	ShowByAction.prototype._resetVisInfo = function _resetVisInfo() {
		this.visApi = this.content.getFeature('WidgetAPI.deprecated').getVisApi();
		this._projectedDataItems = null;
		var visDefinition = this.visApi && this.visApi.getDefinition && this.visApi.getDefinition();
		this._isMapWidget = visDefinition && visDefinition.geo;
		this._isCrosstabWidget = visDefinition && visDefinition.id === 'crosstab';
		this._module = this.visApi.getModule();
		this.model = this.visApi.ownerWidget.model;
	};

	ShowByAction.prototype.getDataPointActionList = function getDataPointActionList(selections, actionOptions) {
		if (this.dashboardApi.getApplicationName() !== 'explore') {
			return [];
		}
		// This class is constructed once but this method is called at each selection, so it's the good place to update the private members of this class at each user selection
		this._resetVisInfo();

		var sEventGroupId = this.visApi ? this.visApi.getEventGroupId() : null;
		var pageContextItems = this.visApi.getPageContextAPI().getPageContextItems ? this.visApi.getPageContextAPI().getPageContextItems({ scope: this.visApi.getScope(), origin: 'visualization', eventGroupId: sEventGroupId }) : [];
		var oSelectedItems = this._getBrushingItemThatMatchesSelection(pageContextItems);
		if (!oSelectedItems.length) {
			return [];
		}
		for (var _iterator = oSelectedItems, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var selectedItem = _ref;

			// disable showBy if any selected item has autogroup
			if (this._hasAutoGroupColumn(selectedItem)) {
				return [];
			}

			// disable showBy if any selected column is of type latitude or longitude as we can not map other geographical column like city, country, etc... to the latitude/longitude layer (defect 272143)
			if (this._hasLongitudeLatitudeColumn(selectedItem)) {
				return [];
			}
		}
		var setToolbar = this.setToolbar.bind(this);
		var viewOptions = this._getViewOptions(oSelectedItems, actionOptions.selections);
		if (!viewOptions) {
			// no candidate columns for showBy
			return [];
		}
		var nValueCount = this._getValueCountOfBrushingItems(oSelectedItems);
		this.compareByCase = nValueCount === 2;
		this.pageContextItems = oSelectedItems;

		var label = this.compareByCase ? _StringResources2.default.get('compare_by_label') : _StringResources2.default.get('show_by_label');
		// showBy is enabled when 1 or more than 3 data points are selected, otherwise enable compareBy
		return [{
			name: 'ShowByAction',
			label: label,
			text: label,
			type: 'NextView',
			order: 251, // as per design, this action is after 'Exclude', see dashboard-common/src/utils/ActionTypes.js for details.
			viewModule: 'explore/showByView',
			viewOptions: viewOptions,
			enableGoPrevious: false,
			setToolbar: setToolbar
		}];
	};

	ShowByAction.prototype._hasAutoGroupColumn = function _hasAutoGroupColumn(selectedItem) {
		var autoGroup = this.dashboardApi.getFeature('DataSources.CustomBinUI');
		var sourceId = selectedItem.getSourceId();
		var itemIds = selectedItem.getItemIds();
		if (sourceId && itemIds && itemIds.length) {
			return itemIds.some(function (itemId) {
				return !!autoGroup.getCustomBinning(sourceId, itemId);
			});
		}
		return false;
	};

	ShowByAction.prototype._hasLongitudeLatitudeColumn = function _hasLongitudeLatitudeColumn(selectedItem) {
		var _this = this;

		if (this._isMapWidget) {
			var itemIds = selectedItem.getItemIds();
			if (itemIds && itemIds.length) {
				return itemIds.some(function (itemId) {
					return _this._getGeoTaxonomy(itemId).isLatLong;
				});
			}
			return false;
		}
	};

	/*
 * This function returns the value count of page context items generated by the selections
 * which helps to determine if showBy or compareBy should be enabled.
 * @return {number} valueCount - 2 means compareBy, other number means showBy
 * If the selection generates 1 page context item and it has:
 *	- 2 values => compareBy will be enabled
 *	- 1 or > 2 values => showBy will be enabled
 * If > 1 page context item (selection in Table):
 *	- enable compareBy only when there is only 1 page context item that has 2 values, all other items have 1 value (2 rows selected)
 *	- enable showBy for other cases
 */


	ShowByAction.prototype._getValueCountOfBrushingItems = function _getValueCountOfBrushingItems(selections) {
		var nValueCount = null;
		if (selections.length === 1) {
			nValueCount = selections[0].getValueCount();
		} else {
			// case Table with many page context item entries
			var itemsWithMoreThanOneValue = selections.filter(function (selection) {
				return selection.getValueCount() > 1;
			});
			if (itemsWithMoreThanOneValue.length === 1 && itemsWithMoreThanOneValue[0].getValueCount() === 2) {
				nValueCount = 2;
			} else {
				nValueCount = 1;
			}
		}
		return nValueCount;
	};

	/**
 * Method to set the toolbar so that we can remove the toolbar on certain actions
 * @param {Object} toolbar from which the action is called (i.e. the dialog opens from)
 */


	ShowByAction.prototype.setToolbar = function setToolbar(toolbar) {
		this.toolbar = toolbar;
	};

	ShowByAction.prototype._getProjectedDataItems = function _getProjectedDataItems() {
		if (this._projectedDataItems && this._projectedDataItems.length) {
			return this._projectedDataItems;
		}
		var dataItemList = this.content.getFeature('Visualization').getSlots().getMappingInfoList().map(function (el) {
			return el.dataItem;
		});
		this._projectedDataItems = dataItemList.filter(function (dataItem) {
			return dataItem.getColumnId() !== MULTI_MEASURES_SERIES;
		}).map(function (dataItem) {
			return dataItem.getColumnId();
		});
		return this._projectedDataItems;
	};

	/*
 * A selection contains 1 or more values of 1 or more itemIds
 * (eg: intersect Year and Country = 2 itemIds and a point like 2007-Canada would be 1 "value" of that intersection)
 * a brushing entry also contains a list of 1 or more itemIds and their values.
 * Usually the brushing and selections are the same but, for navigate, there are additional brushing entries .
 * Make sure we exclude brushing entries that are not visible and at the end, should have only 1 visible brushing entry before counting values.
 */


	ShowByAction.prototype._getBrushingItemThatMatchesSelection = function _getBrushingItemThatMatchesSelection(pageContextItems) {
		if (pageContextItems.length < 2) {
			return pageContextItems;
		}
		var visibleBrushingEntries = [];
		var projectedDataItems = this._getProjectedDataItems();
		pageContextItems.forEach(function (pageContextItem) {
			// this check is to work around the live widget issue where de-select a data point doesn't remove the page context entry,
			// it just removes all values of this entry
			if (pageContextItem.getValueCount && pageContextItem.getValueCount() > 0) {
				var itemIds = pageContextItem.getItemIds();
				if (_underscore2.default.intersection(projectedDataItems, itemIds).length === itemIds.length) {
					// All items in page context entry are projected
					visibleBrushingEntries.push(pageContextItem);
				}
			}
		});
		// For all vis types (except Table), should have only 1 visible brushing entry to be good candidate for showBy/compareBy.
		if (visibleBrushingEntries.length === 1) {
			return visibleBrushingEntries;
		} else {
			// For Table chart: selection of many columns in Table chart generates many page context item entries instead of dataPoint (behaviour since day 1 of gemini),
			// therefore it's still valid for showBy when there are many page context items generated by selection
			var visDefinition = this.visApi && this.visApi.getDefinition && this.visApi.getDefinition();
			var isTableWidget = visDefinition && visDefinition.id === 'JQGrid';
			if (isTableWidget) {
				return visibleBrushingEntries;
			}
		}
		return [];
	};

	ShowByAction.prototype._getViewOptions = function _getViewOptions(pageContextItems, selections) {

		this.slotAndDataItemsToRemap = this._getSlotAndDataItemsToRemap(pageContextItems, selections, this._isCrosstabWidget);
		if (!this.slotAndDataItemsToRemap) {
			return null;
		}
		var showByHandler = this.showByHandler.bind(this);
		var contextColumns = this._getCategoricalColumns();
		var shapingHelper = this._getShapingHelper();
		// do not show the showBy link if there are not other category columns to replace the selected one
		if (!contextColumns.length) {
			return null;
		}
		return {
			// height: 280, // TODO: remove and see if still works
			// width: 400, // TODO: remove and see if still works
			// state: this.state, //Default State // FIXME: this.state is nowhere
			eventHandler: showByHandler,
			widget: this.visApi.ownerWidget,
			slotId: this.slotAndDataItemsToRemap.slotId,
			closeOnActionApplied: true,
			contextColumns: contextColumns,
			shapingHelper: shapingHelper,
			getRecommendedColumns: this.getRecommendedColumns.bind(this)
		};
	};

	/*Get the slot ID and data items that the 'Show by Category' to replace with.
 * If the selection involves only 1 slot, return this slot and selected data items in this slot
 * If many slots are involved, choose 1 slot to replace:
 * 	- For crosstab: when user selects a cell value, both rows and columns slot are involved in the selection, but
 * it's more intuitive to replace "rows" slot than "columns" slot, so return "rows" slot and selected data items of this slot.
 * 	- For other chart types: we see this case for visualizations that also have data in color slot (ex: stack column chart with color data item)
 * in this case,  return the first slot (which is not supposed to be color slot in all visualization definitions) and selected data items
 * @param {Object} result - null or object containing slotId and array of its selected data items
 */


	ShowByAction.prototype._getSlotAndDataItemsToRemap = function _getSlotAndDataItemsToRemap(pageContextItems, selections) {
		var crosstabWidget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		if (selections && selections._aCategorySelections && selections._aCategorySelections.length) {
			var slotToDataItems = selections._slotToCategoryCount;
			var slots = Object.keys(slotToDataItems);
			if (!slots.length) {
				return null;
			}
			var slotId = null;
			if (slots.length === 1 || slots.length > 1 && !crosstabWidget) {
				slotId = slots[0];
			} else {
				// crosstabWidget with both slots involved, return the "rows" slot which is the second slot
				slotId = slots[1];
			}
			var dataItemIds = [];
			pageContextItems.forEach(function (pageContextItem) {
				dataItemIds = dataItemIds.concat(pageContextItem.getItemIds());
			});
			var dataItems = [];
			var _getDataItemsToRemap = function _getDataItemsToRemap() {
				selections._aCategorySelections.forEach(function (selection) {
					if (selection.slot.getId() === slotId) {
						var itemId = selection.slotDataItem.getColumnId();
						// make sure the data item is part of page context because this.selections._aCategorySelections is used for tooltip,
						// it can contain outer columns of table which are not part of the selection
						if (dataItemIds.indexOf(itemId) > -1) {
							dataItems.push({
								id: selection.slotDataItem.getId(),
								itemId: itemId
							});
						}
					}
				});
				return dataItems;
			};
			return {
				slotId: slotId,
				dataItems: _getDataItemsToRemap()
			};
		}
		return null;
	};

	ShowByAction.prototype.showByHandler = function showByHandler(payload) {
		var oPayload = void 0;
		if (payload) {
			oPayload = {
				showByCategory: {
					itemId: payload.context.id,
					caption: payload.context.label,
					id: ''
				},
				slotAndDataItemsToRemap: this.slotAndDataItemsToRemap,
				compareByCase: this.compareByCase,
				pageContextItems: this.pageContextItems
			};
		}
		this.onSelectCategory(oPayload);
	};

	/* Exclude columns that are already in projections of the visualization.
 * For map widget, only take "location" columns. If the selected column has taxonomy = 'location' ,
 * For other vis types, only take "attribute" columns.
 */


	ShowByAction.prototype._isGoodCandidateColumnForShowBy = function _isGoodCandidateColumnForShowBy(column) {
		if (!column) {
			return false;
		}

		var columnId = column.getId();
		if (this._getProjectedDataItems().indexOf(columnId) > -1) {
			return false; //Already projected
		}
		if (this._isMapWidget) {
			return this._getGeoTaxonomy(columnId).isLocation;
		} else {
			return column.getType() === 'attribute';
		}
	};

	ShowByAction.prototype._getGeoTaxonomy = function _getGeoTaxonomy(columnId) {
		var column = this.content.getFeature('Visualization').getDataSource().getMetadataColumn(columnId);
		var isLocation = false;
		var isLatLong = false;
		if (column) {
			var taxonomyList = column.getTaxonomyList();
			if (taxonomyList && taxonomyList.length) {
				var family = taxonomyList[0].getFamily();
				isLocation = taxonomyList[0].getClass() === 'cGeoLocation';
				isLatLong = family === 'cLatitude' || family === 'cLongitude';
			}
		}
		return { isLocation: isLocation, isLatLong: isLatLong };
	};

	ShowByAction.prototype._getCategoryColumnOfKeyDriver = function _getCategoryColumnOfKeyDriver(recommendedItem) {
		var column = this._module.getMetadataColumn(recommendedItem.fieldIDForExpression);
		if (this._isGoodCandidateColumnForShowBy(column)) {
			return column;
		}
		return null;
	};

	ShowByAction.prototype.getRecommendedColumns = function getRecommendedColumns() {
		var _this2 = this;

		var projectedDataItemIds = this._getProjectedDataItems();
		if (!projectedDataItemIds || projectedDataItemIds.length === 0) {
			return Promise.resolve([]);
		}
		var nbTarget = 0;
		var promises = [];
		var renderContext = {
			requestMap: {}
		};

		var visKeyDrivers = this.content.getFeature('VisKeyDrivers');
		visKeyDrivers = visKeyDrivers && visKeyDrivers.isVisKeyDriversFeatureEnabled() ? visKeyDrivers : null;

		projectedDataItemIds.forEach(function (projectedItemId) {
			if (visKeyDrivers) {
				promises.push(visKeyDrivers.refreshPossibleKeyDrivers(projectedItemId, false /* useModelData */));
			} else {
				//TODO: this can be removed when the visKeyDrivers feature flag is removed.
				promises.push(_this2.visApi.whenPossibleKeyDriversAreReady(renderContext, projectedItemId, false /* useModelData */));
			}
		});

		return Promise.all(promises).then(function (allKeyDrivers) {
			var recommendedColumns = [];
			if (allKeyDrivers && allKeyDrivers.length) {
				allKeyDrivers.forEach(function (keyDrivers) {
					if (keyDrivers && keyDrivers.recommendedDrivers && keyDrivers.recommendedDrivers.length) {
						nbTarget++;
						keyDrivers.recommendedDrivers.forEach(function (keyDriver) {
							var column = _this2._getCategoryColumnOfKeyDriver(keyDriver);
							if (column) {
								recommendedColumns.push({
									id: column.getId(),
									label: column.getLabel(),
									moserObject: column.getMoserObject()
								});
							}
						});
					}
				});
			}
			return recommendedColumns;
		}).then(function (recommendedColumns) {
			if (nbTarget > 1) {
				// need to remove duplicate columns in the result
				recommendedColumns = _underscore2.default.uniq(recommendedColumns, function (column) {
					return column.id;
				});
			}
			return recommendedColumns;
		});
	};

	ShowByAction.prototype._getCategoricalColumns = function _getCategoricalColumns() {
		var _this3 = this;

		var columns = [];
		var filterColumnsCallBack = function filterColumnsCallBack(column) {
			return _this3._isGoodCandidateColumnForShowBy(column);
		};
		var metadataColumns = this._module.getMetadataColumns(filterColumnsCallBack);
		if (metadataColumns && metadataColumns.length) {
			metadataColumns.forEach(function (column) {
				var idForExpression = column.getId();
				columns.push({
					value: idForExpression,
					label: column.getLabel(),
					title: idForExpression, // tooltip,
					moserObject: column.getMoserObject()
				});
			});
		}
		return columns;
	};

	ShowByAction.prototype._getShapingHelper = function _getShapingHelper() {
		if (this.isNewShowCompareByEnabled()) {
			return this._module.getShapingHelper();
		}
		return null;
	};

	ShowByAction.prototype.isNewShowCompareByEnabled = function isNewShowCompareByEnabled() {
		if (this.dashboardApi) {
			// Access featureChecker to check feature flag for new edit drivers dialog
			var featureChecker = this.dashboardApi && this.dashboardApi.getGlassCoreSvc('.FeatureChecker');
			return !(featureChecker && featureChecker.checkValue('explore', 'newShowCompareBy', 'false'));
		}
		return false;
	};

	ShowByAction.prototype.onSelectCategory = function onSelectCategory(params) {
		// The onSelectCallback of showBy is in ExploreCard.addShowByCard
		if (this.onSelectCallback) {
			// If transactionId is not passed by caller, start it here and pass it to Explore callback function
			params.payloadOptions = params.payloadOptions || {};
			params.payloadOptions.payloadData = params.payloadOptions.payloadData || {};
			params.payloadOptions.payloadData.undoRedoTransactionId = params.payloadOptions.payloadData.undoRedoTransactionId || _underscore2.default.uniqueId('addShowByCard');
			this.onSelectCallback(this.getNewWidgetSpecs(params), params.payloadOptions.payloadData);
		}
	};

	ShowByAction.prototype.getNewWidgetSpecs = function getNewWidgetSpecs(params) {
		if (!params || !params.pageContextItems) {
			return [];
		}
		this._showbyIdCntr = this._showbyIdCntr || 0;
		params.showByCategory.id = this.visApi.ownerWidget.id + '_showBy_' + ++this._showbyIdCntr;
		var specs = [];
		if (params.compareByCase) {
			specs = this._getWidgetSpecsForCompareBy(params);
		} else {
			specs = this._getWidgetSpecsForShowBy(params);
		}
		// remove visualizationId in filter spec so that dashboard won't treat these filters as brushed filters
		// (dashbpard live-widget relies on this property to distinguish filter for brushed item and local filter)
		specs.forEach(function (spec) {
			if (spec.localFilters && spec.localFilters.length) {
				spec.localFilters.forEach(function (filter) {
					filter.visualizationId = undefined;
				});
			}
		});
		return specs;
	};

	ShowByAction.prototype._getWidgetSpecsForShowBy = function _getWidgetSpecsForShowBy(params) {
		var specs = [];
		/*For showBy, set the option to exclude visible selections to false because
   the visible selections form part of the showBy context */
		var filters = this.visApi.getAllFiltersAsLocalFiltersForPinning( /*excludeVisibleSelections*/false);
		var widgetSpec = this.newWidgetSpecWithFilter(params, filters, this.model);
		// widget id, name and titleHtml should be cleared in order to be regenerated
		widgetSpec = this.removeUnwantedAttributesFromSpec(widgetSpec);
		widgetSpec && specs.push(widgetSpec);
		this.clearSelections(params.payloadOptions);
		return specs;
	};

	ShowByAction.prototype._getWidgetSpecsForCompareBy = function _getWidgetSpecsForCompareBy(params) {
		var filterCount = params.pageContextItems.length;
		var filter1 = this.visApi.getSelectionAsLocalFilters({ includeLocalFilters: true });
		var filter2 = this.visApi.getSelectionAsLocalFilters({ includeLocalFilters: true });
		var nbFilters = filter1.length;
		var i = nbFilters - filterCount;
		while (i < nbFilters) {
			if (filter1[i].values.length === 2) {
				filter1[i].values.splice(1, 1);
				filter2[i].values.splice(0, 1);
			}
			i++;
		}

		var selectionAsFilters = [filter1, filter2];
		var specs = [];
		var widgetSpec = this.newWidgetSpecWithFilter(params, selectionAsFilters[0], this.model);
		widgetSpec = this._addExtraWidgetOptions(widgetSpec);
		// widget id, name and titleHtml should be cleared in order to be regenerated
		widgetSpec = this.removeUnwantedAttributesFromSpec(widgetSpec);
		widgetSpec && specs.push(widgetSpec);
		widgetSpec = this.newWidgetSpecWithFilter(params, selectionAsFilters[1], this.model);
		widgetSpec = this._addExtraWidgetOptions(widgetSpec);
		// widget id, name and titleHtml should be cleared in order to be regenerated
		widgetSpec = this.removeUnwantedAttributesFromSpec(widgetSpec);
		widgetSpec && specs.push(widgetSpec);
		this.clearSelections(params.payloadOptions);
		return specs;
	};

	ShowByAction.prototype.clearSelections = function clearSelections(options) {
		this.visApi.clearSelectionsUsedForShowBy(options);
	};

	ShowByAction.prototype.newDataItem = function newDataItem(showByCategory) {
		return {
			id: showByCategory.id,
			itemId: showByCategory.itemId,
			itemLabel: showByCategory.caption
		};
	};

	ShowByAction.prototype.addDataItem = function addDataItem(widgetModelClone, params) {
		if (!widgetModelClone || !widgetModelClone.data || !widgetModelClone.data.dataViews || widgetModelClone.data.dataViews.length === 0) {
			return null;
		}
		var dataItem = this.newDataItem(params.showByCategory);
		widgetModelClone.data.dataViews[0].dataItems.push(dataItem);
		return dataItem;
	};

	ShowByAction.prototype.updateSlot = function updateSlot(widgetModelClone, params, newDataItemUniqueId) {
		if (!widgetModelClone || !widgetModelClone.slotmapping || !widgetModelClone.slotmapping.slots) {
			return null;
		}
		var slotToRemap = null;
		var dataItemIdsToReplace = [];
		widgetModelClone.slotmapping.slots.some(function (slot) {
			if (slot.name === params.slotAndDataItemsToRemap.slotId) {
				slotToRemap = slot;
				dataItemIdsToReplace = params.slotAndDataItemsToRemap.dataItems.map(function (dataItem) {
					return dataItem.id;
				});
				return true;
			}
			return false;
		});
		if (slotToRemap) {
			if (widgetModelClone.visId === 'JQGrid' || widgetModelClone.visId === 'crosstab') {
				this.updateSlotForCrosstabAndTable(slotToRemap, dataItemIdsToReplace, newDataItemUniqueId);
				this.removeHeatSlotForXtabTable(widgetModelClone);
			} else {
				slotToRemap.dataItems = [newDataItemUniqueId];
				slotToRemap.caption = params.showByCategory.caption;
			}
		}
		if (dataItemIdsToReplace.length) {
			this._removeBrushedItems(widgetModelClone, dataItemIdsToReplace);
		}
		return slotToRemap;
	};

	/*
 * For crosstab and table visualization, we don't replace all columns in the slot, we just replace the selected columns in the slot with the new column.
 * For Table, if there are measures between the replaced columns, make sure we insert the new data item before the measure columns.
 * Ex: table projections are: [cat1, measure1, cat2] and selection contains cat1 and cat2.
 * After updateSlot, projections should become: [newColumn, measure1]
 */


	ShowByAction.prototype.updateSlotForCrosstabAndTable = function updateSlotForCrosstabAndTable(slotToRemap, dataItemIdsToReplace, newDataItemUniqueId) {
		var newDataItems = [];
		var replaceIndex = -1;
		for (var i in slotToRemap.dataItems) {
			if (dataItemIdsToReplace.indexOf(slotToRemap.dataItems[i]) === -1) {
				newDataItems.push(slotToRemap.dataItems[i]);
			} else if (replaceIndex === -1) {
				// replace
				newDataItems.push(newDataItemUniqueId);
				replaceIndex = newDataItems.length - 1;
			}
		}
		slotToRemap.dataItems = newDataItems;
	};

	ShowByAction.prototype.newWidgetSpecWithFilter = function newWidgetSpecWithFilter(params, selectionFilter, model) {
		var modelJSON = model.toJSON();

		var modelJSONClone = _jquery2.default.extend(true, {}, modelJSON);
		delete modelJSONClone.containerPageId;

		var dataItem = this.addDataItem(modelJSONClone, params);

		var updateDone = dataItem && this.updateSlot(modelJSONClone, params, dataItem.id);

		if (updateDone) {
			modelJSONClone.localFilters = selectionFilter;
			return modelJSONClone;
		} else {
			return null;
		}
	};

	/* 
 * If the vis type is Table/xtab, remove the heat slot and data items associated 
 * with heat as we don't carry over the new CF properties in R7 for showBy/compareBy
 */


	ShowByAction.prototype.removeHeatSlotForXtabTable = function removeHeatSlotForXtabTable(widgetSpec) {
		var newConditionalFormattingEnabled = !this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'xtabcondFormat', 'disabled');
		if (newConditionalFormattingEnabled) {
			var visType = this.content.getFeature('Visualization').getType();
			if (['Crosstab', 'List'].indexOf(visType) > -1) {
				var slots = widgetSpec.slotmapping.slots;
				var dataView = widgetSpec.data.dataViews[0];
				var heatIndex = null;
				var dataItemsInHeat = void 0;
				for (var i = 0; i < slots.length; ++i) {
					if (slots[i].name === 'heat') {
						heatIndex = i;
						dataItemsInHeat = slots[i].dataItems;
						break;
					}
				}
				if (heatIndex !== null) {
					slots.splice(heatIndex, 1);
					var dataItems = dataView.dataItems;
					var preservedDataItems = [];
					for (var _i2 = 0; _i2 < dataItems.length; ++_i2) {
						if (dataItemsInHeat.indexOf(dataItems[_i2].id) === -1) {
							// keep data items that are not in heat slot
							preservedDataItems.push(dataItems[_i2]);
						}
					}
					if (preservedDataItems.length) {
						dataView.dataItems = preservedDataItems;
					}
				}
			}
		}
		return widgetSpec;
	};

	ShowByAction.prototype._removeBrushedItems = function _removeBrushedItems(widgetModel, dataItemIdsToReplace) {
		var dataViews = widgetModel.data.dataViews;
		for (var i = 0; i < dataViews.length; i++) {
			this._removeBrushedDataItemFromDataViews(dataViews[i], dataItemIdsToReplace);
		}
	};

	ShowByAction.prototype._removeBrushedDataItemFromDataViews = function _removeBrushedDataItemFromDataViews(dataView, dataItemIdsToReplace) {
		var updatedDataItems = [];
		var dataItems = dataView.dataItems;
		for (var i = 0; i < dataItems.length; i++) {
			if (dataItemIdsToReplace.indexOf(dataItems[i].id) === -1) {
				updatedDataItems.push(dataItems[i]);
			}
		}

		if (updatedDataItems.length > 0) {
			dataView.dataItems = updatedDataItems;
		}
	};

	/* Remove old unwanted attributes from the spec so as to allow the auto-generation
 of new and accurate attributes for the widget i.e. Title or id */


	ShowByAction.prototype.removeUnwantedAttributesFromSpec = function removeUnwantedAttributesFromSpec(widgetSpec) {
		var unwantedAttrs = ['id', 'name', 'titleHtml', 'thumbnailId'];
		_underscore2.default.each(unwantedAttrs, function (attr) {
			delete widgetSpec[attr];
		});
		return widgetSpec;
	};

	ShowByAction.prototype._addExtraWidgetOptions = function _addExtraWidgetOptions(widgetSpec) {
		var extraWidgetOptions = {
			properties: [{
				id: 'itemAxis.labels.layoutMode',
				value: 'stagger'
			}, {
				id: 'widget.legend.position',
				value: 'right'
			}]
		};
		Object.assign(widgetSpec, extraWidgetOptions);
		return widgetSpec;
	};

	return ShowByAction;
}();

exports.default = ShowByAction;

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ShowByDialog = __webpack_require__(500);

var _ShowByDialog2 = _interopRequireDefault(_ShowByDialog);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = __webpack_require__(503);

/**
* The actual dialog controller which handles selection and changes from the react components.
*/
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var ShowByView = View.extend({
	/**
  * Initialize a new dialog
  * @param options - an object of the following form
  *		{
  *			eventHandler - action handler when user selects a column in the showByDialog
 *			contextColumns - all category columns in the data set
 *			getRecommendedColumns - callback to get possible key drivers of category type of projected items in the widget
 *		}
 */
	init: function init(options) {
		ShowByView.inherited('init', this, arguments);
		this.dialogOptions = {
			eventHandler: options.eventHandler,
			contextColumns: options.contextColumns,
			shapingHelper: options.shapingHelper,
			getRecommendedColumns: options.getRecommendedColumns
		};
		this.selectionHandler = this.selectionHandler.bind(this);
	},

	render: function render() {
		var _this = this;

		return this._renderReactComponents(this.dialogOptions).then(function () {
			return _this;
		});
	},

	_renderReactComponents: function _renderReactComponents(options) {
		var _this2 = this;

		this.$el.addClass('popoverDialogContainer');
		return options.getRecommendedColumns().then(function (recommendedColumns) {
			options.recommendedColumns = recommendedColumns;
			// Render the react components
			_reactDom2.default.render(_react2.default.createElement(_ShowByDialog2.default, {
				contextColumns: options.contextColumns,
				eventHandler: _this2.selectionHandler,
				recommendedColumns: options.recommendedColumns,
				shapingHelper: options.shapingHelper
			}), _this2.$el[0]);
		});
	},

	selectionHandler: function selectionHandler(value) {
		if (this.dialogOptions.eventHandler) {
			this.remove();
			this.dialogOptions.eventHandler({
				context: {
					id: value.id,
					label: value.label
				}
			});
		}
	},


	/**
 * Remove the dialog and toolbar.
 */
	remove: function remove() {
		_reactDom2.default.unmountComponentAtNode(this.$el[0]);
		// If there is a toolbar and a flyout, close it.
		if (this.toolbar && this.toolbar.flyout) {
			this.toolbar.flyout.close();
		}
		ShowByView.inherited('remove', this);
	},

	/**
 * @param  {Object} toolbar that the dialog is being rendered from.
 */
	renderCallBack: function renderCallBack(toolbar) {
		this.toolbar = toolbar;
		return Promise.resolve();
	},

	/**
 * Needed so toolbar is set in NextView and the flyout can be closed when remove the dialog
 */
	preload: function preload() {
		return Promise.resolve();
	}
});

exports.default = ShowByView;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps; /*
                                      *+------------------------------------------------------------------------+
                                      *| Licensed Materials - Property of IBM
                                      *| IBM Cognos Products: Dashboard
                                      *| (C) Copyright IBM Corp. 2019, 2020
                                      *|
                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                      *+------------------------------------------------------------------------+
                                      */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(2);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(1);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(501);

var _baUiCarbonToolkit = __webpack_require__(4);

var _shaping = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moser = __webpack_require__(55);
var moserjs = moser.default;

var ShowByDialog = (_temp = _class = function (_Component) {
	_inherits(ShowByDialog, _Component);

	function ShowByDialog(props) {
		_classCallCheck(this, ShowByDialog);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initialiseProps.call(_this);

		_this.state = {
			searchResult: '',
			searchString: '',
			mounted: false,
			isSearchFocused: !props.recommendedColumns.length
		};
		_this.contextColumns = props.contextColumns;
		_this.contextColumnsMoser = _this.contextColumns.map(function (col) {
			return col.moserObject;
		});
		_this.selectionHandler = props.eventHandler;
		_this.recommendedColumns = props.recommendedColumns;
		_this.recommendedColumnsMoser = _this.recommendedColumns.map(function (col) {
			return col.moserObject;
		});
		_this.searchPlaceHolder = _StringResources2.default.get('searchAll');
		_this.recommendedColumnsLabel = _StringResources2.default.get('recommendedColumns');
		_this.allColumnsLabel = _StringResources2.default.get('allColumns');
		_this.searchRef = null;
		return _this;
	}

	ShowByDialog.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		// MUI has an issue with the container height and its virtualized list
		// they need our component to render first so they can calculate the height needed for the tree
		setTimeout(function () {
			return _this2.setState({ mounted: true });
		}, 0);
		this.moserTreeMapRecommended = new Map();
		this.moserTreeMapSearch = new Map();
	};

	ShowByDialog.prototype.componentWillUnmount = function componentWillUnmount() {
		this.moserTreeMapRecommended = null;
		this.moserTreeMapSearch = null;
	};

	ShowByDialog.prototype.render = function render() {
		var _this3 = this;

		if (this.props.shapingHelper) {
			return _react2.default.createElement(
				'div',
				{ className: 'showByDialogAmb ba-theme-waca' },
				_react2.default.createElement(_baUiCarbonToolkit.SearchInput, {
					className: 'searchBar',
					value: this.state.searchString,
					placeholder: this.searchPlaceHolder,
					onChange: this._onInputChange,
					fullWidth: 'true',
					onFocus: this._onFocus,
					onBlur: this._onBlur,
					ref: function ref(r) {
						return _this3.searchRef = r;
					}
				}),
				this._getTreeListComponent()
			);
		}

		return _react2.default.createElement(
			'div',
			{ className: 'showByDialog ba-theme-waca' },
			_react2.default.createElement(_baUiCarbonToolkit.AutoCompleteInput, {
				values: this.contextColumns,
				value: this.state.searchString,
				placeholder: this.searchPlaceHolder,
				onChange: this._onInputChange,
				onSelectionChange: this._onSelectionChange,
				onValueMatch: this._onValueMatch,
				fullWidth: 'true'
			}),
			this._getListComponent()
		);
	};

	/**
 * Display the recommended columns list only when no search result
 */


	// Returns true when the object should be shown in the tree, false otherwise


	// Returns true when the object should be shown in the tree, false otherwise


	return ShowByDialog;
}(_react.Component), _initialiseProps = function _initialiseProps() {
	var _this4 = this;

	this._onFocus = function () {
		_this4.setState({ isSearchFocused: true });
	};

	this._onBlur = function () {
		_this4.setState({ isSearchFocused: false });
	};

	this._onInputChange = function (value) {
		if (!value) {
			// The icon 'x' is clicked to clear search input, make sure search result is also cleared out
			_this4.setState({ searchResult: '' });
		}
		_this4.setState({ searchString: value });
	};

	this._onValueMatch = function (values) {
		_this4.setState({ searchResult: values });
	};

	this._onSelectionChange = function (selection) {
		_this4.selectionHandler({
			id: selection.value,
			label: selection.label
		});
	};

	this._getListComponent = function () {
		if (_this4.recommendedColumns && _this4.recommendedColumns.length && !_this4.state.searchResult && !_this4.state.searchString) {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: 'columnsListLabel' },
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _this4.recommendedColumnsLabel })
				),
				_react2.default.createElement(
					'div',
					{ className: 'columnsListContainer' },
					_react2.default.createElement(_baUiCarbonToolkit.List, {
						length: _this4.recommendedColumns.length,
						itemRenderer: _this4._itemRenderer,
						selectionMode: 'single',
						onSelectionChange: _this4._onListSelection,
						tabIndex: 0
					})
				)
			);
		} else {
			return null;
		}
	};

	this._getTreeListComponent = function () {
		var shapingHelper = _this4.props.shapingHelper;


		var props = {};
		if (!_this4.state.isSearchFocused && _this4.state.searchString === '') {
			props = {
				moserObjectFilter: _this4.recommendedPredicate
			};
		} else if (_this4.searchRef) {
			_this4.searchRef.focus();

			props = {
				moserObjectFilter: _this4.searchPredicate
			};
		}

		var tree = null;
		if (_this4.state.mounted) {
			tree = _react2.default.createElement(_shaping.ShapingPickTree, _extends({
				filter: _this4.state.searchString,
				onSelect: _this4._onSelect
			}, props));
		}

		return _react2.default.createElement(
			shapingHelper.ShapingProvider,
			null,
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: 'columnsListLabel' },
					_react2.default.createElement(_baUiCarbonToolkit.Label, { label: _this4.state.isSearchFocused || _this4.state.searchString !== '' ? _this4.allColumnsLabel : _this4.recommendedColumnsLabel })
				),
				_react2.default.createElement(
					'div',
					{ className: 'columnsTreeContainer' },
					tree
				)
			)
		);
	};

	this.searchPredicate = function (moserObject) {
		if (moserObject.getObjectType() === moserjs.MoserObjectTypes.QUERY_ITEM) {
			return _this4.contextColumnsMoser.indexOf(moserObject) >= 0;
		}

		if (_this4.moserTreeMapSearch.has(moserObject)) {
			return _this4.moserTreeMapSearch.get(moserObject);
		}

		var hasSearchMembers = moserjs.ModuleUtils.getTreeChildren(moserObject).some(function (child) {
			return _this4.searchPredicate(child);
		});

		_this4.moserTreeMapSearch.set(moserObject, hasSearchMembers);

		return hasSearchMembers;
	};

	this.recommendedPredicate = function (moserObject) {
		if (moserObject.getObjectType() === moserjs.MoserObjectTypes.QUERY_ITEM) {
			return _this4.recommendedColumnsMoser.indexOf(moserObject) >= 0;
		}

		if (_this4.moserTreeMapRecommended.has(moserObject)) {
			return _this4.moserTreeMapRecommended.get(moserObject);
		}

		var hasRecommendedMembers = moserjs.ModuleUtils.getTreeChildren(moserObject).some(function (child) {
			return _this4.recommendedPredicate(child);
		});

		_this4.moserTreeMapRecommended.set(moserObject, hasRecommendedMembers);

		return hasRecommendedMembers;
	};

	this._onSelect = function (selected) {
		if (selected.getObjectType() === moserjs.MoserObjectTypes.QUERY_ITEM) {
			_this4.selectionHandler({
				id: selected.idForExpression,
				label: selected.label
			});
		}
	};

	this._onListSelection = function (event) {
		var selection = _this4.recommendedColumns[event.index];
		_this4.selectionHandler(selection);
	};

	this._itemRenderer = function (index) {
		var item = _this4.recommendedColumns[index];
		return _react2.default.createElement(
			_baUiCarbonToolkit.ListItem,
			{ 'data-index': index, selectable: 'true' },
			_react2.default.createElement(
				_baUiCarbonToolkit.FlexItem,
				{ grow: true },
				_react2.default.createElement(_baUiCarbonToolkit.TruncatedText, { value: item.label })
			)
		);
	};
}, _temp);


ShowByDialog.propTypes = {
	contextColumns: _PropTypes2.default.array,
	eventHandler: _PropTypes2.default.func,
	recommendedColumns: _PropTypes2.default.array,
	shapingHelper: _PropTypes2.default.object
};

exports.default = ShowByDialog;

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/index.js??ref--1-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--1-4!./showByDialog.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--1-1!../../../../node_modules/postcss-loader/index.js??ref--1-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--1-4!./showByDialog.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.showByDialog {\n  color: #777677;\n  width: 260px;\n}\n\n.showByDialog .columnsListLabel {\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.showByDialog .columnsListContainer {\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-bottom: 16px;\n  border-width: 1px;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  border-style: solid;\n  overflow-y: auto;\n  max-height: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  text-overflow: ellipsis;\n}\n\n.showByDialogAmb {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  width: 350px;\n  height: 388px;\n}\n\n.showByDialogAmb .searchBar {\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-top: 8px;\n}\n\n.showByDialogAmb .columnsListLabel {\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.showByDialogAmb .columnsTreeContainer {\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-bottom: 16px;\n  border-width: 1px;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  border-style: solid;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  text-overflow: ellipsis;\n  height: 282px;\n}\n\n.showByDialogAmb .bi-common-panelMessage {\n  top: 0px !important;\n  overflow: hidden !important;\n  height: 440px;\n}\n\n.showByDialogAmb .bi-common-panelMessage__inner {\n  padding-top: 130px;\n}\n\n", ""]);

// exports


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_503__;

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_55__;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * The BaseSummaryValueQuery contains the commone elements for a single query that updates summaryCollector entries
 * with the single row result of the aggregated summary values with filtering applied
 * for all measures (ordinals) that are projected.
 * NOTE: the execute method contains Logic to process exception conditions
 *		to avoid querying and/or update summaries immediately if possible.
 **/
var BaseSummarizerQuery = function () {

	/**
  * @Constructor
  * @param {Object} widgetApi - the owner widget (needed to access services)
  * @param {Object} dashboardApi - the dashboardApi
  * @param {Object} logger - The logger
  * @param {Function} [cbGetRowTuples=null] - when this callback is supplied, the rendered data rows are used
  *				where the filter values are "implied" (eg TopN).  This is only needed for summary stats (not selection stats)
  */
	function BaseSummarizerQuery(widgetApi, dashboardApi, logger) {
		var cbGetRowTuples = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		_classCallCheck(this, BaseSummarizerQuery);

		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;

		this.logger = logger;
		this.cbGetRowTuples = cbGetRowTuples;

		//By default, we should include the filter context.
		this.includeFilters = true;
	}

	BaseSummarizerQuery.prototype.destroy = function destroy() {
		this.deactivate();
	};

	BaseSummarizerQuery.prototype.activate = function activate() {
		//If the widget shaping changed, we need to refresh summaries.
		this.widgetApi.on('shapingmodel:changed', this.onWidgetShapingChanged, this);
	};

	BaseSummarizerQuery.prototype.deactivate = function deactivate() {
		//If the widget shaping changed, we need to refresh summaries.
		this.widgetApi.off('shapingmodel:changed', this.onWidgetShapingChanged, this);
	};

	BaseSummarizerQuery.prototype.onWidgetShapingChanged = function onWidgetShapingChanged() {
		//Perform any actions necessary if notified that the widget shaping changed.
		//For example, if the widget shaping changed, we need to refresh summaries.
		//By default, this method does nothing.
	};

	BaseSummarizerQuery.prototype.addQueryItem = function addQueryItem() {};

	/**
  * execute a query (or return known/cached results) for the Summary values of each fact (measure).
  * NOTE: This function often doesn't actually execute a query if Summaries don't change or
  *  values can be returned for specialconditions processed in "addQueryItem".
  * @param {Object} summaryCollector - a summaryCollector object (or selectionSummaryCollector) whose entries are to be updated with the results.
  * @param {Object} queryDef (optional) - a queryDefinition to build onto (for combined summaries)
  * @param {Boolean} [isSelectionStats=false] - when true, stats collected are for selections.
  */


	BaseSummarizerQuery.prototype.build = function build(summaryCollector) {
		var _this = this;

		var queryDef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { dataItems: [], projections: [] };
		var isSelectionStats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var visualizationAPI = this.widgetApi.getVisualization();
		var savedPromptsAPI = visualizationAPI.getSavedPrompts();
		if (savedPromptsAPI && savedPromptsAPI.getPromptSpecList()) {
			queryDef.parameterValues = savedPromptsAPI.getPromptSpecList();
		}
		isSelectionStats = isSelectionStats || !!summaryCollector.isSelectionSummaryCollector;
		//Extract all projected ordinal data items with aggregate set to produce a single row query result.
		var slotsAPI = visualizationAPI.getSlots();
		if (slotsAPI) {
			slotsAPI.getDataItemList().forEach(function (mappedDataItem) {
				_this.addQueryItem(queryDef, mappedDataItem, summaryCollector);
			});
		}

		if (queryDef.dataItems.length === 0 || queryDef.projections.length === 0) {
			//If nothing was included in the query for whatever reason, return null.
			return null;
		}

		if (this.includeFilters) {
			var addFiltersResult = this.addFilters(content, isSelectionStats);
			if (!addFiltersResult.canBuildFilterSpec) {
				queryDef.dataItems = []; //Reset the items to an empty list and return null to indicate the query can't be done.
				return null;
			}
			queryDef.filters = addFiltersResult.filters;
		}
		return queryDef;
	};

	BaseSummarizerQuery.prototype.execute = function execute(summaryCollector) {
		var queryDef = this.build(summaryCollector);
		if (!queryDef) {
			return Promise.resolve(true);
		}

		//Query for any overall summaries that are not already cached
		return this._execute(summaryCollector, queryDef);
	};

	BaseSummarizerQuery.prototype._execute = function _execute(summaryCollector, queryDef) {
		var _this2 = this;

		return this._getColumnValues(queryDef).then(function (queryResultData) {
			queryResultData.getResultItemList().forEach(function (resultDataItem, colIdx) {
				var dataItemUniqueId = queryDef.projections[colIdx];
				var tupleHeader = resultDataItem.getDataItemList();
				var cellValue = queryResultData.getValue(0, colIdx);
				if (cellValue) {
					var finalValue = cellValue.getValue && cellValue.getValue() || cellValue.v;
					_this2.processValue(dataItemUniqueId, tupleHeader[0].aggregate, finalValue, summaryCollector);
				}
			});
			return true;
		}).catch(function (error) {
			_this2._logError(error);
			//don't throw here!  If the query fails, processValue isn't called (empty response)
			//but it shouldn't fail the visualization query.
		});
	};

	/**
  * Update the summary entry with the summary value under the fieldNames specified.
  * @param {Object} summaryCollector - the summaryCollector to be updated
  * @param {String} dataItemUniqueId - The id of the dataItem to update the summary entry for.
  * @param {String} overallSummaryValue - the single row value to update the entry with
  * @param {String} fieldNameUse - the field name to update with the unformatted value.
  * @param {String} fieldName - the field name to update with the formatted value.
  */


	BaseSummarizerQuery.prototype.updateSummaryEntry = function updateSummaryEntry(summaryCollector, dataItemUniqueId, overallSummaryValue, fieldNameUse, fieldName) {
		var summaryEntry = summaryCollector.getSummary(dataItemUniqueId);
		if (summaryEntry) {
			if (summaryCollector.isSelectionSummaryCollector && !summaryEntry.valueMap) {
				summaryCollector.removeSummary(dataItemUniqueId);
				summaryEntry = null;
			} else {
				//before update the summary, call updateSummaryEntry to replace the current
				//summaryEntry with the copy of itself, see SummaryCollector.updateSummaryEntry for details
				summaryEntry = summaryCollector.updateSummaryEntry(summaryEntry);
				summaryEntry[fieldNameUse] = overallSummaryValue;

				var unformattedSummaryValue = overallSummaryValue === 0 ? '0' : (overallSummaryValue || '').toString();
				var formatSpec = summaryEntry.metadata && summaryEntry.metadata.format;
				var Formatter = this._getFormatter();
				summaryEntry[fieldName] = Formatter && formatSpec ? Formatter.format(summaryEntry[fieldNameUse], formatSpec) : unformattedSummaryValue;
			}
		}
		return summaryEntry;
	};

	/**
  * add Filters to the query.
  * @param {boolean} isSelectionStats - true if filters are being added for visible selections
  * @returns An object with a status (canBuildFilterSpec) and, if true, the FilterJSON suitable for sending to the query api.
  */


	BaseSummarizerQuery.prototype.addFilters = function addFilters(content, isSelectionStats) {
		var _this3 = this;

		var filters = [];

		//NOTE: The pinningAPI has a flag to exclude visible selections so we want to INCLUDE them only when asking for selectionSummaries.
		var dataPointSelections = content.getFeature('DataPointSelections.deprecated');
		var selections = dataPointSelections.getSelections();
		var portableFilters = this._getFilterInfo(content);
		var useRowTuplesAsFilters = this._useRowTuplesAsFilters(portableFilters);

		if (selections.length > 0) {
			filters.push(this._buildDataPointFilterFromSelections(selections));
		}

		if (useRowTuplesAsFilters && this.cbGetRowTuples) {
			var rowTuples = this.cbGetRowTuples(isSelectionStats);
			if (!rowTuples || !rowTuples.tuples || rowTuples.tuples.length === 0) {
				//Can't build a filter spec if we need tuples and the returned tuples are empty.
				return { canBuildFilterSpec: false };
			}
			if (rowTuples.itemIds.length === 1) {
				var tuples = rowTuples.tuples.map(function (tuple) {
					return tuple[0];
				});
				filters.push({ columnId: rowTuples.itemIds[0], operator: 'in', values: tuples });
			} else {
				filters.push(this._buildDataPointFilter(rowTuples));
			}
		}

		portableFilters && portableFilters.forEach && portableFilters.forEach(function (filterEntry) {
			//post-aggregate range filters are covered by rendered tuples.  Don't include them as filters.
			if (!_this3._isPostAggregateRangeFilter(filterEntry)) {
				filters.push(filterEntry);
			}
		});
		return { canBuildFilterSpec: true, filters: filters };
	};

	BaseSummarizerQuery.prototype._buildDataPointFilterFromSelections = function _buildDataPointFilterFromSelections(selections) {
		var orFilter = {
			operator: 'or',
			values: []
		};

		selections.forEach(function (selection) {
			var andFilter = { operator: 'and', values: [] };
			selection.categories.forEach(function (tuplePart) {
				//TODO: guard against post-aggregate filters.
				andFilter.values.push({ columnId: tuplePart.columnId, operator: 'in', values: [{ d: tuplePart.label, label: tuplePart.label }] });
			});
			orFilter.values.push(andFilter);
		});
		return orFilter;
	};

	BaseSummarizerQuery.prototype._buildDataPointFilter = function _buildDataPointFilter(rowTuples) {
		var itemIds = rowTuples.itemIds;
		var orFilter = {
			operator: 'or',
			values: []
		};

		rowTuples.tuples.forEach(function (rowTuple) {
			var andFilter = { operator: 'and', values: [] };
			rowTuple.forEach(function (tuplePart, indexInSlot) {
				//TODO: guard against post-aggregate filters.
				andFilter.values.push({ columnId: itemIds[indexInSlot], operator: 'in', values: [tuplePart] });
			});
			orFilter.values.push(andFilter);
		});
		return orFilter;
	};

	BaseSummarizerQuery.prototype._isPostAggregateRangeFilter = function _isPostAggregateRangeFilter(filterEntry) {
		return filterEntry.preOrPost === 'post' && filterEntry.operator && this._isRangeFilter(filterEntry.operator);
	};

	BaseSummarizerQuery.prototype._isRangeFilter = function _isRangeFilter(operator) {
		var rangeOps = ['between', 'notbetween', 'lt', 'gt'];
		return rangeOps.indexOf(operator) > -1;
	};

	//return true if this widget requires the rendered tuples to determine filter values.
	//This can happen in cases where the filter values are implied (ie: TopN/BottomN or post aggregate range filers)


	BaseSummarizerQuery.prototype._useRowTuplesAsFilters = function _useRowTuplesAsFilters(portableFilters) {
		return this._hasTopBottom() || this._hasPostAggregateRangeFilters(portableFilters);
	};

	//return true if this widget includes topBottom (and we need to use the rendered row tuples as filters.)


	BaseSummarizerQuery.prototype._hasTopBottom = function _hasTopBottom() {
		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var visualization = content.getFeature('Visualization');
		return !!visualization.getSlots().getDataItemList().find(function (dataItem) {
			return dataItem.getTopBottom();
		});
	};

	//return true if this widget includes post aggregate range filters (and we need to use the rendered row tuples as filters.)


	BaseSummarizerQuery.prototype._hasPostAggregateRangeFilters = function _hasPostAggregateRangeFilters(portableFilters) {
		var _this4 = this;

		//post-aggregate range filters also reduce the set based on aggregated group values.
		var hasPostAggregateRangeFilter = portableFilters && portableFilters.some(function (filterEntry) {
			return _this4._isPostAggregateRangeFilter(filterEntry);
		});
		return !!hasPostAggregateRangeFilter;
	};

	BaseSummarizerQuery.prototype._getFormatter = function _getFormatter() {
		return this.widgetApi.getVisApi().getFormatter();
	};

	BaseSummarizerQuery.prototype._getFilterInfo = function _getFilterInfo(content) {
		var globalFilters = this.dashboardApi.getFeature('GlobalFilters');
		var eventGroups = this.dashboardApi.getFeature('EventGroups');
		var visualization = content.getFeature('Visualization');
		var datasource = visualization.getDataSource();
		var localFilters = visualization.getLocalFilters();
		var type = this.dashboardApi.getAppConfig('pageContainerType');
		var combinedFilterList = [];
		combinedFilterList.push.apply(combinedFilterList, localFilters.getFilterList());
		combinedFilterList.push.apply(combinedFilterList, globalFilters.getFilterList({
			origin: 'filter',
			sourceId: datasource.getId(),
			scope: this._getPageContent(content, type).getId(),
			eventGroupId: eventGroups.getGroupId(content.getId())
		}));
		return combinedFilterList;
	};

	BaseSummarizerQuery.prototype._getColumnValues = function _getColumnValues(queryDef) {
		var content = this.dashboardApi.getCanvas().getContent(this.widgetApi.getId());
		var visualization = content.getFeature('Visualization');
		var queryService = this.dashboardApi.getFeature('QueryService');
		var dataSource = visualization.getDataSource();
		var aggregations = queryDef.dataItems.map(function (dataItem) {
			return dataItem.aggregate;
		});
		var columnIds = queryDef.dataItems.map(function (dataItem) {
			return dataItem.itemId;
		});
		return queryService.getColumnValues(dataSource.getId(), columnIds, queryDef.filters, undefined, [], aggregations);
	};

	/**
  * TODO: This method is from dashboard-common/ContentUtil.js we should find a better way managing dependencies across micro components
  * Recursively walk the content and it's parent to find the page content.
  * @param {ContentAPI} content
  * @param {String} [type='page'] the content type.
  * @returns {ContentAPI} page content. If the type can not be found, returns null
  */


	BaseSummarizerQuery.prototype._getPageContent = function _getPageContent(content) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'page';

		var pageContent = null;
		while (content) {
			if (type && content.getType && content.getType() === type) {
				pageContent = content;
			}
			content = content.getContainer && content.getContainer();
		}
		return pageContent;
	};

	BaseSummarizerQuery.prototype._logError = function _logError() {
		this.logger.error('An error occured while requesting measure summaries for statistics', arguments, this.widgetApi.getVisApi());
	};

	return BaseSummarizerQuery;
}();

exports.default = BaseSummarizerQuery;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ })

},[466]);
});


// WEBPACK FOOTER //
// dashboard-extensions.min.js